export default {
  // ── Zoo / Livestock (chiavi legacy — backward compat) ────────────────────────
  sheep: "Ovini",
  cattle: "Bovini",
  goat: "Caprini",
  pig: "Suini",
  horse: "Equini",
  animal: "Animale",
  animals: "Animali",
  group: "Gruppo",
  groups: "Gruppi",
  herd: "Allevamento",
  herds: "Allevamenti",
  event: "Evento",
  events: "Eventi",
  livestock_management: "Gestione Allevamento",
  adult: "Adulto",
  adults: "Adulti",
  baby: "Giovane",
  babies: "Giovani",
  adult_females: "Femmine Adulte",
  adult_males: "Maschi Adulti",
  baby_females: "Femmine Giovani",
  baby_males: "Maschi Giovani",
  sex: "Sesso",
  male: "Maschio",
  female: "Femmina",
  sex_m: "M",
  sex_f: "F",
  type_in: "Tipo Ingresso",
  type_out: "Tipo Uscita",
  type_in_N: "Nato in azienda",
  type_in_A: "Acquistato",
  type_in_R: "Ricevuto in regalo",
  type_in_T: "Trasferito",
  type_out_M: "Morto",
  type_out_V: "Venduto",
  type_out_R: "Ceduto",
  type_out_T: "Trasferito",
  type_out_S: "Smarrito",
  event_delivery: "Parto",
  event_eco: "Ecografia",
  event_treatment: "Trattamento",
  event_vaccination: "Vaccinazione",
  event_weight: "Pesatura",
  event_medication: "Medicinale",
  event_other: "Altro",
  code: "Codice",
  code_bdn: "Codice BDN",
  name: "Nome",
  date_birth: "Data di nascita",
  date_in: "Data ingresso",
  date_out: "Data uscita",
  mother: "Madre",
  father: "Padre",
  breed: "Razza",
  color: "Colore",
  note: "Note",
  eid: "EID (chip)",
  active: "Attivo",
  inactive: "Non attivo",
  removed: "Rimosso",
  no_group: "Nessun gruppo",
  add: "Aggiungi",
  edit: "Modifica",
  remove: "Rimuovi",
  save: "Salva",
  cancel: "Annulla",
  confirm: "Conferma",
  delete: "Elimina",
  restore: "Ripristina",
  back: "Indietro",
  search: "Cerca",
  filter: "Filtra",
  all: "Tutti",
  new: "Nuovo",
  view: "Visualizza",
  select: "Seleziona",
  loading: "Caricamento...",
  no_data: "Nessun dato disponibile",
  no_animals: "Nessun animale trovato",
  no_groups: "Nessun gruppo trovato",
  no_events: "Nessun evento registrato",
  no_members: "Nessun animale in questo gruppo",
  error_loading: "Errore nel caricamento dei dati",
  save_ok: "Salvato con successo",
  save_error: "Errore nel salvataggio",
  delete_ok: "Eliminato con successo",
  confirm_remove: "Confermare la rimozione?",
  total: "Totale",
  members: "Animali",
  age: "Età",
  years: "anni",
  months: "mesi",
  zoo_home: "Allevamento",
  animal_list: "Anagrafica",
  group_list: "Gruppi",
  animal_detail: "Dettaglio Animale",
  group_detail: "Dettaglio Gruppo",
  add_animal: "Nuovo Animale",
  add_group: "Nuovo Gruppo",
  add_event: "Aggiungi Evento",
  add_to_group: "Aggiungi al Gruppo",
  move_date: "Data Movimento",
  warning_species:
    "Attenzione: questa funzione è ottimizzata principalmente per gli ovini.",

  // ── Navigazione principale ───────────────────────────────────────────────────
  nav: {
    home: "Home",
    farms: "Aziende",
    activityFeed: "Feed Attività",
    messages: "Messaggi",
    notifications: "Notifiche",
    profile: "Profilo",
    organization: "Organizzazione",
    manageOrg: "Gestione Org",
    manageAllOrgs: "Gestione Org (tutte)",
    manageSchemas: "Gestione Schede",
    accessions: "Accessioni",
    accessionsElab: "Elaborazione Dati",
    aiTagging: "AI Tagging",
    sendNotifications: "Invia Notifiche",
    chatAdmin: "Chat Admin",
    virtualFarms: "Aziende Virtuali",
    users: "Utenti",
    admin: "Admin",
    settings: "Impostazioni",
    talkToPoderi: "Parla con Poderi",
    documents: "Documenti",
    adminOrgs: "Organizzazioni",
    adminVarieties: "Varietà",
    adminChat: "Chat",
    adminPlantHealth: "Fitosanitari",
    adminBdf: "Banca Dati Fitofarmaci",
    adminWeather: "Stazioni meteo",
    adminSpatialModel: "Modello spaziale",
    adminSystemStatus: "Stato sistema",
    credits: "Credits",
    contact: "Contatti",
  },

  // ── Sidebar azienda ──────────────────────────────────────────────────────────
  farm: {
    farmHome: "Home Azienda",
    fieldsAndCrops: "Campi e Colture",
    cropRotation: "Rotazione Colturale",
    operations: "Operazioni",
    weatherDss: "Meteo e DSS",
    soils: "Suoli",
    warehouse: "Magazzino",
    marketing: "Marketing",
    team: "Team",
    livestock: "Allevamento",
    plantrec: "Plantrec",
    openData: "Open Data",
    monitoring: "Monitoraggio",
    defaultName: "Azienda",
  },

  // ── Lista aziende (FarmCenterList) ───────────────────────────────────────────
  farmList: {
    loading: "Caricamento in corso...",
    error: "Errore",
    retry: "Riprova",
    welcome: "Benvenuto",
    noFarms: "Non sono presenti aziende agricole registrate.",
    createFirst: "Crea la tua prima azienda per iniziare.",
    createFirstBtn: "Crea la tua prima azienda",
    newFarm: "Nuova Azienda",
    mapPanel: "Mappa",
    listPanel: "Lista",
    searchPlaceholder: "Cerca azienda...",
    sortBy: "Ordina:",
    sortName: "A-Z",
    sortArea: "Superficie",
    sortSync: "Aggiornamento",
    noAddress: "Indirizzo non specificato",
    plots: "Appezzamenti",
    hectares: "ha",
    seasons: "Stagioni",
    farmsCount: "{count} aziende agricole registrate",
    title: "Aziende",
  },

  // ── Fenologia — fasi BBCH (chiavi = nomi EN restituiti dall'API) ─────────────
  "winter dormancy": "Gemme invernali",
  "start bud break": "Gemme gonfie",
  "leaf development": "Sviluppo fogliare",
  "shoot development": "Accrescimento germoglio",
  "inflorescence buds are closed": "Comparsa grappoli fiorali",
  "inflorescence buds start to swell": "Rigonfiamento bottoni fiorali",
  "corolla differentiation": "Differenziazione corolla",
  "beginning of flowering": "Inizio fioritura",
  "full flowering": "Fioritura 50%",
  "fruit set": "Allegagione",
  "fruit growth after fruit set": "Accrescimento frutto post allegagione",
  "stone hardening 0-50%": "Indurimento nocciolo (0-50%)",
  "stone hardening > 50%": "Indurimento nocciolo (>50%)",
  "stone hardening 100%": "Nocciolo indurito",
  "fruit growth green olives": "Accrescimento frutto olive verdi",
  "fruit growth yellow-green olives": "Accrescimento frutto olive giallo-verdi",
  "veraison 5%": "Inizio invaiatura 5%",
  "veraison 50%": "Invaiatura 50%",
  "veraison 100%": "Invaiatura 100%",
  "vegetative rest": "Riposo vegetativo",
  "bud break": "Germogliamento",
  "beginning leaf unfolded": "Prime foglie distese",
  "5 leaves unfolded": "Germogli lunghi 10 cm",
  "inflorescence visible": "Grappoli visibili",
  "inflorescence swelling": "Grappoli distesi",
  "flowers separating": "Bottoni fiorali separati",
  "beginning of flowering (10%)": "Inizio fioritura (10%)",
  "full flowering (50%)": "Piena fioritura (50%)",
  "fruit set (10%)": "Inizio allegagione 10%",
  "fruit set (50%)": "Allegagione 50%",
  "fruit set (100%)": "Allegagione completa",
  "berries groat-sized": "Acino grano di pepe",
  "berries pea-sized": "Acino pisello",
  "berries beginning to touch": "Prechiusura grappolo",
  "berries touching": "Grappolo chiuso",
  "beginning of ripening": "Inizio invaiatura",
  "berries developing colour": "Invaiatura 50%",
  "softening of berries": "Invaiatura completa",
  maturation: "Maturazione",
  "Time for harvest": "Raccolta",

  // ── Irrigazione — fasi modello irriguo (chiavi = nomi EN modello) ────────────
  // Olivo (fasi singole legacy)
  flowering: "Fioritura",
  "fruit-set": "Allegagione",
  "hard-pit": "Indurimento nocciolo",
  harvest: "Raccolta",
  // Olivo (fasi range - nuove)
  "vegetative rest - bud break": "Riposo vegetativo - Germogliamento",
  "bud break - flowering": "Germogliamento - Fioritura",
  "flowering - fruit set": "Fioritura - Allegagione",
  "fruit-set - hard pit": "Allegagione - Indurimento nocciolo",
  "hard pit - veraison": "Indurimento nocciolo - Invaiatura",
  "varaison - harvest": "Invaiatura - Raccolta",
  // Vite (fasi legacy)
  "growing grapes": "Accrescimento acini",
  // Vite (fasi range - nuove)
  "flowering - fruit set (100%)": "Fioritura - Allegagione completa",
  "fruit set (100%) - berries beginning to touch":
    "Allegagione completa - Prechiusura grappolo",
  "berries beginning to touch - varaison": "Prechiusura grappolo - Invaiatura",
  "varaison - end of varaison": "Invaiatura - Fine invaiatura",
  "end varaison - start maturation": "Fine invaiatura - Inizio maturazione",
  // Mais (fasi range - modello irriguo)
  "sowing - emergence": "Semina - Emergenza",
  "emergence - stem elongation": "Emergenza - Allungamento stelo",
  "stem elongation - flowering": "Allungamento stelo - Fioritura",
  "flowering - milk stage": "Fioritura - Maturazione lattea",
  "milk stage - soft dough stage": "Maturazione lattea - Maturazione cerosa",
  "soft dough stage - fully ripe": "Maturazione cerosa - Maturazione piena",

  // ── Profilo ──────────────────────────────────────────────────────────────────
  profile: {
    title: "Profilo Utente",
    language: "Lingua",
    languageDesc: "Seleziona la lingua dell'interfaccia",
    italian: "Italiano",
    english: "English",
  },

  // ── Dettaglio azienda (FarmCenterDetail) ─────────────────────────────────────
  farmDetail: {
    loading: "Caricamento...",
    edit: "Modifica",
    deleteFarm: "Elimina azienda",
    add: "Aggiungi",
    chooseModeTitle: "Come vuoi gestire {name}?",
    chooseModeHint:
      "Scegli il tipo di gestione. Potrai modificarlo in seguito dalle impostazioni.",
    modeFields: "Campi e Colture",
    modeFieldsDesc: "Appezzamenti, stagioni, operazioni colturali",
    modeZoo: "Allevamento",
    modeZooDesc: "Greggi, animali e gruppi",
    modeMixed: "Entrambi",
    modeMixedDesc: "Azienda mista con campi e allevamento",
    noSeasonTitle: "Nessuna stagione configurata",
    noSeasonHint:
      "Per iniziare a lavorare con l'azienda, crea la prima stagione.",
    createSeason: "Crea stagione",
    panelMap: "Mappa",
    panelPlots: "Appezzamenti",
    panelDetails: "Dettagli",
    legendCrops: "Legenda Colture",
    traps: "Trappole",
    herdsCount: "Allevamenti ({count})",
    goToHerd: "Vai all'allevamento",
    zooPromptTitle: "Attività zootecnica",
    zooPromptQuestion: "Hai animali o allevamenti in questa azienda?",
    zooPromptYes: "Sì, gestisci l'allevamento",
    zooPromptNo: "No, non ho animali",
    plotsCount: "Appezzamenti ({count})",
    newPlot: "Nuovo Appezzamento",
    searchPlaceholder: "Cerca per nome o coltura...",
    viewCard: "Vista card",
    viewTable: "Vista tabella",
    createManually: "Crea manualmente",
    createManuallyDesc: "Disegna il tuo appezzamento sulla mappa.",
    importFromFile: "Importa da file",
    importFromFileDesc:
      "Carica un file Shapefile o GeoJSON con i tuoi appezzamenti già georeferenziati.",
    noResultsFor: 'Nessun risultato per "{query}"',
    addCrop: "Aggiungi coltura",
    delete: "Elimina",
    open: "Apri",
    absent: "Assente",
    register: "Registro",
    operations: "Operazioni",
    observations: "Osservazioni",
    warehouse: "Magazzino",
    newGeoElement: "+ Nuovo elemento geografico",
    geoElementsCount: "Elementi Geografici ({count})",
    newGeoElementShort: "+ Nuovo Elemento",
    type: "Tipo:",
    surveys: "Rilievi →",
    farmNotFound: "Azienda non trovata.",
    plotModalTitle: "Appezzamento",
    back: "Indietro",
    next: "Avanti",
    saving: "Salvataggio...",
    saveChanges: "Salva Modifiche",
    createPlot: "Crea Appezzamento",
    geoElementModalTitle: "Elemento Geografico",
    cancel: "Annulla",
    createGeoElement: "Crea Elemento",
    seasonModalTitle: "Stagione",
    deletePlotTitle: "Elimina appezzamento",
    deletePlotConfirm: "Eliminare l'appezzamento {name}?",
    deletePlotCascade:
      "Verrà cancellata anche la coltivazione {season} ({crop}) associata a questo appezzamento.",
    cropFallback: "coltura",
    cannotUndo: "L'operazione non può essere annullata.",
    confirmDeleteTitle: "Conferma eliminazione",
    deleteSeasonConfirm: "Procedere con l'eliminazione della stagione?",
    deleteGeoElementConfirm:
      "Procedere con l'eliminazione dell'elemento geografico?",
    operationModalTitle: "Operazione Colturale",
    observationModalTitle: "Osservazione",
    deleteOperationConfirm: "Procedere con l'eliminazione dell'operazione?",
    deleteObservationConfirm: "Procedere con l'eliminazione dell'osservazione?",
    addCropModalTitle: "Aggiungi coltura",
    plotLabel: "Appezzamento:",
    cropLabel: "Coltura",
    selectCropPlaceholder: "Seleziona coltura...",
    productModalTitle: "Prodotto",
    deleteFarmConfirm: "Procedere con l'eliminazione dell'azienda?",
    deleteProductConfirm: "Procedere con l'eliminazione del prodotto?",
    trapFallbackTitle: "Trappola",
    editTrap: "Modifica Trappola",
    newTrap: "Nuova Trappola",
    save: "Salva",
    deleteTrapTitle: "Elimina trappola",
    deleteTrapConfirm: "Eliminare la trappola {name}?",
    voiceFab: "Parla con Poderi",
    plotTypeField: "Appezzamento coltivabile",
    plotTypeOrchard: "Frutteto",
    notAvailable: "N/D",
    typeFallback: "Tipo {id}",
    importPlotsAction: "Importa Appezzamenti",
    createObservationAction: "Crea Osservazione",
    createOperationAction: "Crea Operazione Colturale",
    errorCreatingSeason: "Errore durante la creazione della stagione: {msg}",
    errorCannotDeletePlot:
      'Impossibile eliminare: l\'appezzamento "{name}" ha {count} coltivazioni. Rimuovile prima.',
    errorCannotDeletePlotDeps:
      "Impossibile eliminare: la coltivazione {season} ha {parts}. Rimuovile prima.",
    andJoiner: " e ",
    operationsCount: "{count} operazioni",
    operationCount: "{count} operazione",
    observationsCount: "{count} osservazioni",
    observationCount: "{count} osservazione",
    errorDeleteGeneric: "Errore durante l'eliminazione",
    errorDeletePlot: "Errore durante l'eliminazione dell'appezzamento",
    errorCreateField: "Errore nella creazione: {msg}",
    errorDeleteGeoElement:
      "Errore durante l'eliminazione dell'elemento geografico",
    errorDeleteProduct: "Errore durante l'eliminazione del prodotto",
    errorDeleteFarm: "Errore durante l'eliminazione dell'azienda",
    errorDeleteSeason: "Errore durante l'eliminazione della stagione",
    errorDeleteOperation: "Errore durante l'eliminazione dell'operazione",
    errorDeleteObservation: "Errore durante l'eliminazione dell'osservazione",
    breadcrumbFallback: "Dettaglio",
  },

  // ── Dettaglio campo (FieldDetail) ─────────────────────────────────────────────
  fieldDetail: {
    loading: "Caricamento...",
    add: "Aggiungi",
    edit: "Modifica",
    delete: "Elimina",
    plants: "Piante",
    soilMissingText:
      "Nessuna analisi del suolo è stata inserita per questo campo. I modelli usano un suolo standard, inserire la propria analisi per avere dei risultati più precisi.",
    addSoilAnalysis: "Aggiungi analisi",
    plotCropMissingText:
      "Questo campo ha una coltura arborea ma l'appezzamento non è ancora stato attivato come coltura permanente: dati come sesto d'impianto e varietà vanno inseriti sull'appezzamento.",
    activatePlotCrop: "Attiva coltura sull'appezzamento",
    activatePlotCropModalText:
      "Seleziona la coltura permanente da attivare sull'appezzamento. È preselezionata la coltura del campo corrente, ma puoi cambiarla.",
    stationMissingText:
      "Non è stata scelta nessuna stazione meteo specifica per azienda. Si usa la stazione meteo più vicina, scegliere la stazione meteo più rappresentativa per migliorare i risultati dei modelli.",
    selectStation: "Seleziona stazione",
    noModelsAvailable: "Nessun modello disponibile per questa coltura.",
    refreshAll: "Aggiorna tutti",
    defense: "Difesa",
    defenseShort: "Pest",
    noPestModels: "Nessun modello difesa disponibile per questa coltura.",
    plotHeader: "Appezzamento",
    plantingTitle: "Impianto",
    plantingOf: "Impianto di {cultivars}",
    plantingYear: "Anno {year}",
    vigourLow: "Bassa",
    vigourMedium: "Media",
    vigourHigh: "Alta",
    vigourSuffix: "vigoria",
    grassCover: "inerbimento",
    noGrassCover: "assenza inerbimento",
    plantingLayout: "Sesto {x} × {y} m — {density} p/ha",
    noPlantingData: "Nessun dato impianto",
    soilTitle: "Suolo",
    soilClaySand: "Argilla {clay}% · Sabbia {sand}%",
    soilPh: "pH {ph}",
    defaultFarm: "Default azienda",
    cropRotation: "Rotazione colturale",
    cultivationOf: "Coltivazione di {crop}",
    cultivation: "Coltivazione",
    editSurface: "Modifica superficie",
    customGeometry: "Geometria personalizzata",
    variety: "Varietà",
    expectedYield: "Resa attesa",
    yieldMissing: "Attenzione: resa assente",
    irrigation: "Irrigazione",
    irrigationFlow: "Portata irrigua",
    notes: "Note",
    noGeometry: "Nessuna geometria disponibile.",
    openDataTitle: "Dati Open Data",
    farmDataUnavailable: "Dati azienda non disponibili.",
    newOperation: "Nuova Operazione",
    newObservation: "Nuova Osservazione",
    editTrapModalTitle: "Modifica Trappola",
    cancel: "Annulla",
    save: "Salva",
    selectStationModalTitle: "Seleziona stazione meteo",
    confirmDeleteTitle: "Conferma eliminazione",
    deleteFieldConfirm:
      "Stai eliminando la coltivazione di {crop} per l'anno {season} nell'appezzamento {plot}.",
    unknownCrop: "coltura sconosciuta",
    cannotUndo: "L'operazione non può essere annullata.",
    deleteAlsoPlot: "Elimina anche l'appezzamento {name}",
    editFieldModalTitle: "Modifica Coltivazione",
    saveChanges: "Salva Modifiche",
    customGeoModalTitle: "Personalizza Geometria",
    editPlotModalTitle: "Modifica Appezzamento",
    back: "Indietro",
    next: "Avanti",
    saving: "Salvataggio...",
    plantingDataModalTitle: "Dati di Impianto",
    dataUnavailable: "Dati non disponibili.",
    forceRecalc: "Forza ricalcolo",
    close: "Chiudi",
    help: "Aiuto",
    plotNotFound: "Appezzamento non trovato.",
    cropOperationLabel: "Operazione colturale",
    observationLabel: "Osservazione",
    tabModels: "Modelli",
    tabData: "Dati",
    tabMap: "Mappa",
    tabActivity: "Attività",
    tabTraps: "Trappole",
    irrigationNo: "Assente",
    irrigationEmergency: "Manuale/di soccorso",
    irrigationDrip: "Irrigazione a goccia",
    irrigationSprinkler: "Impianto Sprinkler",
    irrigationSubirrigation: "SubIrrigazione",
    irrigationSurface: "Irrigazione di superficie",
    irrigationOther: "Altre tipologie",
    plotTypeOrchard: "Frutteto",
    plotTypeVineyard: "Vigneto",
    plotTypeOliveGrove: "Oliveto",
    plotTypePasture: "Pascolo",
    plotTypeFieldFallback: "Campo",
    notAvailable: "N/D",
    cannotDeleteHasDeps: "Impossibile eliminare: ha {deps}. Rimuovili prima.",
    depOperations: "{count} operazione/i",
    depObservations: "{count} osservazione/i",
    depPlants: "{count} pianta/e",
    errorSavingSoil: "Errore nel salvataggio del suolo",
    layerPlotReference: "Plot (riferimento)",
    layerFieldCustomGeometry: "Campo (geometria personalizzata)",
    layerPlot: "Appezzamento",
    noCropFallback: "Nessuna coltura",
    popupPlotReference: "(Plot di riferimento)",
    popupCrop: "Coltura: {crop}",
    popupCustomGeometry: "(geometria personalizzata)",
  },

  // ── Monitoraggio / Osservazioni (ObservationView) ────────────────────────────
  observation: {
    pageTitle: "Monitoraggio - {name}",
    farmFallback: "Azienda",
    monitoringLabel: "Monitoraggio",
    tabObservations: "Osservazioni",
    tabSchede: "Dati Schede",
    tabTraps: "Trappole",
    tabAgroecologia: "AgroEcologia",
    tabOrobix: "Orobix",
    observationsCount: "Osservazioni ({count})",
    tableView: "Tabella",
    cardView: "Card",
    download: "Scarica",
    newObservation: "+ Nuova",
    noObservations: "Nessuna osservazione registrata.",
    addTrapviewTrap: "Aggiungi Trappola Trapview",
    selectSeasonForTraps:
      "Seleziona una stagione per visualizzare le trappole.",
    spadeTestsCount: "Test della Vanga ({count})",
    newSpadeTest: "+ Nuovo Test",
    noSpadeTests: "Nessun test della vanga registrato.",
    deleteSpadeTitle: "Elimina test",
    deleteSpadeConfirm: 'Eliminare il test "{name}"?',
    cancel: "Annulla",
    delete: "Elimina",
    observationModalTitle: "Osservazione",
    confirmDeleteTitle: "Conferma eliminazione",
    deleteObservationConfirm:
      "Sei sicuro di voler eliminare questa osservazione?",
    credentialsSaved: "Credenziali salvate.",
    trapviewHint:
      "Inserisci le credenziali del tuo account Trapview. Le trappole verranno importate automaticamente.",
    username: "Username",
    usernamePlaceholder: "username Trapview",
    password: "Password",
    close: "Chiudi",
    save: "Salva",
    errorUsernamePasswordRequired: "Username e password sono obbligatori.",
    errorSaving: "Errore nel salvataggio.",
    colType: "Tipo",
    colDate: "Data",
    colPlot: "Appezzamento",
    colCrop: "Coltura",
    colNotes: "Note",
    notAvailable: "N/D",
  },
  operationsView: {
    pageTitle: "Operazioni - {name}",
    farmFallback: "Azienda",
    operationsLabel: "Operazioni",
    tabPlanning: "Pianificazione",
    tabOperations: "Operazioni",
    tabSchede: "Dati Schede",
    tabReport: "Report",
    selectSeasonForPlanning:
      "Seleziona una stagione per visualizzare la pianificazione.",
    createSeason: "Crea Stagione",
    operationsCount: "Operazioni Colturali ({count})",
    tableView: "Tabella",
    cardView: "Card",
    download: "Scarica",
    newOperation: "+ Nuova",
    filterStatus: "Stato",
    filterAll: "Tutte",
    filterNone: "Eseguite",
    filterPlanned: "Pianificate",
    filterDone: "Completate",
    filterCancelled: "Annullate",
    reset: "Reset",
    noOperations: "Nessuna operazione registrata.",
    noOperationsHint:
      "Aggiungi operazioni colturali per tracciare le attività sui campi.",
    noOperationsReport: "Nessuna operazione registrata per questa stagione.",
    copperReportTitle:
      "Rame (Cu) distribuito per appezzamento — stagione corrente",
    fieldCrop: "Appezzamento / Coltura",
    copperKgHa: "kg Cu/ha",
    copperLimit: "Limite 4 kg/ha",
    exceeded: "Superato",
    ok: "OK",
    total: "Totale",
    operationTypesByField: "Tipi di operazione per appezzamento",
    operationModalTitle: "Operazione Colturale",
    confirmDeleteTitle: "Conferma eliminazione",
    deleteItemConfirm: "Sei sicuro di voler eliminare questo elemento?",
    cancel: "Annulla",
    delete: "Elimina",
    statusNone: "Eseguito",
    statusPlanned: "Pianificata",
    statusDone: "Completata",
    statusCancelled: "Annullata",
    colType: "Tipo",
    colDate: "Data",
    colStatus: "Stato",
    colPlot: "Appezzamento",
    colCrop: "Coltura",
    colDetails: "Dettagli",
    notAvailable: "N/D",
  },
  seasonSelector: {
    createSeason: "Crea Stagione",
    selectSeason: "Seleziona stagione",
    createNewSeason: "+ Crea Nuova Stagione",
  },
  cardField: {
    plotNoCrop: "Appezzamento senza coltura",
    plants: "piante",
    typeOrchard: "Frutteto",
    typeVineyard: "Vigneto",
    typeOliveGrove: "Oliveto",
    typePasture: "Pascolo",
  },
  operationObservationModal: {
    defaultTitle: "Operazione",
    back: "Indietro",
    next: "Avanti",
    cancel: "Annulla",
    save: "Salva",
    update: "Aggiorna",
  },
  farmCenterFormModal: {
    cancel: "Annulla",
    saveChanges: "Salva Modifiche",
    createFarm: "Crea Azienda",
    editFarmTitle: "Modifica Azienda",
    newFarmTitle: "Nuova Azienda",
  },
  runModelGeneric: {
    refresh: "Aggiorna",
    loading: "Caricamento...",
    modelNotSupported: "Modello {modelName} non supportato per il rendering",
    unexpectedError: "Errore imprevisto",
  },
  soilCard: {
    default: "Default",
    edit: "Modifica",
    delete: "Elimina",
    organicMatter: "Sostanza Organica",
    nitrogen: "Azoto (N)",
    phosphorus: "Fosforo (P₂O₅)",
    potassium: "Potassio (K₂O)",
    associatedPlots: "Appezzamenti associati",
  },
  soilFormModal: {
    editTitle: "Modifica Analisi del Suolo",
    newTitle: "Nuova Analisi del Suolo",
    cancel: "Annulla",
    save: "Salva",
  },
  soilForm: {
    useStandardSoil: "Usa Suolo Standard",
    useStandardSoilHint:
      "Crea rapidamente un'analisi con valori standard (40% sabbia, 20% argilla)",
    sampleCode: "Codice Campione",
    sampleCodePlaceholder: "es. SOIL-2024-001",
    samplingDate: "Data di Campionamento",
    textureComposition: "Composizione Tessiturale",
    sand: "Sabbia (%)",
    clay: "Argilla (%)",
    chemicalParameters: "Parametri Chimici",
    organicMatter: "Sostanza Organica (%)",
    totalNitrogen: "Azoto Totale (‰)",
    phosphorus: "Fosforo P₂O₅ (‰)",
    potassium: "Potassio K₂O (‰)",
    useForAllPlots:
      "Usa questa analisi per tutti gli appezzamenti dell'azienda.",
    associatedPlots: "Appezzamenti Associati",
    associatedPlotsHint:
      "Seleziona gli appezzamenti a cui questa analisi del suolo si applica",
    noPlotsAvailable: "Nessun appezzamento disponibile",
    validation: {
      sampleCodeRequired: "Il codice campione è obbligatorio",
      sandRequired: "La percentuale di sabbia è obbligatoria",
      clayRequired: "La percentuale di argilla è obbligatoria",
      organicMatterRequired: "La sostanza organica è obbligatoria",
      sandClaySumExceeds: "La somma di sabbia e argilla non può superare 100%",
      selectPlotOrDefault:
        "Seleziona almeno un appezzamento o imposta come default",
    },
  },
  plotForm: {
    warningInheritedPart1: "Le modifiche a",
    warningInheritedBold: "nome, geometria e superficie",
    warningInheritedPart2:
      "saranno ereditate da tutte le {count} coltivazioni:",
    namePlotLabel: "Nome Appezzamento",
    nameGeoElementLabel: "Nome Elemento",
    namePlotPlaceholder: "Es: Campo Nord, Oliveto Sud",
    nameGeoElementPlaceholder: "Es: Capannone, Recinzione",
    typeLabel: "Tipo Elemento",
    typePlaceholder: "Seleziona tipo",
    stepGeometryLabel: "Geometria",
    stepGeometryDescription: "Disegna la geometria sulla mappa",
    stepDetailsLabel: "Dettagli",
    stepDetailsDescription: "Inserisci i dati dell'appezzamento",
    nameRequired: "Il nome è obbligatorio",
    pointRequired: "Posiziona un punto sulla mappa",
    lineRequired: "Disegna una linea con almeno 2 punti sulla mappa",
    polygonRequired: "Disegna un poligono con almeno 3 punti sulla mappa",
    cropLabel: "Coltura",
    cropPlaceholder: "Seleziona coltura",
    permanentCropType: "Coltura permanente / Frutteto",
    fieldCropType: "Campo coltivabile",
    orchardDataButton: "Dati di impianto",
    orchardDataEditButton: "Modifica dati impianto",
    areaLabel: "Superficie (m²)",
    areaPlaceholder: "Es: 2.5",
    noteLabel: "Note",
    notePlaceholder: "Note aggiuntive...",
    descriptionLabel: "Descrizione",
    descriptionPlaceholder: "Descrizione dell'elemento...",
    missingDataModalTitle: "Dati mancanti",
    ok: "OK",
    orchardModalTitle: "Dati di impianto",
    confirm: "Conferma",
    areaNegative: "La superficie non può essere negativa",
    typeRequired: "Seleziona un tipo di elemento",
    entityLabelPlot: "appezzamento",
    entityLabelGeoElement: "elemento geografico",
    loadError: "Errore nel caricamento dell'{entity}",
    saveError: "Errore nel salvataggio",
  },
  seasonForm: {
    editTitle: "Modifica Stagione",
    newTitle: "Nuova Stagione",
    modeLabel: "Modalità",
    fullYearMode: "Anno intero",
    customMode: "Periodo personalizzato",
    yearLabel: "Anno",
    yearPlaceholder: "Seleziona anno",
    seasonNameLabel: "Nome Stagione",
    seasonNamePlaceholder: "Es: Primavera 2024, Inverno 2024-2025",
    dateFromLabel: "Data Inizio",
    dateToLabel: "Data Fine",
    cancel: "Annulla",
    saving: "Salvataggio...",
    saveChanges: "Salva Modifiche",
    createSeason: "Crea Stagione",
    copyStepTitle: "Copia colture dalla stagione precedente",
    copyStepHint:
      "Seleziona e modifica le colture da copiare nella nuova stagione:",
    cropPlaceholder: "Seleziona coltura",
    copyingInProgress: "Creazione colture in corso...",
    skip: "Salta",
    copySelected: "Copia selezionati ({count})",
    nameRequired: "Il nome è obbligatorio",
    dateFromRequired: "La data di inizio è obbligatoria",
    dateToRequired: "La data di fine è obbligatoria",
    dateToAfterFrom:
      "La data di fine deve essere successiva alla data di inizio",
    overlapMessage:
      'La stagione si sovrappone con "{name}" ({from} - {to}). Le stagioni non possono sovrapporsi.',
    loadError: "Errore nel caricamento della stagione",
    saveError: "Errore nel salvataggio",
  },
  zooContent: {
    title: "Allevamento",
    newHerd: "+ Nuovo gregge",
    loading: "Caricamento...",
    emptyTitle: "Nessun gregge configurato",
    emptyDescription:
      "Crea il primo gregge per iniziare a gestire i tuoi animali.",
    createFirstHerd: "Crea primo gregge",
    capiCount: "{count} capi",
    gruppiCount: "{count} gruppi",
  },
  productForm: {
    catalogSearchLabel: "Cerca nel catalogo",
    catalogSearchPlaceholderPesti: "Cerca fitofarmaco...",
    catalogSearchPlaceholderFerti: "Cerca fertilizzante...",
    catalogExpiry: "scad.",
    catalogEmpty: "Nessun risultato — inserisci il nome manualmente",
    nameLabel: "Prodotto",
    namePlaceholder: "Nome del prodotto",
    dateEnterLabel: "Data ingresso",
    quantityLabel: "Quantità",
    uomLabel: "Unità di misura",
    costLabel: "Costo totale",
    supplierLabel: "Fornitore",
    supplierPlaceholder: "Nome fornitore",
    invoiceLabel: "Fattura/Bolla",
    invoicePlaceholder: "Numero fattura",
    dateEndLabel: "Data esaurimento",
    cuPercLabel: "% Rame (Cu)",
    extraFieldsTitle: "{name} - Dati specifici",
    recipeTitle: "Ricetta / Ingredienti",
    addIngredient: "+ Aggiungi ingrediente",
    recipeEmpty: "Nessun ingrediente aggiunto",
    tableProduct: "Prodotto",
    tableQuantity: "Quantità",
    tableNote: "Note",
    selectPlaceholder: "-- Seleziona --",
    exhausted: " (esaurito)",
    notePlaceholderRow: "Note...",
    noteLabel: "Note",
    notePlaceholder: "Note aggiuntive...",
    cancel: "Annulla",
    saving: "Salvataggio...",
    saveChanges: "Salva Modifiche",
    addProduct: "Aggiungi Prodotto",
    errorLoading: "Errore nel caricamento del prodotto",
    errorNameRequired: "Il nome è obbligatorio",
    errorDateRequired: "La data è obbligatoria",
    errorQuantityRequired: "Quantità obbligatoria e &gt;= 0",
    errorSaving: "Errore nel salvataggio",
  },
  imageLoader: {
    takePhoto: "Scatta foto",
    addPhoto: "Aggiungi foto",
    uploading: "Caricamento {current}/{total}...",
    queuedTitle: "Immagini in attesa di upload",
    queuedCount: "{count} in attesa",
    progressText: "{current} / {total} foto",
    notSynced: "Non sincronizzata",
    noImages: "Nessuna immagine caricata.",
    modalTitle: "Immagine",
    captionLabel: "Didascalia",
    captionPlaceholder: "Scrivi una didascalia...",
    syncedWithServer: "Sincronizzata con il server",
    save: "Salva",
    delete: "Elimina",
    sourceGallery: "galleria",
    sourceCamera: "fotocamera",
    errorSource: "Errore {source}: {message}",
    errorReadingFile: '"{name}": errore lettura file',
    errorQueueLimit:
      "Limite raggiunto: massimo 20 immagini in coda. Connettiti per sincronizzare.",
    errorServer: '"{label}": errore server',
    errorNetwork: "errore di rete",
    errorUpload: '"{label}": {message}',
  },
  trapCard: {
    syncButton: "Aggiorna da Trapview",
    editButton: "Modifica trappola",
    deleteButton: "Elimina trappola",
    noAutoData: "Nessun dato ancora ricevuto dalla trappola.",
    noObservations: "Nessun rilevamento registrato.",
    addObservation: "+ Aggiungi rilevamento",
    add: "+ Aggiungi",
    date: "Data",
    catches: "Catture",
    notes: "Note",
    showImage: "Mostra immagine",
    edit: "Modifica",
    delete: "Elimina",
    tabChart: "Grafico",
    tabData: "Dati",
    chartYAxis: "Adulti catturati",
    editObservationTitle: "Modifica rilevamento",
    newObservationTitle: "Nuovo rilevamento",
    syncErrorDefault: "Errore aggiornamento",
    typeCromo: "Cromo trappole",
    typePheno: "Trappole a feromoni",
    typeFlytrap: "FlyTrap",
    typeOther: "Altro",
  },
  trapUpsert: {
    autoBadge:
      "Trappola automatica — i dati vengono importati automaticamente da Trapview.",
    nameLabel: "Nome *",
    namePlaceholder: "es. Trappola A1",
    typeLabel: "Tipo",
    typeCromo: "Cromo trappole",
    typePheno: "Trappole a feromoni",
    typeFlytrap: "FlyTrap",
    typeOther: "Altro",
    pestLabel: "Insetto / Parassita",
    optional: "(opzionale)",
    pestPlaceholder: "es. Ceratitis capitata",
    dateLabel: "Data posizionamento",
    fieldsLabel: "Campi monitorati",
    gpsLabel: "Posizione GPS",
    gpsHint: "(clicca sulla mappa)",
    lat: "Lat",
    lon: "Lon",
    removeCoords: "Rimuovi",
    mapHintDefault: "Clicca per impostare la posizione",
    trapNameFallback: "Trappola",
    nameRequired: "Inserisci il nome della trappola",
  },
  trapView: {
    title: "Trappole ({count})",
    newTrap: "+ Nuova Trappola",
    loading: "Caricamento...",
    emptyTitle: "Nessuna trappola presente per questa stagione.",
    emptyHint: "Crea la prima trappola per iniziare il monitoraggio.",
    createTrap: "Crea Trappola",
    editModalTitle: "Modifica Trappola",
    newModalTitle: "Nuova Trappola",
    cancel: "Annulla",
    save: "Salva",
    deleteModalTitle: "Elimina trappola",
    deleteConfirmPrefix: "Eliminare la trappola",
    deleteConfirmSuffix: "?",
    cannotUndo: "L'operazione non può essere annullata.",
    delete: "Elimina",
  },
  trapviewSetup: {
    statusNotConfigured: "Non configurato",
    statusInvalidCreds: "Credenziali non valide",
    statusConnected: "Connesso",
    notConfigured: "Nessuna integrazione Trapview configurata.",
    invalidCreds: "Credenziali non valide. Aggiorna username e password.",
    credentialsSaved: "Credenziali trapview salvate.",
    noTrapsImported: "Nessuna trappola ancora importata.",
    configureTraps: "Configura trappole",
    loadingDevices: "Recupero trappole da Trapview…",
    errorFetchDevices: "Errore recupero trappole",
    devicesTitle: "Trappole disponibili — seleziona quelle da importare:",
    selectAll: "Seleziona tutte",
    importButton: "Importa ({count})",
    errorImportPartial: "Errore su {count} trappola/e",
    connectedPrefix: "Connesso ·",
    connectedSuffix: "trappola/e collegate.",
  },
  schemaDataTable: {
    noData: "Nessun dato disponibile.",
    exportCsv: "Esporta CSV",
    noDataForSchema: "Nessun dato per questa scheda.",
    columns: {
      date: "Data",
      field: "Appezzamento",
      crop: "Coltura",
      area: "Sup. (ha)",
      productName: "Prodotto",
      amountHa: "Dose/ha",
      dose: "Dose",
      uom: "U.M.",
      amountTot: "Totale",
      mm: "mm",
      tillage: "Lavorazione",
      depth: "Profondità (cm)",
      pruningType: "Tipo potatura",
      culture: "Cover crop",
      fertilizzante: "Fertilizzante",
      quantita: "Quantità",
      totalOlives: "Olive camp.",
      trapName: "Trappola",
      trap: "Catture",
      stage: "Fase",
      fasemedia: "BBCH",
      result: "Risultato",
      production: "Produzione",
      typeAmount: "Tipo qtà",
      regNr: "Nr. reg.",
      activeIngredient: "Principio attivo",
      target: "Avversità",
      interval: "Intervallo (gg)",
      withholding: "Carenza (gg)",
      pruningNotes: "Note potatura",
    },
  },
  orobixTab: {
    loadingAcquisitions: "Caricamento acquisizioni...",
    noAcquisitions: "Nessuna acquisizione Orobix disponibile.",
    acquisition: "Acquisizione",
    selectAcquisition: "Seleziona un'acquisizione…",
    loadingData: "Caricamento dati…",
    analysisDate: "Data analisi:",
    acquisitionDate: "Data acquisizione:",
    imagesCount: "{count} immagini",
    mapTheme: "Tema mappa",
    resultSummary: "{total} olive ({green} verdi / {black} nere) — CI: {ci}",
    loadAcquisitionsError: "Errore caricamento acquisizioni",
    loadDetailError: "Errore caricamento dettaglio",
    themes: {
      pctBlack: "% Olive nere",
      pctBlackField: "% olive nere",
      countOlives: "N° olive totali",
      countOlivesField: "N° olive",
      acquisitionTime: "Ora acquisizione",
      acquisitionTimeField: "min dall'inizio",
    },
    columns: {
      id: "ID",
      dateTime: "Data/Ora",
      lat: "Lat",
      lon: "Lon",
      result: "Risultato",
    },
    popup: {
      image: "Immagine",
      olives: "Olive",
      green: "verdi",
      black: "nere",
      pctBlack: "% nere",
      colorIndex: "Color index",
      time: "Ora",
    },
  },
  ganttPlanner: {
    title: "Calendario delle attività",
    experimentalHint:
      "Attenzione questa funzione è ancora in fase sperimentale. I dati potrebbero non essere salvati correttamente, si consiglia di utilizzarla solo per pianificazioni temporanee o di test. Trascina operazioni/monitoraggi sulla timeline per pianificarle.",
    availableActivities: "Attività Disponibili",
    searchPlaceholder: "🔍 Cerca attività...",
    clearSearch: "Cancella",
    operationsTab: "🚜 Operazioni ({count})",
    observationsTab: "🔬 Monitoraggi ({count})",
    defaultOperationDescription: "Operazione colturale",
    defaultObservationDescription: "Monitoraggio",
    noPlotsTitle: "📋 Nessun appezzamento disponibile per questa stagione.",
    noPlotsHint: "Aggiungi appezzamenti per iniziare la pianificazione.",
    newActivity: "Nuova Attività",
    editOperation: "Modifica Operazione",
    editObservation: "Modifica Monitoraggio",
    newOperation: "Nuova Operazione",
    newObservation: "Nuovo Monitoraggio",
    noFieldsAlert:
      "Nessun campo coltivato per questo appezzamento nella stagione selezionata.",
    moveError: "Errore nello spostamento: {message}",
    deleteError: "Errore nell'eliminazione: {message}",
    confirmDelete: 'Eliminare {type} "{name}"?',
    typeOperation: "operazione",
    typeObservation: "monitoraggio",
    months: {
      jan: "Gen",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "Mag",
      jun: "Giu",
      jul: "Lug",
      aug: "Ago",
      sep: "Set",
      oct: "Ott",
      nov: "Nov",
      dec: "Dic",
    },
  },
  ganttTimeline: {
    view: "Vista:",
    day: "Giorno",
    week: "Settimana",
    month: "Mese",
    year: "Anno:",
    zoom: "Zoom:",
    resetView: "Reset Vista",
    today: "Oggi",
    defaultOperationLabel: "Operazione",
    defaultObservationLabel: "Osservazione",
  },
  quadernoDiCampagna: {
    exportExcel: "Esporta Excel",
    loading: "Caricamento dati...",
    noData: "Nessun dato disponibile per il quaderno di campagna.",
    notAvailable: "N/D",
    exportNotImplemented: "Export Excel - da implementare",
    columns: {
      date: "Data",
      season: "Stagione",
      species: "Specie",
      variety: "Varietà",
      plot: "Appezzamento",
      area: "Superficie",
      operation: "Operazione",
      reason: "Motivo",
      production: "Produzione",
      product: "Prodotto",
      uom: "UdM",
      quantity: "Quantità",
    },
  },
  plotEnrichment: {
    noData: "Nessun dato open data disponibile",
    enrichWithOpenData: "Arricchisci con Open Data",
    newDataAvailable: "Nuovi dati disponibili",
    update: "Aggiorna",
    hide: "Nascondi",
    view: "Visualizza",
    reEnrichAllData: "Ri-arricchisci tutti i dati",
    texture: "Tessitura",
    sandPercent: "{value}% sabbia",
    clayPercent: "{value}% argilla",
    elevation: "Quota",
    metersAboveSeaLevel: "m s.l.m.",
    temperature: "Temperatura",
    updateOpenDataTitle: "Aggiorna Dati Open Data",
    newFeaturesAvailable: "Novità disponibili",
    partialUpdate: "Aggiornamento parziale",
    partialUpdateHint: "Interroga solo i nuovi dati (più veloce)",
    fullUpdate: "Aggiornamento completo",
    fullUpdateHint:
      "Re-interroga tutti i dati (consigliato se sono passati mesi)",
    cancel: "Annulla",
    enrichErrorPrefix: "Errore durante l'arricchimento: ",
    updateErrorPrefix: "Errore durante l'aggiornamento: ",
    categoryPedology: "Pedologia",
    categoryElevation: "Quota",
    categoryTemperature: "Temperatura",
  },
  fieldForm: {
    geographicFieldTitle: "Campo Geografico (Plot)",
    geographicDataHint: "dati geografici pluriennali",
    editCustomizations: "Modifica Personalizzazioni",
    customizeGeometry: "Personalizza Geometria",
    editPlotArrow: "Modifica Plot →",
    name: "Nome",
    customizedM: "personalizzato",
    surface: "Superficie",
    customizedF: "personalizzata",
    geometry: "Geometria",
    customized: "Personalizzata",
    fromPlot: "Dal plot",
    cropTitle: "Coltivazione {season} (Field)",
    cropDataHint: "dati specifici della coltivazione",
    crop: "Coltura",
    selectCrop: "Seleziona coltura",
    variety: "Varietà",
    varietyPlaceholder: "Es. Frantoio, Leccino...",
    notes: "Note",
    notesPlaceholder: "Note specifiche per questa coltivazione...",
    notAvailable: "N/D",
    plotTypeOrchard: "Frutteto",
    plotTypeVineyard: "Vigneto",
    plotTypeOliveGrove: "Oliveto",
    plotTypePasture: "Pascolo",
    plotTypeField: "Campo",
    fieldNotFound: "Campo non trovato",
    loadErrorPrefix: "Errore nel caricamento dei dati: ",
    selectCropError: "Seleziona una coltura",
    saveError: "Errore nel salvataggio",
    saveErrorPrefix: "Errore nel salvataggio: ",
    yieldHaLabel: "Resa attesa (q/ha)",
    yieldHaPlaceholder: "Es. 50",
    irrigationLabel: "Irrigazione",
    irrigationNo: "Assente",
    irrigationEmergency: "Manuale/di soccorso",
    irrigationDrip: "Irrigazione a goccia",
    irrigationSprinkler: "Impianto Sprinkler",
    irrigationSubirrigation: "SubIrrigazione",
    irrigationSurface: "Irrigazione di superficie",
    irrigationOther: "Altre tipologie di Irrigazione",
    irrigationFlowLabel: "Portata irrigua (l/s)",
    irrigationFlowPlaceholder: "Es. 2",
  },
  varietyChooser: { remove: "Rimuovi", addMore: "Aggiungi..." },
  fieldGeoForm: {
    loading: "Caricamento...",
    referencePlot: "Plot di riferimento",
    plotName: "Nome Plot",
    plotSurface: "Superficie Plot",
    crop: "Coltura",
    notAvailable: "N/D",
    referenceNote:
      "Puoi personalizzare nome e geometria solo per questa coltivazione. Il plot rimarrà invariato.",
    cropNameLabel: "Nome Coltivazione (opzionale)",
    cropNamePlaceholder: "Es: Vigna Nord, Oliveto Sud",
    emptyNameHint: 'Se vuoto, verrà usato il nome dell\'appezzamento: "{name}"',
    geometryLabel: "Geometria (opzionale)",
    geometryHint:
      "Disegna l'area specifica di questa coltivazione. Se vuota, verrà usata la geometria del plot.",
    surfaceLabel: "Superficie (m²)",
    surfacePlaceholder: "Auto-calcolata dalla geometria",
    surfaceHint:
      "Calcolata automaticamente dalla geometria disegnata. Se non disegni una geometria, verrà usata quella del plot ({area}).",
    fieldNotFound: "Appezzamento non trovato",
    loadErrorPrefix: "Errore nel caricamento: ",
    negativeSurfaceError: "La superficie non può essere negativa",
    saveError: "Errore nel salvataggio",
    saveErrorPrefix: "Errore nel salvataggio: ",
  },
  plotOrchardEditor: {
    variety: "Varietà",
    varietyPlaceholder:
      "Aggiungi un nome e premi invio, ne puoi aggiungere più di una",
    plantingYear: "Anno di impianto",
    plantingYearPlaceholder: "Es. 2005",
    vigourClass: "Classe di vigoria",
    notSpecifiedF: "— Non specificata —",
    vigourLow: "Bassa",
    vigourMedium: "Media",
    vigourHigh: "Alta",
    naturalGrassing: "Inerbimento naturale",
    notSpecifiedM: "— Non specificato —",
    yes: "Sì",
    no: "No",
    rowDistance: "Distanza tra le file (m)",
    rowDistancePlaceholder: "Es. 6",
    plantDistance: "Distanza sulle file (m)",
    plantDistancePlaceholder: "Es. 4",
    plantingDensity: "Densità di impianto",
    plantsPerHa: "{density} piante/ha",
  },
  fieldCropTimeline: {
    all: "Tutte",
    operations: "Operazioni",
    observations: "Osservazioni",
    noItemsRegistered: "Nessuna operazione o osservazione registrata.",
    createFirstOperation: "Crea la prima operazione colturale",
    makeFirstObservation: "Fai la prima osservazione",
    noItemsForFilter: "Nessun elemento per questo filtro.",
    newOperation: "Nuova Operazione Colturale",
    newObservation: "Nuova Osservazione",
    editOperation: "Modifica Operazione",
    editObservation: "Modifica Osservazione",
    confirmDeletionTitle: "Conferma eliminazione",
    deleteItemConfirm: "Eliminare questo elemento?",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    operation: "Operazione",
    observation: "Osservazione",
    statusPlanned: "Pianificata",
    statusDone: "Completata",
    statusCancelled: "Annullata",
  },
  farmCenterForm: {
    tabAnagrafica: "Anagrafica",
    tabExtra: "Dati Aggiuntivi",
    tabStazione: "Stazione Meteo",
    nameLabel: "Nome Azienda",
    namePlaceholder: "Es: Azienda Agricola Rossi",
    cuaaLabel: "CUAA",
    cuaaPlaceholder: "Es: RSSMRA80A01H501Z",
    placeLabel: "Indirizzo/Luogo",
    placePlaceholder: "Es: Firenze, Toscana",
    searching: "Cercando...",
    geocode: "Geocodifica",
    gpsSearching: "GPS...",
    gps: "GPS",
    gpsPositionTitle: "Posiziona con GPS",
    mapHint: "Clicca sulla mappa per inserire o modificare le coordinate",
    coordinatesRequired:
      "Coordinate obbligatorie: clicca sulla mappa o usa il pulsante Geocodifica.",
    noteLabel: "Note",
    notePlaceholder: "Note aggiuntive sull'azienda...",
    addStationLink: "Aggiungere stazione meteo aziendale",
    addStationLaterHint:
      "Se vuoi inserire la stazione aziendale dopo aver creato l'azienda, potrai farlo dalla sezione Dss e Meteo.",
    noStationsAvailable: "Nessuna stazione disponibile.",
    newFarmDefaultName: "Nuova Azienda",
    loadErrorPrefix: "Errore nel caricamento dell'azienda",
    geocodingErrorDefault:
      "Errore durante la geocodifica. Riprova o inserisci le coordinate manualmente.",
    gpsNotSupported: "Geolocalizzazione non supportata dal browser.",
    gpsPermissionDenied:
      "Permesso GPS negato. Abilita la localizzazione nelle impostazioni.",
    gpsUnavailable: "Impossibile ottenere la posizione GPS.",
    nameRequired: "Il nome è obbligatorio",
    placeRequired: "L'indirizzo è obbligatorio",
    required: "Obbligatoria",
    latInvalid: "Non valida (-90 a 90)",
    lonInvalid: "Non valida (-180 a 180)",
    missingCoordinates:
      "Coordinate geografiche mancanti: clicca sulla mappa o usa Geocodifica (tab Anagrafica)",
    saveError: "Errore nel salvataggio",
    placeRegisteredLabel: "Indirizzo Sede Legale",
    practiceLabel: "Quali sono le pratiche colturali",
    practiceConventional: "Convenzionali",
    practiceTransition: "Azienda in transizione al Bio",
    practiceMixed: "Azienda Bio certificata solo su alcuni settori",
    practiceBio: "Azienda Bio certificata",
  },
  stationPicker: {
    nearest: "Più vicina",
    noStationsAvailable: "Nessuna stazione disponibile.",
    farmCenter: "Azienda",
    station: "Stazione",
    noFarmCenterCoordinates: "Coordinate azienda non disponibili",
    dataUpdated: "Dati aggiornati",
    dailyDataUpdated: "Dati gg aggiornati",
    dailyDataAsOf: "Dati gg al {date}",
    hourlyDataUpdated: "Dati orari aggiornati",
    hourlyDataAsOf: "Dati orari al {date}",
    dailyDataMissing: "Dati gg assenti",
    hourlyDataMissing: "Dati orari assenti",
  },
  homeView: {
    loggedInTitle: "Accesso effettuato",
    userLabel: "Utente: {name}",
  },
  soilsView: {
    title: "Suoli - {name}",
    farmFallback: "Azienda",
    addAnalysis: "Aggiungi Analisi del Suolo",
    noSoils: "Nessuna analisi del suolo presente.",
    noSoilsHint:
      "Crea una nuova analisi per iniziare a gestire i dati pedologici della tua azienda.",
    breadcrumbSoils: "Suoli",
    saveError: "Errore nel salvataggio. Riprova.",
    deleteConfirm: 'Vuoi davvero eliminare l\'analisi del suolo "{code}"?',
    deleteError: "Errore nell'eliminazione.",
  },
  warehouseSection: {
    title: "Magazzino ({count})",
    archivedBadge: "{count} esauriti",
    hideArchived: "Nascondi esauriti",
    showAll: "Mostra tutti",
    addTitle: "Aggiungi",
    noProducts: "Nessun prodotto",
    colProduct: "Prodotto",
    colEntry: "Ingresso",
    colQty: "Qtà",
    colResidual: "Residuo",
    movementsTitle: "Movimenti",
    archiveTitle: "Segna come esaurito",
    editTitle: "Modifica",
    deleteTitle: "Elimina",
    archivedTag: "esaurito {date}",
    loadLabel: "Carico",
    operationFallback: "Operazione",
    uomMismatchTitle: "UOM diversa dal carico",
    residualLabel: "Residuo",
  },
  operationProductRow: {
    productLabel: "Prodotto {n}",
    removeTitle: "Rimuovi prodotto",
    productFieldLabel: "Prodotto",
    selectPlaceholder: "-- Seleziona --",
    otherManual: "Altro (inserimento manuale)",
    createProductTitle: "Crea nuovo prodotto in magazzino",
    productNameLabel: "Nome prodotto",
    productNamePlaceholder: "Nome del prodotto",
    totalLabel: "Totale",
    unitLabel: "Unità",
    qtyHaLabel: "Qtà/ha",
    stockInsufficientPrefix: "Scorte insuff.: ",
    stockPrefix: "Scorta: ",
    npkMissingWarning:
      "Concentrazione N-P-K non inserita: il calcolo delle unita fertlizzanti non sara disponibile. Inserisci le percentuali qui sopra oppure nel magazzino prodotto.",
    reasonLabel: "Motivo del trattamento",
    npkEnterQuantity: "Inserisci una quantità per calcolare NPK",
    npkSummary: "NPK unità/ha: {n} - {p} - {k}",
  },
  notificationsView: {
    title: "Notifiche",
    notificationsCount: "{count} notifiche",
    unreadCount: "{count} non lette",
    markAllRead: "Segna tutte come lette",
    openChat: "Apri chat →",
    emptyLabel: "Nessuna notifica",
    emptySub: "Le notifiche push ricevute appariranno qui",
    pushOnlyNative: "Push disponibili solo su app nativa (iOS/Android)",
    tokenAcquired: "Token acquisito e trasmesso al server con successo",
    tokenNotObtained:
      "Nessun token ottenuto — controlla i permessi nelle impostazioni del dispositivo",
    registerError: "Errore: {error}",
    timeNow: "Adesso",
    timeMinAgo: "{min} min fa",
    timeHoursAgo: "{h} ore fa",
  },
  notificationAdminView: {
    title: "Invia Notifiche Push",
    step1Title: "1. Filtra destinatari",
    activeLastLabel: "Considera attivi gli ultimi",
    months: "mesi",
    loadUsers: "Carica utenti",
    step2Title: "2. Seleziona destinatari",
    usersDevicesCount: "{users} utenti, {devices} device",
    selectAll: "Seleziona tutti",
    deselectAll: "Deseleziona tutti",
    colEmail: "Email",
    colPlatform: "Platform",
    colLastUpdate: "Ultimo aggiornamento",
    colDevice: "Device",
    uidFallback: "uid:{uid}",
    selectionSummary: "{users} utenti selezionati · {devices} device totali",
    noActiveUsers: "Nessun utente con token attivo nel periodo selezionato.",
    step3Title: "3. Messaggio",
    titleLabel: "Titolo *",
    titlePlaceholder: "Es: Aggiornamento disponibile",
    bodyLabel: "Testo *",
    bodyPlaceholder: "Scrivi il testo della notifica...",
    routeLabel: "Route (opzionale)",
    routePlaceholder: "Es: /poderi/abc123",
    routeHint:
      "Se specificata, l'app navigherà a questa route al tap sulla notifica",
    previewLabel: "Anteprima",
    previewNoTitle: "(senza titolo)",
    previewNoBody: "(senza testo)",
    sendInfo: "Verrà inviata a {users} utenti ({devices} device)",
    sendButton: "Invia notifica",
    errorLoadingUsers: "Errore caricamento utenti",
    confirmSendSummary:
      "Stai per inviare la notifica a {users} utenti ({devices} device). Confermi?",
    errorSending: "Errore invio",
    resultTitle: "Risultato invio",
    resultSent: "Inviati",
    resultFailed: "Falliti",
    resultUsers: "Utenti",
    resultDevicesFound: "Device trovati",
    newNotification: "Nuova notifica",
  },
  feedView: {
    title: "Feed Attività",
    breadcrumbHome: "Home",
    filters: "Filtri",
    org: "Organizzazione",
    allOrgs: "Tutte",
    farm: "Azienda",
    allFarms: "Tutte",
    crop: "Coltura",
    allCrops: "Tutte",
    type: "Tipo",
    allTypes: "Tutti",
    typeObservation: "Osservazione",
    typeOperation: "Operazione",
    typeAnimal: "Animali",
    schema: "Scheda",
    allSchemas: "Tutte le schede",
    period: "Periodo",
    periodLast30: "Ultimi 30 gg",
    periodLast90: "Ultimi 90 gg",
    periodCurrentYear: "Anno corrente",
    periodLastYear: "Anno scorso",
    periodAll: "Tutte le date",
    periodCustom: "Personalizzato",
    dateFrom: "Dal",
    dateTo: "Al",
    dateFieldUpdate: "Aggiornamento",
    dateFieldOperation: "Data operazione",
    reset: "Reset",
    loading: "Caricamento...",
    emptyPeriod: "Nessuna attività nel periodo selezionato.",
    emptyPeriodTable: "Nessun dato nel periodo selezionato.",
    emptyPeriodMap: "Nessun dato geolocalizzato nel periodo selezionato.",
    errorLoadFeed: "Errore nel caricamento del feed",
    statusPlanned: "Pianificata",
    statusDone: "Completata",
    statusCancelled: "Annullata",
    moreFields: "{name} +{n} altri",
    schemaFallback: "Schema #{id}",
    operationFallback: "Operazione #{id}",
    animalEventFallback: "Evento animale #{id}",
    timeAgoSeconds: "{n} secondi fa",
    timeAgoMinutes: "{n} minuti fa",
    timeAgoHours: "{n} ore fa",
    timeAgoDays: "{n} giorni fa",
    tabFeed: "Feed",
    tabTable: "Tabella",
    tabMap: "Mappa",
    tableColDate: "Data",
    tableColFarm: "Azienda",
    tableColScheda: "Scheda",
    tableColType: "Tipo",
    tableColUser: "Utente",
    tableColNotes: "Note",
  },
  cropRotationView: {
    title: "Rotazione Colturale",
    defaultFarmName: "Azienda",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    tabRotations: "Rotazioni",
    tabSeasons: "Stagioni",
    seasonsTitle: "Stagioni ({count})",
    newSeason: "Nuova Stagione",
    noSeasons: "Nessuna stagione registrata.",
    noSeasonsHint:
      "Crea la prima stagione per iniziare a tracciare le colture.",
    edit: "Modifica",
    delete: "Elimina",
    period: "Periodo",
    year: "Anno",
    seasonModalTitle: "Stagione",
    deleteConfirmTitle: "Conferma eliminazione",
    deleteConfirmMessage: "Sei sicuro di voler eliminare questa stagione?",
    cancel: "Annulla",
    notAvailable: "N/D",
  },
  cropRotation: {
    title: "Rotazione Colturale",
    addSeason: "Aggiungi Stagione",
    hint: "Trascina le colture sulle celle per assegnarle agli appezzamenti per stagione",
    availableCrops: "Colture Disponibili",
    searchCropPlaceholder: "Cerca coltura...",
    clearSearch: "Cancella ricerca",
    noCropsInDb: "Nessuna coltura disponibile nel database.",
    noCropsInDbHint: "Le colture verranno caricate dal backend.",
    noCropsFound: 'Nessuna coltura trovata per "{query}"',
    noCropsFoundHint: "Prova con un altro termine di ricerca.",
    noCropsFoundShort: "Nessuna coltura trovata",
    annualCropType: "Annuale",
    noPlots: "Nessun appezzamento disponibile.",
    noSeasons: "Nessuna stagione disponibile.",
    noPlotsOrSeasonsHint:
      "Crea prima appezzamenti e stagioni per gestire le colture.",
    plot: "Appezzamento",
    editPlot: "Modifica appezzamento",
    remove: "Rimuovi",
    addPlot: "Aggiungi Appezzamento",
    editAssignmentTitle: "Modifica Assegnazione",
    cropLabel: "Coltura",
    season: "Stagione",
    noteLabel: "Note",
    notePlaceholder: "Note aggiuntive...",
    save: "Salva",
    editPlotTitle: "Modifica Appezzamento",
    newPlotTitle: "Nuovo Appezzamento",
    editSeasonTitle: "Modifica Stagione",
    newSeasonTitle: "Nuova Stagione",
    selectCropTitle: "Seleziona Coltura",
    unknown: "Sconosciuto",
    cropAlreadyAssigned:
      "Questa coltura è già assegnata a questo appezzamento per questa stagione.",
    createAssignmentError: "Errore nella creazione dell'assegnazione",
    saveError: "Errore nel salvataggio",
    removeError: "Errore nella rimozione",
    confirmRemoveField: "Rimuovere {crop} da questo appezzamento?",
  },
  adminDbmngView: {
    addNewSchema: "Aggiungi nuova scheda",
    updateVocabularies: "Aggiorna vocabolari",
    updatingVocabularies: "Aggiornamento...",
    save: "Salva",
    saving: "Salvataggio...",
    selectSchemaType: "Seleziona il tipo di scheda da editare",
    editSchedeButton: "Edita le schede",
    mySchede: "Le mie schede",
    orgSchede: "Schede delle organizzazioni",
    columnOrganization: "Organizzazione",
    noPersonalSchede:
      "Nessuna scheda personalizzata. Crea una nuova scheda o consulta quelle pubbliche.",
    edit: "Modifica",
    delete: "Elimina",
    visible: "Visibile",
    hidden: "Nascosta",
    typeOrganization: "Organizzazione",
    publicSchede: "Schede pubbliche",
    noPublicSchede: "Nessuna scheda pubblica disponibile.",
    typePublic: "Pubblica",
    syncHintBefore: "Dopo aver salvato, clicca",
    syncHintAfter: "per vedere subito la scheda modificata nell'app.",
    schemaProperties: "Proprietà Scheda",
    schemaNameLabel: "Nome scheda",
    schemaNamePlaceholder: "Nome della scheda...",
    filtroLabel: "Filtro",
    filtroPlaceholder: "Valore filtro...",
    fieldsDefinition: "Definizione Campi",
    loading: "Caricamento...",
    confirmDeleteTitle: "Conferma eliminazione",
    confirmDeleteTextBefore: "Vuoi eliminare la scheda",
    confirmDeleteTextAfter: "?",
    cancel: "Annulla",
    deleting: "Eliminazione...",
    newSchemaNameLabel: "Nome della scheda",
    newSchemaNamePlaceholder: "Inserisci il nome...",
    creating: "Creazione...",
    create: "Crea",
    pageTitleDefault: "Gestione Schede",
    schedeFor: "Schede - {caso}",
    editorTitle: "Editor: {name}",
    breadcrumbHome: "Home",
    editorFallback: "Editor",
    columnSchemaType: "Tipo di scheda",
    columnName: "Nome",
    columnActive: "Attiva",
    columnOrder: "Ordine",
    columnDataType: "Tipo di dato",
    notAvailable: "N/D",
    confirmChangeVisibility: "Sei sicuro di voler cambiare la visibilità?",
    errorLoadingConfig: "Errore caricamento configurazione",
    errorLoadingSchede: "Errore caricamento schede",
    errorLoadingSchemaDetails: "Errore caricamento dettagli scheda",
    errorChangingVisibility: "Errore cambio visibilità",
    errorDeleting: "Errore eliminazione",
    errorCreatingSchema: "Errore creazione scheda",
    errorSaving: "Errore salvataggio",
    saveSuccess: "Scheda salvata con successo",
  },
  warehouseView: {
    title: "Magazzino",
    farmFallback: "Azienda",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbWarehouse: "Magazzino",
    productModalTitle: "Prodotto",
    cancel: "Annulla",
    saving: "Salvataggio...",
    saveChanges: "Salva Modifiche",
    addProduct: "Aggiungi Prodotto",
    operationModalTitle: "Operazione Colturale",
    confirmDeleteTitle: "Conferma eliminazione",
    cannotUndo: "L'operazione non può essere annullata.",
    delete: "Elimina",
    errorDeletingProduct: "Errore durante l'eliminazione del prodotto",
  },
  marketingView: {
    title: "Marketing",
    farmFallback: "Azienda",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbMarketing: "Marketing",
  },
  marketingSection: {
    publicationTitle: "Pubblicazione",
    publishedOn: "Pubblicata il {date}",
    visibleInList: "visibile nella lista",
    directLinkOnly: "solo link diretto",
    notYetPublished: "Pagina non ancora pubblicata",
    publicUrlLabel: "URL pubblico",
    listed: "Listed",
    unlisted: "Unlisted",
    publishing: "Pubblicazione...",
    saveAndUpdate: "Salva e aggiorna",
    saveAndPublish: "Salva e pubblica",
    remove: "Rimuovi",
    descriptionTitle: "Descrizione",
    companyDescriptionLabel: "Descrizione azienda",
    companyDescriptionPlaceholder: "Descrivi la tua azienda...",
    productsDescriptionLabel: "Descrizione prodotti",
    productsDescriptionPlaceholder: "Descrivi i tuoi prodotti...",
    imagesTitle: "Immagini",
    imageGallery: "Galleria immagini",
    logo: "Logo",
    contactsTitle: "Contatti e social",
    emailLabel: "Email",
    phoneLabel: "Telefono",
    pageUrlPlaceholder: "URL pagina",
    saveMarketingData: "Salva dati marketing",
    autoSlugFallback: "nome-azienda",
    errorSaving: "Errore nel salvataggio: ",
    errorPublishing: "Errore pubblicazione: ",
    errorGeneric: "Errore: ",
    confirmUnpublish: "Rimuovere la pagina pubblica?",
  },
  farmCenterMap: {
    viewDetails: "Visualizza Dettagli",
  },
  teamView: {
    inviteMember: "Invita Membro",
    leaveTeam: "Esci dal Team",
    loading: "Caricamento...",
    error: "Errore",
    teamMembers: "Membri del Team",
    owner: "Responsabile",
    roleOwner: "Proprietario",
    roleGrower: "Coltivatore",
    roleAdvisor: "Consulente",
    roleUndefined: "Non definito",
    transferOwnership: "Trasferisci resp.",
    remove: "Rimuovi",
    noMembers: "Nessun membro nel team",
    pendingInvitations: "Inviti Pendenti",
    singleUseLink: "Link monouso",
    expires: "Scade",
    organizations: "Organizzazioni",
    unlink: "Scollega",
    noOrgsLinked: "Nessuna organizzazione collegata",
    orgVisibilityInfo:
      "Tutti i membri dell'organizzazione vedono i dati delle osservazioni e delle operazioni colturali di questa azienda, secondo le impostazioni qui sotto.",
    observations: "Osservazioni",
    observationsHint: "monitoraggio, trappole",
    visibleToOrg: "Visibili org",
    private: "Private",
    cropOperations: "Operazioni colturali",
    cropOperationsHint: "irrigazione, concimazione, trattamenti…",
    saveError: "Errore nel salvataggio",
    readonlyHint: "Solo il responsabile può modificare queste impostazioni.",
    selectOrgPlaceholder: "Seleziona organizzazione...",
    link: "Collega",
    inviteModalTitle: "Invita Membro al Team",
    inviteViaLink: "Invita tramite link",
    inviteContacts: "Invita Contatti",
    inviteCodeDesc:
      "Genera un link monouso da condividere — non serve conoscere l'email. Dopo aver generato il link condividete il link via email o whatsapp. Se invitate più di una persona generate un link a persona.",
    inviteContactsDesc:
      "Aggiungi direttamente un utente con cui condividi già un'altra azienda.",
    role: "Ruolo",
    loadingContacts: "Caricamento contatti...",
    noContactsAvailable:
      "Nessun contatto disponibile. I contatti sono gli utenti con cui condividi già almeno un'altra azienda.",
    add: "Aggiungi",
    close: "Chiudi",
    loginEmail: "Email di login",
    emailPlaceholder: "email@esempio.it",
    important: "Importante",
    emailInviteWarning:
      "Poderi non invia automaticamente l'email. Se l'utente è già in poderi vede un avviso appena entra. Se non è in poderi consigliamo di avvisarlo personalmente, via email o altro.",
    cancel: "Annulla",
    sendInvite: "Invia Invito",
    linkExpiry: "Scadenza link",
    oneDay: "1 giorno",
    sevenDays: "7 giorni",
    thirtyDays: "30 giorni",
    noExpiry: "Nessuna scadenza",
    copied: "Copiato!",
    copy: "Copia",
    deleteThisInvite: "Elimina questo invito",
    generateLink: "Genera link",
    transferModalTitle: "Trasferisci Responsabilità",
    transferConfirmPrefix:
      "Vuoi trasferire la responsabilità del farm center a",
    transferConfirmWarning:
      "Non potrai più rimuovere altri membri o invitare persone.",
    confirm: "Conferma",
    removeModalTitle: "Rimuovi membro dal team",
    removeConfirmPrefix: "Vuoi rimuovere",
    removeConfirmSuffix: "dal team di questa azienda?",
    removeConfirmDataLoss:
      "L'utente perderà l'accesso all'azienda e a tutti i suoi dati.",
    farmFallback: "Azienda",
    breadcrumbFarms: "Aziende",
    breadcrumbTeam: "Team",
    whatsappFarmFallback: "un'azienda agricola",
    whatsappInviteMessage:
      "Sei stato invitato a unirti al team di {farm} su Poderi. Clicca qui per accettare: {link}",
    errorGeneratingLink: "Errore generazione link",
    errorDeleting: "Errore eliminazione",
    confirmCancelInvitation: "Annullare questo invito?",
    genericError: "Errore",
    errorLoadingContacts: "Errore caricamento contatti",
    errorAdding: "Errore durante l'aggiunta",
    errorRemoving: "Errore durante la rimozione",
    confirmLeaveTeam: "Vuoi uscire dal team di questa azienda?",
    confirmUnlinkOrg: "Scollegare questa organizzazione?",
  },
  chatListView: {
    title: "Messaggi",
    newMessage: "Nuovo messaggio",
    searchConversationPlaceholder: "Cerca conversazione...",
    loadingChats: "Caricamento chat...",
    retry: "Riprova",
    noResults: "Nessun risultato",
    startConversation: "Inizia la conversazione...",
    noMessages: "Nessun messaggio",
    noChats: "Nessuna chat",
    noChatsHint: "Avvia una conversazione con i tuoi team o contatti",
    newConversation: "Nuova conversazione",
    farmGroupTab: "Gruppo azienda",
    directMessageTab: "Messaggio diretto",
    searchFarmGroupPlaceholder: "Cerca gruppo azienda...",
    noFarmsAvailable: "Nessuna azienda disponibile",
    searchContactPlaceholder: "Cerca contatto...",
    loading: "Caricamento...",
    noContactsFound: "Nessun contatto trovato",
    farmGroupFallback: "Gruppo azienda",
    systemSenderName: "Poderi 2.MAI",
    adminSenderFallback: "Amministratore",
    directChatFallback: "Chat diretta",
  },
  chatRoomView: {
    participantSingular: "partecipante",
    participantPlural: "partecipanti",
    loadingMessages: "Caricamento messaggi...",
    loadPrevious: "Carica precedenti",
    sendFailed: "Invio fallito",
    sending: "In invio",
    read: "Letto",
    sent: "Inviato",
    noMessagesStart: "Nessun messaggio. Inizia tu!",
    writeMessagePlaceholder: "Scrivi un messaggio...",
    chatFallback: "Chat",
    farmGroupFallback: "Gruppo azienda",
    systemSenderName: "Poderi 2.MAI",
    adminSenderFallback: "Amministratore",
    directChatFallback: "Chat diretta",
    badgeFarm: "Gruppo",
    badgeDirect: "Diretto",
    badgeBroadcast: "Comunicazione",
    breadcrumbChat: "Chat",
  },
  chatAdminView: {
    title: "Messaggi — Admin",
    newBroadcastMessage: "Nuovo messaggio broadcast",
    loading: "Caricamento...",
    selectedCount: "{selected}/{total} selezionati",
    selectAll: "Tutti",
    selectNone: "Nessuno",
    searchNameOrEmailPlaceholder: "Cerca nome o email...",
    subjectOptionalLabel: "Oggetto (opzionale)",
    subjectPlaceholder: "Es: Aggiornamento colture",
    messageLabel: "Messaggio *",
    writeMessagePlaceholder: "Scrivi il messaggio...",
    recipientsCount: "{count} destinatari",
    send: "Invia",
    sentToCount: "Inviato a {sent}/{total} destinatari",
    recentThreads: "Thread recenti",
    refresh: "Aggiorna",
    searchRecipientPlaceholder: "Cerca destinatario...",
    repliesCount: "{count} risposte",
    noThreads: "Nessun thread",
    campaignsSent: "Campagne inviate",
    noSubject: "(senza oggetto)",
    recipientsAbbrev: "{count} dest.",
    noCampaigns: "Nessuna campagna",
    selectThreadHint:
      "Seleziona un thread dalla lista per visualizzare la conversazione",
    campaignLabel: "Campagna: {subject}",
    loadingMessages: "Caricamento messaggi...",
    replyPlaceholder: "Rispondi...",
    sendError: "Errore invio",
  },
  dssView: {
    title: "DSS - Supporto alle Decisioni",
    weatherStation: "Stazione meteo",
    addStation: "Aggiungi stazione",
    station: "Stazione",
    changeStation: "Cambia stazione",
    noStationBanner:
      "Nessuna stazione meteo associata. I modelli DSS richiedono dati meteo.",
    chooseStation: "Scegli stazione",
    myStations: "Le mie stazioni",
    irrigation: "Irrigazione",
    irrigationDesc:
      "Calcolo del fabbisogno idrico, bilancio idrico e gestione degli interventi irrigui.",
    nutrition: "Concimazione",
    nutritionDesc:
      "Piani di fertilizzazione, bilancio degli elementi nutritivi e gestione degli apporti.",
    dashboard: "Dashboard",
    dashboardDesc:
      "Pannello personalizzabile con i modelli preferiti su più campi, aggiornabile con un click.",
    selectWeatherStation: "Seleziona stazione meteo",
    cancel: "Annulla",
    save: "Salva",
    home: "Home",
    farms: "Aziende",
    farmFallback: "Azienda",
    dssBreadcrumb: "DSS",
  },
  stationWeatherPanel: {
    loadingWeatherData: "Caricamento dati meteo...",
    dataUpdated: "Dati aggiornati",
    dataNotUpdated: "Dati non aggiornati",
    updatedAt: "Aggiornato al {date}",
    dataAvailablePercentage: "{percent}% di dati disponibili",
    forecastFor: "Previsioni {name}",
    historicalDataFor: "Dati ultimi 10gg stazione - {name}",
    noHistoricalData: "Nessun dato storico disponibile.",
    selectStationHint: "Seleziona una stazione per visualizzare i dati meteo.",
    dayNamesShort: "Dom,Lun,Mar,Mer,Gio,Ven,Sab",
    tempMin: "T min",
    tempAvg: "T media",
    tempMax: "T max",
    rain: "Pioggia",
    temperatureAxis: "Temperatura (°C)",
    rainAxis: "Pioggia (mm)",
    weatherDataFetchError: "Errore nel recupero dei dati meteo",
    networkError: "Errore di rete",
  },
  weatherStationForm: {
    editTitle: "Modifica stazione meteo",
    addTitle: "Aggiungi stazione meteo",
    provider: "Provider",
    stationName: "Nome stazione",
    stationId: "ID stazione",
    stationPosition: "Posizione stazione",
    mapHint:
      "Clicca sulla mappa per posizionare la stazione, oppure inserisci le coordinate manualmente.",
    latitude: "Latitudine",
    longitude: "Longitudine",
    publicKey: "Chiave pubblica",
    publicKeyPlaceholder: "Public key",
    privateKey: "Chiave privata",
    privateKeyPlaceholder: "Private key",
    username: "Utente",
    usernamePlaceholder: "Username",
    password: "Password",
    passwordPlaceholder: "Password",
    dataVisibility: "Visibilità dati",
    accessFarm: "Azienda",
    accessFarmDesc: "Visibile ai team delle aziende che la usano",
    accessOrg: "Org",
    accessOrgDesc: "Visibile alle organizzazioni selezionate",
    accessPublic: "Pubblica",
    accessPublicDesc: "Visibile a tutti gli utenti",
    accessPrivate: "Riservata",
    accessPrivateDesc: "Solo tu",
    providerPesslDesc: "Chiave pubblica + privata",
    providerNetsensDesc: "Utente + password",
    shareWithOrgs: "Condividi con organizzazioni",
    shareWithOrgsHint:
      "Seleziona le organizzazioni che potranno vedere questa stazione.",
    noOrgsAvailable:
      "Nessuna organizzazione disponibile. Devi far parte di almeno un'organizzazione per usare questa opzione.",
    historicalDataRecovery: "Recupero dati storici",
    historicalDataRecoveryHint:
      "Opzionale. Se la stazione ha dati nel passato, indica da quando recuperarli. Verrà eseguito alla prima sincronizzazione.",
    recoverDataFrom: "Recupera dati dal",
    cancel: "Annulla",
    update: "Aggiorna",
    saveStation: "Salva stazione",
    station: "Stazione",
    farm: "Azienda",
    requiredFieldsError:
      "Compila tutti i campi obbligatori (nome, coordinate).",
    stationIdRequiredError: "ID stazione obbligatorio.",
    pesslKeysRequiredError:
      "Inserisci chiave pubblica e privata per METOS/PESSL.",
    netsensCredentialsRequiredError: "Inserisci utente e password per Netsens.",
    saveError: "Errore durante il salvataggio",
  },
  stationManager: {
    noOwnStations: "Nessuna stazione creata da te.",
    edit: "Modifica",
    public: "Pubblica",
    private: "Riservata",
  },
  operationObservationForm: {
    invalidTypeTitle: "Tipo non valido",
    invalidTypeValue:
      "Il valore {type} non è un tipo valido per questo componente.",
    invalidTypeValid: "Tipi validi:",
    selectType: "Seleziona {typeLabel}",
    selectField: "Seleziona Appezzamento",
    changeType: "Cambia {typeLabel}",
    season: "Stagione",
    fieldSelectLabel: "Appezzamento (seleziona uno o più appezzamenti)",
    allFields: "Tutti",
    colField: "Appezzamento",
    colCrop: "Coltura",
    colAreaHa: "Sup. (ha)",
    notAvailable: "N/D",
    fieldsSelectedCount: "{count} appezzamento/i selezionato/i",
    totalSurface: "Superficie totale",
    treatPartialSurface: "Tratta solo una parte della superficie",
    surfacePercHint: "→ {ha} ha ({perc}%) su {totalHa} ha totali",
    fields: "Appezzamenti",
    surface: "Superficie",
    surfacePercOf: "({perc}% di {totalHa} ha)",
    changeFields: "Cambia Appezzamenti",
    date: "Data",
    warning: "Attenzione",
    futureDateWarning:
      "la data selezionata è nel futuro. Assicurati che sia corretta.",
    plannedActivity: "Attività pianificata",
    plannedActivityHint:
      "la data è nel futuro, questa operazione verrà salvata come pianificata.",
    completionLabelPrefix: "Questa operazione è",
    plannedLower: "pianificata",
    completionLabelSuffix: "e non ancora eseguita.",
    markCompleted: "Segna come completata",
    cancelActivity: "Annulla attività",
    statusWillUpdate: "lo stato verrà aggiornato al salvataggio.",
    undoChange: "Annulla modifica",
    trap: "Trappola",
    newTrap: "Nuova trappola",
    addTrap: "Aggiungi trappola",
    selectTrapPlaceholder: "Seleziona una trappola...",
    cancel: "Annulla",
    save: "Salva",
    waterQuantity: "Quantità di acqua (l/ha)",
    waterQuantityPlaceholder: "es. 500",
    products: "Prodotti",
    totalArea: "Area totale",
    addAnotherProduct: "Aggiungi un altro prodotto",
    harvestQuantity: "Quantità Raccolta",
    unitOfMeasure: "Unità di misura",
    uomQuintals: "q (quintali)",
    uomTonnes: "t (tonnellate)",
    uomGrams: "g (grammi)",
    uomLiters: "l (litri)",
    totalQuantity: "Quantità totale",
    quantityPerHectare: "Quantità per ettaro",
    surfaceAutoCalcHint:
      "Superficie: {ha} ha — modifica un campo per calcolare l'altro automaticamente.",
    quantity: "Quantità",
    olivFlyCountTitle: "Conteggio punture - Mosca dell'olivo",
    olivFlyFullCountTitle: "Conteggio stadi - Mosca completa",
    notes: "Note",
    notesPlaceholder: "Note aggiuntive...",
    newProduct: "Nuovo Prodotto",
    selectAtLeastOneField: "Seleziona almeno un campo",
    dateRequired: "La data è obbligatoria.",
    selectOrCreateTrap:
      "Seleziona una trappola o creane una nuova con il pulsante +",
    saveError: "Errore nel salvataggio: {error}",
    operationFallbackName: "Operazione {id}",
    observationFallbackName: "Osservazione {id}",
    statusPlanned: "Pianificata",
    statusDone: "Completata",
    statusCancelled: "Annullata",
    typeLabelOperation: "Operazione Colturale",
    typeLabelObservation: "Osservazione",
  },
  addPlotsView: {
    back: "Indietro",
    title: "Importa Appezzamenti",
    dropTitle: "Trascina il file qui",
    dropHintWktColumn: "colonna WKT, EPSG:3003",
    dropHintPcgStrongPrefix: "È fortemente consigliato caricare il dato dal",
    dropHintPcgStrong: "PCG (Piano Colturale Grafico)",
    dropHintPcgSuffix: "per la massima compatibilità futura.",
    dropHintFieldsPrefix:
      "Se si utilizzano altri formati, si consiglia di includere il campo",
    dropHintFieldsNome: "(nome dell'appezzamento) e il campo",
    dropHintFieldsColtura:
      "(nome della coltura): in questo modo gli appezzamenti verranno configurati automaticamente già al momento dell'importazione.",
    dropHintMuted:
      "Se i dati non sono disponibili, è possibile disegnare i poligoni e aggiungere le informazioni in un secondo momento.",
    selectFile: "Seleziona file",
    warningsTitle: "Avvertimenti:",
    analyzingFile: "Analisi file in corso...",
    crsNotFoundTitle: "Proiezione non trovata",
    crsNotFoundText1:
      "Il file non contiene informazioni sul sistema di riferimento delle coordinate.",
    crsNotFoundText2:
      "Seleziona la proiezione corretta per procedere con l'importazione.",
    crsOther: "Altro",
    crsCustomPlaceholder: "es. 32632",
    crsCentralNorthItaly: "Italia centro-nord",
    crsCentralSouthItaly: "Italia centro-sud",
    crsDecimalDegrees: "gradi decimali",
    cancel: "Annulla",
    continue: "Continua",
    plotsCount: "{count} appezzamenti",
    withCropCount: "{count} con coltura",
    importCount: "Importa {count} appezzamenti",
    createFieldsLabel:
      "Crea anche le coltivazioni (assegna colture agli appezzamenti)",
    detectedYear: "Anno rilevato dal file:",
    seasonLabel: "Stagione",
    selectSeasonPlaceholder: "Seleziona stagione",
    createNewSeason: "Crea nuova stagione",
    seasonNamePlaceholder: "Nome stagione (es. 2026)",
    create: "Crea",
    chooseCropPerPlotHint:
      "La coltura va scelta per ogni appezzamento nella tabella.",
    useAsName: "Usa come nome:",
    defaultNamePattern: "Appezzamento 1, 2, 3…",
    selectDeselectAll: "Seleziona/deseleziona tutti",
    colName: "Nome",
    colArea: "Sup. (m²)",
    colCrop: "Coltura",
    colNote: "Note",
    colGeometryTitle: "Geometria / Esplodi multipoligono",
    namePlaceholder: "Nome",
    searchCropPlaceholder: "Cerca coltura...",
    zoomToPolygon: "Zoom al poligono",
    explodeIntoPolygons: "Esplodi in {count} poligoni singoli",
    importCompletedTitle: "Importazione completata",
    plotsImported: "{count} appezzamenti importati.",
    fieldsCreated: "{count} coltivazioni create.",
    backToFarm: "Torna all'azienda",
    fileTooLarge:
      "Il file è troppo grande ({size} MB). Dimensione massima consentita: 10 MB.",
    errorPrefix: "Errore: {message}",
    csvParseError: "Errore parsing CSV.",
    noPlotsFound: "Nessun appezzamento trovato nel file.",
    invalidJsonFile: "File JSON non valido.",
    serverError: "Errore dal server.",
    plotDefaultName: "Appezzamento {n}",
    cropUnknownNote: "colt?c: {code}",
    seasonNameRequired: "Inserisci un nome per la stagione.",
    seasonCreateError: "Errore creazione stagione.",
    selectSeasonOrDeselectAlert:
      'Seleziona una stagione per creare le coltivazioni, oppure deseleziona "Crea anche le coltivazioni".',
    unnamed: "Senza nome",
  },
  plotEnrichmentView: {
    pageTitle: "Arricchimento Open Data - {farm}",
    defaultFarmName: "Azienda",
    updateOutdated: "Aggiorna Obsoleti ({count})",
    enrichAll: "Arricchisci Tutti",
    stop: "Interrompi",
    processingInProgress: "Elaborazione in corso...",
    plotsCompleted: "{done} / {total} plot completati",
    processingPlot: "Elaborando: {name}",
    plotFallbackName: "Plot {id}",
    totalPlots: "Plot totali",
    enriched: "Arricchiti",
    outdated: "Obsoleti",
    notEnriched: "Non arricchiti",
    colPlot: "Plot",
    colStatus: "Stato",
    colVersion: "Versione",
    colEnrichedOn: "Arricchito il",
    colActions: "Azioni",
    enrich: "Arricchisci",
    update: "Aggiorna",
    plotsSelected: "{count} plot selezionati",
    enrichSelected: "Arricchisci Selezionati",
    deselectAll: "Deseleziona tutti",
    enrichmentDetailsTitle: "Dettagli Arricchimento",
    enrichmentDataTab: "Dati Arricchimento",
    rawJsonTab: "JSON Raw",
    statusProcessing: "Elaborando...",
    statusError: "Errore",
    statusCompleted: "Completato",
    statusNotEnriched: "Non arricchito",
    statusOutdated: "Obsoleto",
    statusUpdated: "Aggiornato",
    noDataAvailable: "Nessun dato disponibile",
    jsonParseErrorPrefix: "Errore nel parsing JSON: {message}",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbEnrichment: "Arricchimento Open Data",
  },
  irrigationView: {
    title: "Irrigazione",
    defaultFarmName: "Azienda",
    tabModel: "Modello",
    tabSensors: "Sensori",
    noSeasonAvailable:
      "Nessuna stagione disponibile. Crea una stagione per iniziare.",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbDss: "Dss",
    breadcrumbIrrigation: "Irrigazione",
    configTitle: "Irrigazione",
    colPlot: "Appezzamento",
    colCrop: "Coltura",
    colDeficit: "Deficit (mm)",
    colAlert: "Allerta",
    colLastIrrigation: "Ultima irrigazione",
    popupDeficit: "Deficit",
    operationLabel: "Irriga",
    operationModalTitle: "Registra irrigazione",
    fieldQuantity: "Quantita (mm)",
  },
  nutritionView: {
    title: "Concimazione",
    defaultFarmName: "Azienda",
    noSeasonAvailable:
      "Nessuna stagione disponibile. Crea una stagione per iniziare.",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbDss: "Dss",
    breadcrumbNutrition: "Concimazione",
    configTitle: "Concimazione",
    colPlot: "Appezzamento",
    colCrop: "Coltura",
    colAlert: "Allerta",
    colLastFertilization: "Ultima concimazione",
    operationLabel: "Concima",
    operationModalTitle: "Registra concimazione",
  },
  modelFarmSection: {
    loadingFields: "Caricamento Appezzamenti...",
    noFieldsFound: "Nessun campo trovato per questa stagione.",
    noSoilAnalysis: "Nessuna analisi del suolo configurata.",
    addSoilAnalysis: "Aggiungi analisi del suolo",
    dssNotAvailable:
      "DSS non disponibile per la coltura selezionata. La mappa dell'azienda è comunque consultabile.",
    tabMap: "Mappa",
    noFieldsWithGeometry: "Nessun appezzamento con geometria disponibile.",
    noSoilAnalysisDetail:
      "Nessuna analisi del suolo configurata. I modelli utilizzano dati pedologici per calcoli più accurati.",
    summaryFields: "Campi",
    summaryIncompatible: "Non compatibili",
    summaryCompleted: "Completati",
    summaryCritical: "Critici",
    summaryInProgress: "In corso",
    refreshAll: "Aggiorna tutti",
    stop: "Ferma",
    tabTable: "Tabella",
    modelNotAvailable: "Modello non disponibile",
    defaultOperationLabel: "Registra",
    colPlot: "Appezzamento",
    colCrop: "Coltura",
    colAlert: "Allerta",
    colLastOperation: "Ultima op.",
    colActions: "Azioni",
    unknownError: "Errore sconosciuto",
    defaultOperationModalTitle: "Registra operazione",
  },
  irriRender: {
    updatedAt: "Aggiornato al {date}",
    last7Days: "Ultimi 7 giorni",
    etcAvg: "ETc media",
    etcCumulative: "ETc cumulata",
    rain: "Pioggia",
    season: "Stagione",
    startDate: "Data inizio",
    endDate: "Data fine",
    waterStressDays: "Giorni di stress idrico",
    daysPlural: "giorni",
    daysSingular: "giorno",
    autoIrrigations: "Irrigazioni automatiche",
    performedIrrigations: "Irrigazioni effettuate",
    settings: "Impostazioni",
    autoIrrigation: "Irrigazione automatica",
    autoIrrigationHelp:
      "Quando attiva, il modello simulerà automaticamente gli interventi irrigui consigliati.",
    autoIrrigationMm: "Irrigazione auto (mm)",
    performedIrrigationMm: "Irrigazione effettuata (mm)",
    colDate: "Data",
    colPhenology: "Fenologia",
    colCriticalThreshold: "Soglia critica",
    colOptimalThreshold: "Soglia ottimale",
    colDeficit: "Deficit",
    colRainMm: "Pioggia (mm)",
    colAdvice: "Consiglio",
    chartBalance: "Bilancio",
    chartRain: "Pioggia",
    irrigateAmount: "Irriga {amount} mm",
  },
  nutriRender: {
    colItem: "Voce",
    colInputs: "Entrate (kg/ha)",
    colOutputs: "Uscite (kg/ha)",
    yieldNotSet:
      "Resa non impostata — il modello usa un valore di default (50 q/ha).",
    editField: "Modifica campo",
    nutrientBalance: "Bilancio nutrienti",
    recommendedDose: "Dose consigliata: {value} kg/ha",
    applied: "Applicato: {value} kg/ha",
    excess: "Eccesso: {value} kg/ha",
    missing: "Mancante: {value} kg/ha",
    fertilizations: "Concimazioni",
    add: "Aggiungi",
    noFertilizationRegistered: "Nessuna concimazione registrata.",
    colDate: "Data",
    colProduct: "Prodotto",
    colQuantity: "Quantità",
    totals: "Totali",
    fertilization: "Concimazione",
    confirmDeleteTitle: "Conferma eliminazione",
    confirmDeleteText: "Eliminare questa concimazione del",
    deleteCannotBeUndone: "L'operazione non può essere annullata.",
    cancel: "Annulla",
    delete: "Elimina",
    balance: "Bilancio",
    nitrogen: "Azoto (N)",
    rainInputs: "Apporti da pioggia",
    previousCrop: "Coltura precedente",
    previousOrgFert: "Fertiliz. organica prec.",
    mineralization: "Mineralizzazione",
    greenManure: "Sovescio",
    cropRequirement: "Fabbisogno coltura",
    leaching: "Lisciviazione",
    volatilization: "Volatilizzazione",
    denitrification: "Denitrificazione",
    phosphorus: "Fosforo (P)",
    soilInputs: "Apporti dal suolo",
    potassium: "Potassio (K)",
  },
  waterSensorViewer: {
    from: "Dal",
    loading: "Caricamento…",
    refresh: "Aggiorna",
    noSensorData: "Nessun dato sensore per la stazione nel periodo indicato.",
    soilMoistureComparison: "Confronto umidità suolo — tutte le unità",
    units: "Unità",
    unitName: "Unità {id}",
    showAllSeries: "Attiva tutti",
    hideAllSeries: "Escludi tutti",
    toggleSeriesHint: "Mostra/nascondi nel grafico",
    soilTempA: "T suolo A (°C)",
    soilTempB: "T suolo B (°C)",
    leafA: "Foglia A",
    leafB: "Foglia B",
    radiation: "Radiazione (W/m2)",
    colDateTime: "Data/ora",
    stationNotConfigured: "Stazione meteo non configurata per questa azienda.",
    loadError: "Errore nel caricamento",
    downloadCsv: "Scarica CSV",
    configureSensors: "Configura sensori",
    configureSensorsTitle: "Configurazione unità sensore",
    colUnit: "Unità",
    colActive: "Attivo",
    colName: "Nome",
    colLat: "Lat",
    colLon: "Lon",
    save: "Salva",
    saveAll: "Salva tutto",
    close: "Chiudi",
    delete: "Elimina",
    addUnit: "Aggiungi unità",
    addUnitPlaceholder: "ID unità",
    noUnitsConfig: "Nessuna unità trovata per questa stazione.",
    saveError: "Errore durante il salvataggio",
    hasDataHint: "Ha dati",
    noDataHint: "Nessun dato ricevuto",
    tabChart: "Grafico",
    tabMap: "Mappa",
    tabRadiation: "Ombreggiamento",
    shadingComparison: "Ombreggiamento — radiazione unità (ombra) vs stazione (pieno sole)",
    shadingPercent: "% ombreggiamento",
    positionTitle: "Posiziona unità {id}",
    positionHint:
      "Clicca sulla mappa per impostare le coordinate del sensore. Il pallino rosso è la stazione, quello blu è il sensore.",
    stationMarker: "Stazione",
  },
  sensorMap: {
    noGeoUnits: "Nessuna unità con coordinate configurate.",
    unitFallbackName: "Unità {id}",
    dateLabel: "Data",
    sensorTypeLabel: "Sensore",
    wvcA: "Contenuto idrico A",
    wvcB: "Contenuto idrico B",
    noValue: "Nessun dato",
    noDataForDate: "{count} unità senza dato per la data selezionata.",
  },
  orgAdminView: {
    pageTitlePrefix: "Gestione Org -",
    organization: "Organizzazione",
    selectOrgPlaceholder: "Seleziona Org...",
    members: "membri",
    settings: "Impostazioni",
    inviteUser: "Invita Utente",
    loading: "Caricamento...",
    errorPrefix: "Errore:",
    selectOrgToManage:
      "Seleziona un'organizzazione dal menu in alto per gestirla.",
    usersWithoutPeopleProfile: "Utenti senza profilo People",
    creating: "Creazione...",
    createMissingProfiles: "Crea profili mancanti",
    invitationsSentPending: "Inviti Inviati — In Attesa di Risposta",
    invitedBy: "inviato da",
    cancel: "Annulla",
    pendingMembershipRequests: "Richieste di Adesione Pendenti",
    accept: "Accetta",
    reject: "Rifiuta",
    searchMembersPlaceholder:
      "Cerca per nome, email, tag, admin, advisor, membro…",
    farmSingular: "azienda",
    farmPlural: "aziende",
    roleMember: "Membro",
    roleAdvisor: "Advisor",
    roleAdmin: "Admin",
    roleExternal: "Esterno",
    pendingActivation: "in attesa di primo accesso",
    pendingActivationTitle:
      "Utente creato ma non ha ancora effettuato il primo accesso",
    tagsPlaceholder: "es. classe 3B, provincia PI (separati da virgola)",
    addTags: "+ tag",
    colTags: "Tag",
    cannotChangeOwnRole: "Non puoi modificare il tuo stesso ruolo",
    you: "tu",
    removeFromOrgTitle: "Rimuovi dall'organizzazione",
    noMembersFound: "Nessun membro trovato",
    farms: "Aziende",
    newFarm: "+ Nuova",
    searchFarmsPlaceholder: "Cerca aziende...",
    showAllTitle: "Mostra tutte",
    onlyWithoutMembersTitle: "Solo senza membri",
    all: "Tutte",
    withoutTeam: "Senza team",
    owner: "Owner",
    removeFromTeamTitle: "Rimuovi dal team",
    transferOwnershipTitle: "Trasferisci proprietà",
    confirmTransferOwnershipPre: "Rendere",
    confirmTransferOwnershipMid: "proprietario dell'azienda",
    noMembers: "Nessun membro",
    noFarmsFound: "Nessuna azienda trovata",
    importIntro:
      "Inserisci i dati direttamente nella tabella o incolla da Excel (Ctrl+V). Premi <strong>Verifica</strong> per controllare i dati, poi <strong>Importa</strong> per salvare.",
    importFarms: "Import Aziende",
    reset: "Reset",
    verifying: "Verifica...",
    verify: "Verifica",
    importing: "Importazione...",
    import: "Importa",
    row: "Riga",
    importMembers: "Import Tecnici / Utenti",
    selectRoleTitle: "Seleziona Ruolo",
    farmLabel: "Azienda:",
    roleOwner: "Proprietario",
    roleGrower: "Coltivatore",
    roleConsultant: "Consulente",
    confirm: "Conferma",
    removeFromTeamModalTitle: "Rimuovi dal Team",
    confirmRemoveFromTeamPre: "Vuoi rimuovere",
    confirmRemoveFromTeamMid: "dal team di",
    remove: "Rimuovi",
    removeMemberModalTitle: "Rimuovi Membro",
    confirmRemoveMemberPre: "Vuoi rimuovere",
    confirmRemoveMemberPost: "dall'organizzazione?",
    removeMemberAlsoFromTeams:
      "Verranno rimossi anche dai team delle aziende dell'organizzazione.",
    orgSettingsTitle: "Impostazioni Organizzazione",
    name: "Nome",
    shortName: "Nome breve",
    description: "Descrizione",
    publiclyVisible: "Visibile pubblicamente",
    acceptMembershipRequests: "Accetta richieste di adesione",
    save: "Salva",
    inviteUserToOrgTitle: "Invita Utente all'Organizzazione",
    email: "Email",
    emailPlaceholder: "email@esempio.it",
    sendInvite: "Invia Invito",
    colFarmName: "Nome Azienda",
    colTown: "Sede operativa",
    colRegisteredOffice: "Sede legale",
    colLat: "Lat",
    colLon: "Lon",
    colPractice: "Pratica",
    colNote: "Note",
    colEmail: "Email",
    colFirstName: "Nome",
    colLastName: "Cognome",
    colMobile: "Cellulare",
    colType: "Tipo",
    tabManagement: "Gestione",
    tabMap: "Mappa",
    tabFarms: "Aziende",
    tabImport: "Import",
    colFarm: "Azienda",
    colLocation: "Località",
    colArea: "Superficie (ha)",
    colPlots: "Appezzamenti",
    colCrops: "Colture",
    colAnimals: "Animali",
    colLastSync: "Ultimo Sync",
    colTeam: "Team",
    filterByTechnician: "Filtra per tecnico",
    allTechnicians: "Tutti i tecnici",
    edit: "Modifica",
    tabTechnicians: "Tecnici",
    colName: "Nome",
    colProfile: "Profilo",
    colRole: "Ruolo",
    colFarms: "Aziende",
    colLastAccess: "Ultimo accesso",
    breadcrumbHome: "Home",
    membersImportHelp:
      'Email, nome e cognome sono obbligatori. Ruolo: lascia vuoto per un membro semplice, oppure scrivi "advisor" (agronomi dell\'organizzazione) o "external" (soggetti pubblici esterni per le revisioni).',
    breadcrumbOrganizations: "Organizzazioni",
    breadcrumbOrgManagement: "Gestione Org",
    roleUndefined: "Non definito",
    userFallback: "Utente ({uid})",
    genericError: "Errore",
    roleUpdateError: "Errore aggiornamento ruolo",
    confirmCancelInvite: "Annullare questo invito?",
    importErrorMsg: "Errore durante l'importazione",
    importRowsWithErrorsSingular:
      "{count} riga con errori — controlla le celle evidenziate in rosso",
    importRowsWithErrorsPlural:
      "{count} righe con errori — controlla le celle evidenziate in rosso",
    farmsVerifiedMsg: "{count} aziende verificate — premi Importa per salvare",
    farmsImportedMsg: "Importazione completata: {count} aziende inserite",
    membersVerifiedMsg:
      "{count} utenti verificati ({newCount} nuovi, {existCount} esistenti) — premi Importa per salvare",
    invitedCount: "{count} invitati",
    provisionedCount: "{count} utenti creati",
    assignedCount: "{count} assegnati",
    newProfilesCount: "{count} nuovi profili",
    importCompletedMsg: "Importazione completata: {parts}",
    editFarmData: "Modifica dati azienda",
    cloneFarm: "Clona",
    cloneFarmTitle: "Clona azienda",
    cloneFarmChooseSourceTitle: "Clona azienda esistente",
    cloneFarmChooseSourceLabel: "Azienda da clonare",
    cloneFarmChooseSourcePlaceholder: "Seleziona azienda...",
    cloneFarmSourcePre: "Clonazione di",
    cloneFarmNewName: "Nome nuova azienda",
    cloneFarmNewNamePlaceholder: "Nome della nuova azienda",
    cloneFarmSection: "Cosa clonare",
    cloneFarmStructure: "Appezzamenti, campi, stagioni",
    cloneFarmSoil: "Suolo",
    cloneFarmAnimals: "Mandria e animali",
    cloneFarmTeam: "Team",
    cloneFarmTraps: "Trappole",
    cloneFarmProducts: "Prodotti di magazzino",
    cloneFarmEvents: "Eventi animali",
    cloneFarmOliverecStructure: "Oliverec — struttura (piante, elementi geo)",
    cloneFarmObservations: "Osservazioni",
    cloneFarmOperations: "Operazioni",
    cloneFarmOliverecSurveys: "Oliverec — rilievi",
    cloneFarmFilterBySeason: "Filtra per stagione (vuoto = tutte)",
    cloneFarmOperationsRequiresProducts:
      "Richiede 'Prodotti di magazzino' attivo",
    cloneFarmEventsRequiresAnimals: "Richiede 'Mandria e animali' attivo",
    cloneFarmOliverecSurveysRequiresStructure:
      "Richiede 'Oliverec — struttura' attivo",
    cloneFarmSeasonFilterRequiresStructure:
      "Richiede 'Appezzamenti, campi, stagioni' attivo",
    cloneFarmNameRequired: "Inserisci il nome della nuova azienda",
    cloneFarmCloning: "Clonazione in corso...",
    cloneFarmSubmit: "Clona azienda",
    cloneFarmSuccess: "Azienda clonata con successo",
  },

  // ── AppInitializing ──────────────────────────────────────────────────────────
  appInitializing: {
    retry: "Riprova",
    loading: "Caricamento...",
    configTitle: "Caricamento configurazione",
    configMessage: "Connessione al server in corso...",
    databaseTitle: "Inizializzazione database",
    databaseMessage: "Preparazione del database locale...",
    authTitle: "Ripristino sessione",
    authMessage: "Verifica autenticazione...",
    readyTitle: "Quasi pronto",
    readyMessage: "Caricamento completato",
    errorTitle: "Impossibile connettersi",
    errorMessage:
      "Il server non è raggiungibile e non sono disponibili dati locali. Controlla la connessione e riprova.",
  },

  // ── AuthComponent ────────────────────────────────────────────────────────────
  authComponent: {
    profileAndPreferences: "Profilo e Preferenze",
  },

  // ── CreditsView ──────────────────────────────────────────────────────────────
  creditsView: {
    title: "Credits",
    instradareTitle: "Credits Instradare",
    psrTitle: "Credits PSR Regione Toscana",
    psrText:
      'La web-app Poderi è stata sviluppata da <a class="credit-link" href="http://www.aedit.it/" target="_blank" rel="noopener">AEDIT srl</a>, grazie anche al finanziamento del PSR 2014-2020 della Regione Toscana, Sottomisura 16.2 - Annualità 2022, progetto <a class="credit-link" href="https://progetto.poderi.app/" target="_blank" rel="noopener">Poderi</a>.',
    fairshareTitle: "Credits Fairshare",
    fairshareText:
      'La web-app Poderi è stata sviluppata da <a class="credit-link" href="http://www.aedit.it/" target="_blank" rel="noopener">AEDIT srl</a>, grazie anche ai finanziamenti del progetto <a class="credit-link" href="https://www.h2020fairshare.eu/" target="_blank" rel="noopener">H2020 FAIRshare</a>.',
    pisaTitle: "Università di Pisa",
    pisaText:
      "Le funzionalità legate all'allevamento ovino sono state realizzate in collaborazione con il <strong>Centro di ricerche agro-ambientali \"Enrico Avanzi\" (CiRAA)</strong> e con il <strong>Dipartimento di Scienze Agrarie, Alimentari e Agro-ambientali</strong>, dell'Università di Pisa.",
  },

  // ── ProfileView ──────────────────────────────────────────────────────────────
  profileView: {
    title: "Profilo Utente",
    loading: "Caricamento...",
    language: "Lingua",
    personalData: "Dati Personali",
    name: "Nome",
    email: "Email",
    profile: "Profilo",
    phone: "Telefono",
    phonePlaceholder: "Inserisci telefono",
    save: "Salva",
    invitationsReceived: "Inviti Ricevuti",
    invitation: "Invito",
    companyTeam: "Team azienda",
    organization: "Organizzazione",
    fromInviter: "da {name}",
    accept: "Accetta",
    reject: "Rifiuta",
    acceptInvitation: "Accetta Invito",
    alreadyHasProfile: "Hai già un profilo in un'altra organizzazione.",
    newProfileWillBeCreated: "Accettando, verrà creato un nuovo profilo",
    associatedTo: "associato a",
    canChangeProfileName:
      "Puoi cambiare il nome del profilo prima di confermare.",
    aboutToJoin: "Stai per unirti a",
    profileName: "Nome profilo",
    profileNamePlaceholder: "Es. Mario Rossi — NomeOrg",
    visibleToOtherMembers: "Visibile agli altri membri dell'organizzazione",
    cancel: "Annulla",
    confirmAndJoin: "Conferma e Unisciti",
    myOrganizations: "Le mie Organizzazioni",
    roleAdmin: "Amministratore",
    roleAdvisor: "Advisor",
    roleMember: "Membro",
    roleExternal: "Esterno",
    leave: "Esci",
    noOrganizations: "Non fai parte di nessuna organizzazione",
    availableOrganizations: "Organizzazioni Disponibili",
    membersCount: "{count} membri",
    requestSent: "Richiesta inviata",
    requestMembership: "Richiedi adesione",
    noPublicOrganizations: "Nessuna organizzazione pubblica disponibile",
    newKey: "Nuova chiave",
    apiKeyDescription:
      "Le API KEY sono delle chiavi segrete da usare per accedere alle API in modo programmatico. Se un altro sistema deve poter accedere a poderi in automatico lo può fare generando una API KEY che andrai poi a condividere in maniera sicura nell'altra applicazione. Se non hai capito non ti preoccupare, probabilmente non ti servono :)",
    noApiKeys:
      "Nessuna API key. Creane una per accedere alle API in modo programmatico.",
    createdOn: "Creata {date}",
    lastUsedOn: "Ultimo uso {date}",
    neverUsed: "Mai usata",
    newApiKey: "Nuova API key",
    newKeyNamePlaceholder: "Es. Script irrigazione",
    newKeyWarning:
      "La chiave ha accesso completo al tuo account. Conservala in modo sicuro — verrà mostrata una sola volta.",
    copyKeyNow: "Copia la chiave ora. Non sarà più visibile.",
    close: "Chiudi",
    generate: "Genera",
    genericError: "Errore",
    newProfileCreated:
      'Profilo creato per "{name}". Ricarica la pagina o effettua nuovamente il login per accedere con il nuovo profilo.',
    confirmLeaveOrg: 'Vuoi uscire dall\'organizzazione "{name}"?',
    nameRequired: "Nome obbligatorio",
  },

  adminUsersView: {
    title: "Utenti",
    loading: "Caricamento...",
    searchPlaceholder: "Cerca per nome, email, profilo, org...",
    onlyActive: "Solo attivi",
    hideInternal: "Nascondi interni",
    profileCount: "{count} profili",
    statusActive: "Attivo",
    statusInactive: "Inattivo",
    openDetail: "Apri dettaglio",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    colName: "Nome",
    colEmail: "Email",
    colProfile: "Profilo",
    colStatus: "Stato",
    colOrg: "Org",
    colFarms: "Aziende",
    colCreatedAt: "Creato il",
    colLastLogin: "Ultimo accesso",
  },

  adminUserDetailView: {
    title: "Dettaglio Utente",
    loading: "Caricamento...",
    saveSuccess: "Modifiche salvate.",
    account: "Account",
    name: "Nome",
    email: "Email",
    createdAt: "Creato il",
    lastLogin: "Ultimo accesso",
    currentProfile: "Profilo corrente",
    profileName: "Nome profilo",
    changed: "modificato",
    organization: "Organizzazione",
    noOrg: "— nessuna —",
    farms: "Aziende",
    profiles: "Profili",
    cancel: "Annulla",
    newProfile: "+ Nuovo profilo",
    noOrgOption: "— nessuna org —",
    createProfile: "Crea profilo",
    statusActive: "Attivo",
    statusInactive: "Inattivo",
    farmsAbbrev: "{count} az.",
    accountStatus: "Stato account",
    statusDisabled: "Disabilitato",
    disabledWarning: "L'utente non potrà accedere al sistema.",
    roles: "Ruoli",
    rolesChangedHint: "Ruoli modificati — salva per applicare.",
    back: "Indietro",
    save: "Salva",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    breadcrumbUsers: "Utenti",
    profileNameRequired: "Inserisci un nome profilo",
  },

  adminOrgsView: {
    title: "Organizzazioni",
    loading: "Caricamento...",
    searchPlaceholder: "Cerca org...",
    orgCount: "{count} org",
    newOrg: "+ Nuova org",
    colName: "Nome",
    colShortName: "Short name",
    colMembers: "Membri",
    colActiveFeatures: "Feature attive",
    colPublic: "Pubblica",
    editData: "Modifica dati",
    featureFlag: "Feature flag",
    noOrgsFound: "Nessuna org trovata",
    editModalTitle: "Modifica: {name}",
    newOrgModalTitle: "Nuova organizzazione",
    name: "Nome",
    fullNamePlaceholder: "Nome completo",
    shortName: "Nome breve",
    abbreviationPlaceholder: "Abbreviazione",
    description: "Descrizione",
    public: "Pubblica",
    acceptRequests: "Accetta richieste",
    jsonConfig: "Configurazione JSON",
    jsonConfigHint: "(chiave → valore)",
    key: "chiave",
    value: "valore",
    remove: "Rimuovi",
    addKey: "+ Aggiungi chiave",
    cancel: "Annulla",
    saving: "Salvataggio...",
    save: "Salva",
    create: "Crea",
    featureFlagModalTitle: "Feature flag: {name}",
    loadingFeatures: "Caricamento feature...",
    defaultOn: "default ON",
  },

  adminVarietiesView: {
    title: "Varietà",
    loading: "Caricamento...",
    searchPlaceholder: "Cerca varietà...",
    onlyUnused: "Solo non usate",
    varietyCount: "{count} varietà",
    colName: "Nome",
    colCrop: "Coltura",
    colOwner: "Organizzazione",
    colAccessions: "N. accessioni",
    shared: "Condivisa",
    edit: "Modifica",
    makeShared: "Rendi condivisa",
    delete: "Elimina",
    noVarietiesFound: "Nessuna varietà trovata",
    editModalTitle: "Modifica: {name}",
    loadingUsage: "Caricamento utilizzo...",
    usageWarning: "Varietà usata da {count} accessione/i:",
    name: "Nome",
    altName: "Nome alternativo",
    description: "Descrizione",
    owner: "Organizzazione",
    cancel: "Annulla",
    saving: "Salvataggio...",
    save: "Salva",
    deleteModalTitle: "Elimina: {name}",
    deleteConfirmText: "Confermi la cancellazione di questa varietà? L'operazione non è reversibile.",
  },

  adminWeatherView: {
    title: "Stazioni meteo",
    refresh: "Aggiorna",
    statusDisabled: "Disabilitata",
    statusActive: "Attiva",
    today: "oggi",
    recoverButton: "Recover",
    cancelRecoverButton: "Annulla recover",
    modalTitle: "Imposta recover storico",
    modalHintLine1: "Lascia vuoto per usare la data odierna come limite.",
    modalHintLine2: "Il recover verrà eseguito alla prossima run del cron",
    labelDateFrom: "Data inizio (date_from)",
    labelDateTo: "Data fine (date_to)",
    cancel: "Annulla",
    setRecoverButton: "Imposta recover",
    breadcrumbHome: "Home",
    colId: "ID",
    colName: "Nome",
    colType: "Tipo",
    colSource: "Sorgente",
    colProvince: "Prov.",
    colStatus: "Stato",
    colVisibility: "Visibilità",
    colLastData: "Ultimo dato",
    colRecordCount: "Record (1 anno)",
    colRecover: "Recover",
  },

  adminWeatherDetailView: {
    defaultTitle: "Stazione",
    stationsList: "Lista stazioni",
    loading: "Caricamento...",
    baseDataHeader: "Dati base",
    stationNameLabel: "Nome stazione",
    visibilityLabel: "Visibilità",
    visibilityFarm: "Azienda",
    visibilityOrg: "Org",
    visibilityPublic: "Pubblica",
    visibilityPrivate: "Riservata",
    statusLabel: "Stato",
    statusDisabled: "Disabilitata",
    statusActive: "Attiva",
    sourceLabel: "Sorgente:",
    codeLabel: "Codice:",
    provinceLabel: "Provincia:",
    saveButton: "Salva",
    recoverHeader: "Recover storico",
    recoverFromLabel: "Da",
    recoverToLabel: "a",
    today: "oggi",
    removeButton: "Rimuovi",
    recoverDateFromLabel: "Da",
    recoverDateToLabel: "A (vuoto = oggi)",
    setRecoverButton: "Imposta recover",
    recoverHint: "Il recover viene eseguito alla prossima run del cron",
    sensorUnitsHeader: "Configurazione unità sensore",
    dailyDataHeader: "Dati giornalieri per anno",
    noDailyData: "Nessun dato giornaliero.",
    hourlyDataHeader: "Dati orari per anno",
    noHourlyData: "Nessun dato orario.",
    colYear: "Anno",
    colRecord: "Record",
    colFrom: "Dal",
    colTo: "Al",
  },

  adminAepestView: {
    title: "Prodotti Fitosanitari",
    statusCardTitle: "Stato tabella",
    manageCropsLink: "Gestione crop",
    lastUpdate: "Ultimo aggiornamento: {date}",
    loading: "Caricamento...",
    statTotal: "Totale",
    statAttivi: "Attivi",
    statConPdf: "{count} con PDF",
    statAutorizzati: "Autorizzati",
    statRiRegistrati: "Ri-reg / Rinnovati",
    statConDosiEstratte: "Con dosi estratte",
    statTraGliAttivi: "tra gli attivi",
    statRevocati: "Revocati",
    statScadutiSospesi: "Scaduti / Sospesi",
    productsCardTitle: "Prodotti e PDF",
    searchPlaceholder: "Cerca prodotto, n. reg, impresa...",
    onlyActive: "Solo attivi",
    onlyExtracted: "Solo estratti",
    withoutPdf: "Senza PDF",
    searchButton: "Cerca",
    colNumReg: "N. Reg.",
    colProdotto: "Prodotto",
    colImpresa: "Impresa",
    colStato: "Stato",
    colPdf: "PDF",
    colUltimaEtichetta: "Ultima etichetta",
    colEstratto: "Estratto",
    pdfCount: "{count} PDF",
    dosesBadge: "✓ dosi",
    totalProducts: "{total} prodotti",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    breadcrumbFitosanitari: "Fitosanitari",
  },

  adminAepestProductView: {
    titleFallback: "Prodotto fitosanitario",
    loading: "Caricamento...",
    listLink: "lista",
    labelNumReg: "N. Reg.",
    labelImpresa: "Impresa:",
    labelFormulazione: "Formulazione:",
    labelSostanzeAttive: "Sostanze attive:",
    labelDataReg: "Data reg.:",
    labelScadenza: "Scadenza:",
    labelEtichetta: "Etichetta",
    pdfPanelTitle: "Etichetta PDF",
    openInNewTab: "Apri in nuova scheda ↗",
    dosesPanelTitle: "Dosi estratte",
    extractedOn: "estratto {date}",
    notProcessed: "non elaborato",
    jsonButton: "{ } JSON",
    noExtractedData: "Nessun dato estratto per questa etichetta.",
    crops: "{count} colture",
    apiRestrictionsWarn: "⚠ restrizioni api",
    colCrop: "Coltura",
    colAdversity: "Avversità",
    colDose: "Dose",
    colWaterVol: "Vol. H₂O",
    colNumTreatments: "N. tratt.",
    colInterval: "Intervallo",
    colPreHarvest: "Carenza",
    breadcrumbFitosanitari: "Fitosanitari",
  },

  adminSpatialModelView: {
    title: "Modello Spaziale",
    newRun: "Nuovo run",
    availableModels: "Modelli disponibili",
    addModel: "Aggiungi modello",
    configuredRuns: "Run configurati",
    modalEditRunTitle: "Modifica run",
    modalNewRunTitle: "Nuovo run modello spaziale",
    modelLabel: "Modello *",
    selectModelPlaceholder: "— seleziona modello —",
    yearLabel: "Anno *",
    dateFromLabel: "Data inizio",
    dateToLabel: "Data fine",
    areaLabel: "Area geografica *",
    drawingHint: "Clicca e trascina…",
    drawArea: "Disegna area",
    dirNorth: "N",
    dirSouth: "S",
    dirEast: "E",
    dirWest: "O",
    clear: "Cancella",
    modelVarsLabel: "Variabili modello (JSON)",
    modelVarsHint:
      "JSON con le variabili fisse del modello. Il worker aggiunge id_station, date_from, date_to.",
    runningWarning:
      "Questo run è attualmente in esecuzione (o è rimasto bloccato). Salvando verrà resettato a pending e potrà essere rieseguito.",
    cancel: "Annulla",
    save: "Salva",
    createRun: "Crea run",
    modalEditModelTitle: "Modifica modello",
    modalNewModelTitle: "Nuovo modello",
    modelNameLabel: "Model name *",
    modelNamePlaceholder: "es. dss_olivefly_complete",
    labelLabel: "Label",
    labelPlaceholder: "es. Mosca dell'olivo",
    defaultJsonLabel: "Default JSON (variabili fisse del modello)",
    outputVarsLabel: "Variabili output",
    colKey: "Chiave",
    colLabelShort: "Label",
    colType: "Tipo",
    primaryTooltip: "Variabile primaria per il colore mappa",
    primaryText: "Primaria",
    keyPlaceholder: "es. final_value.alert_level",
    typeNumeric: "numeric (0-1)",
    typeCategorical: "categoriale",
    addOutputVar: "Aggiungi variabile",
    colModelName: "Model name",
    colModel: "Modello",
    colYear: "Anno",
    colFrom: "Da",
    colTo: "A",
    colStatus: "Status",
    colProgress: "Progress",
    colCreated: "Creato",
    invalidJson: "JSON non valido",
  },

  farmsView: {
    title: "Tabella dei Farm Center",
    id: "ID",
    name: "Nome",
    address: "Indirizzo",
    lat: "Lat",
    lng: "Lng",
    actions: "Azioni",
    edit: "Modifica",
    loading: "Caricamento...",
    noFarmsFound: "Nessuna azienda trovata.",
    editFarmTitle: "Modifica azienda",
    nameLabel: "Nome:",
    save: "Salva",
    cancel: "Annulla",
    updateError: "Errore nell'aggiornamento",
    loadError: "Errore nel caricamento.",
  },

  geoElementDetailView: {
    companies: "Aziende",
    company: "Azienda",
    geoElement: "Elemento geografico",
  },

  oliverecHomeView: {
    title: "Plantrec — Rilievi piante",
    subtitle: "Seleziona il plot e la scheda di rilievo",
    loading: "Caricamento...",
    noSchemas:
      "Nessuna scheda di rilievo configurata per questa organizzazione.",
    noPlots:
      "Nessun plot con accessioni caricate disponibile per questa azienda.",
    schemaLabel: "Scheda di rilievo",
    schemaPlaceholder: "Seleziona scheda...",
    plotLabel: "Plot",
    plotPlaceholder: "Seleziona plot...",
    start: "Inizia",
    desktopHint: "Stai lavorando da desktop?",
    excelLink: "Inserimento tramite tabella Excel →",
    plantCount: "{count} piante",
  },

  oliverecSurveyView: {
    defaultTitle: "Rilievo piante",
    afterSaveTitle: "Dopo il salvataggio",
    navForward: "▶ Avanti",
    navStay: "↺ Rimani",
    navBack: "◀ Indietro",
    navSnake: "↔ Serpentina",
    navConfigTitle: "Configurazione movimento",
    navAxisLabel: "Cosa cambia ad ogni pianta",
    navAxisPlant: "La pianta (colonna)",
    navAxisRow: "La fila (riga)",
    navAxisRowShort: "fila",
    navConfigClose: "Chiudi",
    saveWhileUploadingTitle: "Foto ancora in caricamento: salvando ora, l'immagine verrà comunque associata a questa pianta appena l'upload termina",
    saving: "Salvataggio...",
    save: "Salva",
    breadcrumbHome: "Plantrec",
    breadcrumbSurvey: "Rilievo",
  },

  spadeTestView: {
    cancel: "Annulla",
    next: "Avanti →",
    start: "Inizia →",
    back: "Indietro",
    saveAndExit: "Salva ed esci",
    finish: "Concludi",
    title: "Test della Vanga",
    selectFieldSubtitle: "Seleziona il campo in cui effettuare il test",
    noFieldsAvailable: "Nessun campo disponibile per la stagione corrente.",
    goBack: "Torna indietro",
    suggestedSampleCode: "Codice campione suggerito:",
    loading: "Caricamento in corso…",
    defaultFarmName: "Azienda",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Aziende",
    breadcrumbMonitoring: "Monitoraggio",
  },

  accessionsView: {
    title: "Gestione Accessioni",
    accessions: "Accessioni",
    varieties: "Varietà",
    totalPlants: "Piante totali",
    withAccession: "Con accessione",
    plots: "Appezzamenti",
    statusEmpty: "Nessuna pianta",
    statusNone: "Senza accessioni",
    statusComplete: "Con accessioni",
    tabAccessions: "Accessioni",
    tabPlots: "Appezzamenti",
    tabVarieties: "Varietà",
    colAccession: "Accessione",
    colVariety: "Varietà",
    colSource: "Origine",
    colPlants: "Piante",
    colFarm: "Azienda",
    colPlot: "Appezzamento",
    colPlots: "Appezzamenti",
    colStatus: "Stato",
    colAccessionsCount: "Accessioni",
    colVarietyCount: "Varietà",
    colCrop: "Coltura",
    endangered: "Varietà a rischio estinzione",
    colEndangered: "Rischio estinzione",
    endangeredYes: "A rischio",
    onlyEndangered: "Solo a rischio estinzione ({count})",
    showAll: "Mostra tutte",
  },

  accessionElabView: {
    title: "Elaborazione Dati Survey",
    home: "Home",
    accessions: "Accessioni",
    dataElaboration: "Elaborazione Dati",
  },

  accessionElab: {
    schema: "Schema",
    ordinateVariable: "Variabile (asse Y)",
    groupBy: "Raggruppa per (asse X)",
    series: "Serie (colori)",
    loadingData: "Caricamento dati...",
    loadError: "Errore caricamento dati",
    noDataForSchema: "Nessun dato trovato per questo schema.",
    filters: "Filtri",
    filtersActive: "{count} attivi",
    filtersNone: "nessuno",
    farmCenter: "Azienda",
    plot: "Appezzamento",
    all: "Tutti",
    allFem: "Tutte",
    year: "Anno",
    variety: "Varietà",
    selectVariablePlaceholder: "— Seleziona variabile —",
    tabChart: "Grafico",
    tabAggregatedData: "Dati Aggregati",
    tabRawData: "Dati Grezzi",
    tabImages: "Immagini",
    selectVariableHint: "Seleziona una variabile per visualizzare il grafico.",
    rows: "righe",
    downloadCsv: "Scarica CSV",
    imagesCount: "{visible} / {total} immagini",
    noImagesForFilters: "Nessuna immagine nei dati filtrati.",
    removeFromAiTraining: "Rimuovi da AI training",
    addToAiTraining: "Aggiungi ad AI training",
    loadMore: "Carica altri ({count} rimanenti)",
    value: "Valore",
    count: "N",
    percent: "%",
    mean: "Media",
    min: "Min",
    q1: "Q1",
    median: "Mediana",
    q3: "Q3",
    max: "Max",
    date: "Data",
    accession: "Accessione",
    frequencyPercent: "% frequenza",
    tooltipMin: "Min: {value}",
    tooltipQ1: "Q1: {value}",
    tooltipMedian: "Mediana: {value}",
    tooltipQ3: "Q3: {value}",
    tooltipMax: "Max: {value}",
    tooltipN: "N: {value}",
  },

  plantSurveyMobile: {
    loading: "Caricamento...",
    row: "Fila",
    plant: "Pianta",
    qr: "QR",
    map: "Mappa",
    plantWithoutAccession: "Pianta senza accessione",
    qrNotAcquired: "QR non acquisito",
    surveyPresent: "Rilievo presente",
    plantNotFound: "Pianta non trovata ({row}/{col})",
    surveyDate: "Data rilievo",
    editingExistingSurvey: "Stai modificando un rilievo già presente",
    acquireFromQr: "Acquisisci da qrcode",
    deleteSurvey: "Elimina rilievo",
    selectPositionHint:
      "Seleziona una posizione con una pianta per inserire i dati.",
    confirmDeleteSurvey: "Sei sicuro di voler eliminare questo rilievo?",
    cancel: "Annulla",
    delete: "Elimina",
    plantMap: "Mappa piante",
    current: "Attuale",
    selected: "Selezionata",
    surveyOk: "Rilievo ok",
    todo: "Da fare",
    rowPlantPos: "Fila {row} · Pianta {col}",
    noSurvey: "Nessun rilievo",
    goToPlant: "Vai a questa pianta",
    clickPlantForDetails: "Clicca su una pianta per i dettagli",
  },
  modelWidget: {
    calculating: "calcolo…",
    calculatingInProgress: "Calcolo in corso…",
    detailLabel: "Dettaglio →",
    modelRunning: "Modello in esecuzione…",
    reportNotAvailable: "Report non disponibile.",
    chart: "Grafico",
    detailedData: "Dati dettagliati",
    calculationError: "Errore nel calcolo del modello",
    modelNotStarted: "Modello non ancora avviato",
  },
  modelsCommon: {
    errorFieldNotFound: "Campo non trovato",
    errorFarmNotLoaded: "Azienda non caricata",
    errorModel: "Errore dal modello",
    errorNetwork: "Errore di rete",
    errorCropNotDefined:
      "Attenzione. Non è stata definita la coltura dell'appezzamento",
    csvInvalidFile: "Attenzione! il file non è corretto",
    modelStartsToday:
      ". Il modello ha come data di inizio la data odierna. Da domani ci sarà il primo run del modello",
    modelStartsFuture: ". Il modello ha come data di inizio una data futura!",
    resultAvailable: "Risultato disponibile",
    irrigate: "Irriga {value} mm",
    deficit: "Deficit: {value} mm",
    nutriBalance: "N:{n} · P:{p} · K:{k} kg/ha",
    phenologyFallback: "Fenologia",
    bioclimFallback: "Indici bioclimatici",
    bioclimIndices: "Huglin: {huglin} · Winkler: {winkler}",
    seasonEnded: "Stagione terminata",
    riskLevel: {
      high: "Alto",
      medium: "Moderato",
      low: "Basso",
      info: "Nessuno",
    },
    oliveFly: {
      modelNotStarted: {
        title: "Il modello si avvia il 4 giugno",
        text: "Il modello sarà in esercizio dal 4 giugno",
      },
      lowP: {
        title: "Basso rischio",
        text: "Basso rischio di inizio ovideposizione",
      },
      mediumP: {
        title: "Attenzione",
        text: "Rischio di ovideposizione in aumento",
      },
      highPLowMortality: {
        title: "Ovideposizione in corso",
        text: "Elevato rischio di ovideposizione - le temperature sono favorevoli allo sviluppo",
      },
      highPHighMortality: {
        title: "Ovideposizione contenuta",
        text: "Elevato rischio di ovideposizione, ma le alte temperature possono contenere lo sviluppo",
      },
      modelEnd: {
        title: "Stagione terminata",
        text: "Il periodo di validità del modello è terminato",
      },
      riskPercent: "Rischio: {value}%",
      default: "Mosca olivo",
    },
    lobesia: {
      stages: {
        c0: {
          label: "Crisalidi svernanti",
          message: "Rischio assente. Svernamento.",
        },
        a1: {
          label: "Adulti I gen.",
          message:
            "Rischio basso. Acquisire informazioni e decidere strategie di monitoraggio e difesa per le prossime fasi.",
        },
        u1: {
          label: "Uova I gen.",
          message:
            "Rischio basso. Acquisire informazioni e decidere strategie di monitoraggio e difesa per le prossime fasi.",
        },
        l1: {
          label: "Larve I gen.",
          message:
            "Rischio basso. Acquisire informazioni e decidere strategie di monitoraggio e difesa per le prossime fasi.",
        },
        c1: {
          label: "Crisalidi I gen.",
          message:
            "Rischio medio. Posizionare le trappole per il monitoraggio degli adulti.",
        },
        a2: {
          label: "Adulti II gen.",
          message:
            "Rischio alto. L'ovideposizione inizierà a breve. Monitoraggio in campo, valutare la strategia di difesa.",
        },
        u2: {
          label: "Uova II gen.",
          message:
            "Rischio alto. Ovideposizione in corso. Monitoraggio grappoli, valutare la strategia di difesa.",
        },
        l2: {
          label: "Larve II gen.",
          message:
            "Rischio medio. Sviluppo larvale in corso. Monitoraggio grappoli, valutare la strategia di difesa.",
        },
        c2: {
          label: "Crisalidi II gen.",
          message: "Rischio medio. Stato di crisalide. Monitoraggio in campo.",
        },
        a3: {
          label: "Adulti III gen.",
          message:
            "Rischio alto. L'ovideposizione inizierà a breve. Monitoraggio in campo, valutare la strategia di difesa.",
        },
        u3: {
          label: "Uova III gen.",
          message:
            "Rischio alto. Ovideposizione in corso. Monitoraggio in campo, valutare la strategia di difesa.",
        },
        l3: {
          label: "Larve III gen.",
          message:
            "Rischio medio. Sviluppo larvale in corso. Monitoraggio in campo, valutare la strategia di difesa.",
        },
        c3: {
          label: "Crisalidi III gen.",
          message: "Rischio basso. Stato di crisalide. Monitoraggio in campo.",
        },
        endCycle: { label: "Fine del ciclo", message: "Rischio assente." },
      },
      generation: "Tignoletta: gen. {generation}",
      default: "Tignoletta",
    },
    powdery: {
      default: "Oidio",
      riskNotSprouted: "Vite non germogliata",
      riskHigh: "Rischio alto",
      riskMedium: "Rischio medio",
      riskLow: "Rischio basso",
      riskWithValue: "{label} ({value})",
    },
    plasmo: {
      infections: "Peronospora: {primary} inf. primarie, {secondary} sec.",
      noInfection: "Peronospora: nessuna infezione",
    },
    botrytis: {
      combined:
        "Botrite – Rischio climatico: {climat} · Rischio fenologico: {pheno}",
      single: "Botrite – rischio climatico di infezione: {climat}",
      gonzalez: "Botrite González – rischio: {label}",
      phaseSuffix: " · fase: {phase}",
    },
    corn: {
      default: "Mais",
      overwintering: "Svernamento",
      youngLarvae: "Larve giovani nel suolo",
      larvaeInSoil: "Larve nel suolo",
      soilCrysalid: "Crisalidi nel suolo",
      flightStart: "Inizio volo adulti",
      flightPeak: "Picco di volo",
      flightDecrease: "Volo in calo",
      flightEnded: "Volo terminato",
      overwinteringO: "Svernamento",
      adult0: "Adulti gen. 0",
      egg1: "Uova gen. 1",
      egg2: "Uova gen. 2",
      egg3: "Uova gen. 3",
      l11: "Larve L1 gen. 1",
      l21: "Larve L2 gen. 1",
      l31: "Larve L3 gen. 1",
      l41: "Larve L4 gen. 1",
      l51: "Larve L5 gen. 1",
      cr1: "Crisalidi gen. 1",
      ad1: "Adulti gen. 1",
      lx3: "Larve gen. 3",
      end3: "Fine stagione",
      adults: "Adulti",
      adultPreovi: "Pre-ovideposizione",
      adultOvi: "Ovideposizione",
      egg: "Uova",
      larvae: "Larve",
      pupae: "Crisalidi",
      adultEmergence2: "Adulti 2ª generazione",
    },
    diabro: {
      labels: {
        overwintering: "Uova",
        youngLarvae: "Larve di prima età",
        larvaeInSoil: "Larve nel suolo",
        soilCrysalid: "Crisalidi nel suolo",
        flightStart: "Inizio dei voli",
        flightPeak: "Picco dei voli",
        flightDecrease: "Diminuzione dei voli",
        flightEnded: "Fine dei voli",
      },
      messages: {
        overwintering: "Non è il momento di trattare",
        youngLarvae: "Non è il momento di trattare",
        larvaeInSoil: "Non è il momento di trattare",
        soilCrysalid: "Lo sfarfallamento degli adulti inizierà presto",
        flightStart: "Prepararsi al trattamento",
        flightPeak:
          "Valutare la possibilità di trattare, se non è già stato fatto",
        flightDecrease:
          "Valutare la possibilità di trattare, se non è già stato fatto",
        flightEnded: "Non è il momento di trattare",
      },
    },
    ostrinia: {
      labels: {
        notStarted: "Modello non ancora partito",
        overwintering: "Forme svernanti",
        adult0: "Adulti",
        egg1: "Uova",
        l11: "Larve di prima età, prima generazione",
        l21: "Larve di seconda età, prima generazione",
        l31: "Larve di terza età, prima generazione",
        l41: "Larve di quarta età, prima generazione",
        l51: "Larve di quinta età, prima generazione",
        cr1: "Crisalidi, prima generazione",
        ad1: "Adulti, prima generazione",
        egg2: "Uova, seconda generazione",
        l12: "Larve di prima età, seconda generazione",
        l22: "Larve di seconda età, seconda generazione",
        l32: "Larve di terza età, seconda generazione",
        l42: "Larve di quarta età, seconda generazione",
        l52: "Larve di quinta età, seconda generazione",
        cr2: "Crisalidi, seconda generazione",
        ad2: "Adulti, seconda generazione",
        egg3: "Uova, terza generazione",
        lx3: "Larve, terza generazione",
        end3: "Ciclo concluso",
      },
      messages: {
        notStarted: "",
        overwintering: "Non è il momento di trattare",
        adult0: "A breve inizierà l'ovideposizione, prepararsi al trattamento",
        egg1: "Valutare la possibilità di trattare, se non è già stato fatto",
        l11: "È iniziato lo sviluppo larvale, valutare la possibilità di trattare, se non è già stato fatto",
        l21: "Non è il momento di trattare",
        l31: "Non è il momento di trattare",
        l41: "Non è il momento di trattare",
        l51: "Non è il momento di trattare",
        cr1: "Non è il momento di trattare",
        ad1: "A breve inizierà l'ovideposizione, prepararsi al trattamento",
        egg2: "Valutare la possibilità di trattare, se non è già stato fatto",
        l12: "È iniziato lo sviluppo larvale, valutare la possibilità di trattare, se non è già stato fatto",
        l22: "Non è il momento di trattare",
        l32: "Non è il momento di trattare",
        l42: "Non è il momento di trattare",
        l52: "Non è il momento di trattare",
        cr2: "Non è il momento di trattare",
        ad2: "A breve inizierà l'ovideposizione, prepararsi al trattamento",
        egg3: "Valutare la possibilità di trattare, se non è già stato fatto",
        lx3: "Non è il momento di trattare",
        end3: "Non è il momento di trattare",
      },
    },
    heli: {
      labels: {
        adults: "Adulti",
        adultPreovi: "Adulti non ovideponenti",
        adultOvi: "Adulti ovideponenti",
        egg: "Uova",
        larvae: "Larve",
        pupae: "Pupe",
        adultEmergence2: "Sfarfallamento adulti, seconda generazione",
        flightEnded: "Ciclo concluso",
      },
      messages: {
        adults: "Gli adulti stanno sfarfallando",
        adultPreovi: "A breve inizierà l'ovideposizione",
        adultOvi:
          "L'ovideposizione è in corso, valutare la possibilità di trattare, se non è già stato fatto",
        egg: "Valutare la possibilità di trattare, se non è già stato fatto",
        larvae: "Non è il momento di trattare",
        pupae: "Non è il momento di trattare",
        adultEmergence2: "A breve inizierà l'ovideposizione",
        flightEnded: "Il ciclo stagionale è terminato",
      },
    },
    diseaseHelp: {
      tignoletta: `<p><strong>Tignoletta della vite</strong> (<em>Lobesia botrana</em>)</p><p>Il modello simula lo sviluppo delle tre generazioni annuali della tignoletta in base alle temperature accumulate (gradi-giorno). Indica il momento di volo degli adulti e la percentuale di larve presenti.</p><ul><li><strong>Rischio basso:</strong> popolazioni contenute o generazione non attiva</li><li><strong>Rischio medio:</strong> volo in corso, monitorare le trappole</li><li><strong>Rischio alto:</strong> picco di volo, valutare il trattamento</li></ul>`,
      peronospora: `<p><strong>Peronospora della vite</strong> (<em>Plasmopara viticola</em>)</p><p>Sono disponibili tre modelli con approcci diversi. La scelta dipende dalla qualità del dato meteorologico disponibile e dal livello di dettaglio richiesto.</p><p><strong>3-10 Goidanich</strong> — modello di riferimento prudenziale</p><p>Basato sulla regola del 3-10 e sul calcolo delle infezioni secondo Goidanich. È il modello da preferire quando non si è sicuri della qualità o della rappresentatività dei dati meteorologici rispetto all'azienda. Essendo prudenziale, tende a sovrastimare le necessità di trattamento rispetto ai modelli più avanzati: meglio un trattamento in più che uno in meno in condizioni di incertezza.</p><p><strong>Peronospora Plus - modello epidemiologico -  Meccanicistico</strong> — modello avanzato per dati meteo affidabili e orari</p><p>Va utilizzato quando il dato meteorologico è molto vicino all'azienda e sono disponibili i dati orari di pioggia. Il modello simula lo sviluppo delle zoospore nel terreno giorno per giorno e stima se le piogge infettanti abbiano effettivamente le condizioni per provocare infezioni primarie. Fornisce una stima più precisa rispetto al meccanicistico, ma richiede un dato meteo di qualità per non perdere di affidabilità.</p><p><strong>Machine Learning</strong> — modello sperimentale</p><p>Modello di machine learning costruito sui dati storici della rete di monitoraggio. Restituisce la probabilità di presenza di sintomi nella settimana successiva. Il modello è ancora in fase di test e validazione: i risultati vanno interpretati come un indicatore di tendenza, non come una previsione certa. Si consiglia di affiancarlo sempre agli altri modelli prima di prendere decisioni di trattamento.</p>`,
      oidio: `<p><strong>Oidio della vite</strong> (<em>Erysiphe necator</em>)</p><p>Sono disponibili due modelli:</p><ul><li><strong>Modello Oidio:</strong> segue il ciclo biologico del fungo in base a temperatura e umidità</li><li><strong>Machine Learning</strong> — stima la probabilità di sintomi nei successivi 7 giorni tramite machine learning</li></ul>`,
      botrite: `<p><strong>Botrite della vite</strong> (<em>Botrytis cinerea</em>)</p><p>Sono disponibili due modelli:</p><ul><li><strong>Modello Botrite:</strong> calcola le ore di bagnatura fogliare favorevoli all'infezione</li><li><strong>Machine Learning</strong> — stima la probabilità di sintomi nei successivi 7 giorni tramite machine learning</li></ul>`,
    },
  },
  phenoRender: {
    alertLabel: "Fase prevalente",
    cumulativeDegreeDays: "Gradi giorno cumulati:",
    genericLabel: "Fenologia",
    end: "Fine",
    noResults: "Nessun risultato disponibile.",
    table: {
      date: "Data",
      stageCurrent: "Stadio corrente",
      percPhase: "Percentuale stadio (%)",
      report: "Segnalazione",
    },
    chart: {
      dayDegree: "Gradi giorno",
      confirmed: "Confermato",
      anticipated: "Anticipo",
      delayed: "Ritardo",
      degreeDaysUnit: "GG",
    },
    correction: {
      question: "La fase stimata è corretta?",
      saving: "Salvataggio…",
      yes: "✓ Sì",
      no: "✗ No, correggi",
      noBbchTitle: "Nessuna fase BBCH da confermare",
      confirmedMsg: "✓ Fase confermata e registrata",
      editQuestion: "Seleziona la fase osservata in campo:",
      choosePlaceholder: "— scegli —",
      cancel: "Annulla",
      save: "Salva osservazione",
      saved: "✓ Osservazione salvata — il modello verrà ricalcolato",
      errorDefault: "Errore durante il salvataggio",
    },
    phaseSummary: {
      title: "Riepilogo fasi fenologiche",
      bbch: "BBCH",
      stage: "Fase",
      start: "Inizio",
      end: "Fine",
      observations: "Osservazioni",
    },
    obs: {
      editTitle: "Modifica",
      deleteTitle: "Elimina",
      addTitle: "Aggiungi osservazione",
      errorDefault: "Errore",
    },
    badge: {
      corrected: "⚡ Corretto (era {value})",
      confirmed: "✓ Confermato",
    },
  },
  phenoHeatmap: {
    title: "Generazioni teoriche",
    noData: "Nessun dato fenologico disponibile.",
    stages: {
      adult: "Adulti",
      pupa: "Pupe",
      larva: "Larve",
      eggs: "Uova",
    },
  },
  grapeBioclimRender: {
    kpi: {
      huglin: "Indice di Huglin",
      winkler: "Indice di Winkler",
      gddAllen: "GDD Allen cum.",
    },
    table: {
      datetime: "Data",
      tavg: "T. media (°C)",
      tmin: "T. min (°C)",
      tmax: "T. max (°C)",
      gdd: "GDD cum.",
      winkler: "Winkler cum.",
      huglin: "Huglin cum.",
      daysDiffHuglin: "Δ gg Huglin vs anno prec.",
      daysDiffWinkler: "Δ gg Winkler vs anno prec.",
    },
    huglinClasses: {
      veryCold: "Molto freddo",
      cold: "Freddo",
      temperate: "Temperato",
      warm: "Caldo",
      veryWarm: "Molto caldo",
    },
    winklerClasses: {
      zoneI: "Zona I",
      zoneII: "Zona II",
      zoneIII: "Zona III",
      zoneIV: "Zona IV",
      zoneV: "Zona V",
    },
    legend: { huglinTitle: "Classi Huglin:" },
    chart: {
      cumulativeIndicesTitle: "Indici bioclimatici cumulati",
      huglinDataset: "Huglin",
      winklerDataset: "Winkler",
      diffTitle: "Anticipo/ritardo rispetto all'anno precedente (giorni)",
      diffYAxis: "Giorni (neg.=anticipo, pos.=ritardo)",
      diffHuglinDataset: "Δ giorni Huglin vs anno prec.",
      diffWinklerDataset: "Δ giorni Winkler vs anno prec.",
    },
    diff: {
      inLine: "In linea con anno prec.",
      anticipo: "{value} gg anticipo",
      ritardo: "{value} gg ritardo",
    },
  },
  pestLobesiRender: {
    table: {
      date: "Data",
      status: "Fase prevalente",
      eggs: "Uova",
      larvae: "Larve",
      pupae: "Crisalidi",
      adults: "Adulti",
    },
    title: { default: "Tignoletta", seasonEnded: "Stagione terminata" },
    chart: {
      title: "Sviluppo Lobesia botrana nel tempo",
      eggs: "Uova",
      larvae: "Larve",
      pupae: "Crisalidi",
      adults: "Adulti",
    },
  },
  pestOliveFlyRender: {
    modelNotStartedWarning: "Attenzione! Il modello non è ancora partito.",
    noData: "Dati non disponibili.",
    ovi: {
      setDate: "Imposta data di inizio ovideposizione",
      editDate: "Modifica data di inizio ovideposizione",
      editButton: "Modifica",
      removeManualDate: "Rimuovi data manuale",
      dateSet: "Data impostata:",
      restoreAutoDate: "Ripristina data automatica",
      insertDateIfDetected: "Inserisci data di ovideposizione se già rilevata",
      startLabel: "Inizio ovideposizione:",
      notStartedYet: "(non ancora partita)",
      modelForecast: "Previsione modello:",
    },
    badge: { manual: "manuale", auto: "automatica" },
    actions: { save: "Salva", cancel: "Annulla" },
    error: { saveFailed: "Errore nel salvataggio" },
    chart: {
      dailyMortality: "Mortalità giornaliera",
      cumMortality7d: "Mortalità cumulata 7gg",
      riskInceptionTitle: "Rischio inizio ovideposizione",
    },
    table: {
      date: "Data",
      status: "Stato",
      mortality: "Mortalità giornaliera",
      mortalityCum7d: "Mortalità cumulata 7gg",
      riskOviposition: "Rischio ovideposizione",
      phenoPhase: "Fase fenologica mosca",
    },
  },
  pestBotrytisRender: {
    kpi: {
      climaticRisk: "Rischio climatico",
      infectionIndex: "Indice infezione",
      phenoRisk: "Rischio fenologico",
      combinedRisk: "Rischio combinato",
      berryStage: "Stadio bacca",
    },
    table: {
      date: "Data",
      alertLevelClimat: "Rischio climat.",
      alertLevelPheno: "Rischio fenol.",
      combinedRisk: "Rischio combinato",
    },
    risk: {
      high: "Alto",
      medium: "Moderato",
      low: "Basso",
      info: "Nessun rischio",
    },
    chart: {
      title: "Indice di infezione Botrytis (climatico)",
      yAxisTitle: "Indice infezione",
      lowBand: "Basso (0–0.5)",
      moderateBand: "Moderato (0.5–1)",
      highBand: "Alto (>1)",
      infectionIndex: "Indice infezione",
    },
  },
  pestBotrytisGonzalezRender: {
    kpi: {
      risk: "Rischio",
      riskIndex: "Indice rischio",
      phase: "Fase",
      sev1: "SEV1 (fioritura)",
      sev2: "SEV2 (acini)",
      sev3: "SEV3 (secondarie)",
    },
    table: { date: "Data", risk: "Rischio", phase: "Fase", sev: "SEV 1/2/3" },
    risk: {
      high: "Alto",
      medium: "Moderato",
      low: "Basso",
      info: "Nessun rischio",
    },
    phase: {
      flowering: "Fioritura",
      ripening: "Maturazione",
      neutral: "Neutro",
    },
    chart: {
      title: "Rischio Botrytis – modello González (giornaliero)",
      yAxisTitle: "Indice rischio",
      lowBand: "Basso (<0.2)",
      moderateBand: "Moderato (<0.5)",
      highBand: "Alto (>0.5)",
      sev1: "SEV1 (fioritura)",
      sev2: "SEV2 (acini)",
      riskGonzalez: "Rischio González",
    },
  },
  pestCornRender: {
    kpi: { gdd: "GDD cumulativi", currentPhase: "Fase attuale" },
    defaultTitle: "Mais - Difesa",
    table: {
      date: "Data",
      phase: "Fase",
      soilLarvae: "Larve suolo (%)",
      adultsPercent: "Adulti (%)",
      eggs: "Uova",
      larvae: "Larve",
      adults: "Adulti",
      pupae: "Crisalidi",
      ovideposition: "Ovideposizione (%)",
    },
    chart: {
      soilLarvae: "Larve nel suolo (%)",
      adultsFlight: "Adulti - volo (%)",
      eggs: "Uova",
      larvae: "Larve",
      pupae: "Crisalidi",
      adults: "Adulti",
      eggsPercent: "Uova (%)",
      larvaePercent: "Larve (%)",
      pupaePercent: "Crisalidi (%)",
      ovideposition: "Ovideposizione (%)",
      adultsGen2: "Adulti 2ª gen. (%)",
      titleDiabro: "Diabrotica virgifera — sviluppo nel tempo",
      titleOstrinia: "Ostrinia nubilalis — sviluppo nel tempo",
      titleHeli: "Helicoverpa armigera — sviluppo nel tempo",
      titleDefault: "Sviluppo nel tempo",
    },
  },
  pestGrapeMlRender: {
    modelEnded: "Il ciclo produttivo della coltura è terminato.",
    notStarted:
      "Il modello non è ancora partito (dati insufficienti o stagione non iniziata).",
    table: {
      date: "Data",
      pInf: "Probabilità di vedere sintomi tra 7 giorni",
    },
    kpi: {
      lastCalcDate: "Data ultimo calcolo",
    },
    title: {
      notStarted: "Modello non ancora avviato",
      withValue: "Probabilità di vedere sintomi tra 7 giorni: {value}%",
    },
    risk: {
      high: "Rischio alto",
      medium: "Rischio medio",
      low: "Rischio basso",
    },
    status: { absent: "Assente" },
    chart: { title: "Probabilità sintomi nei 7 giorni successivi (%)" },
  },
  pestGrapeOidioRender: {
    modelEnded: "Il ciclo produttivo della coltura è terminato.",
    kpi: { currentRisk: "Rischio attuale" },
    warning: {
      title: "Nota importante:",
      text: "Il modello attuale fornisce il rischio puramente climatico. È necessario integrare questo dato con l'effettiva presenza in campo dell'oidio, la pressione degli anni precedenti e la fase fenologica.",
    },
    table: {
      date: "Data",
      pheno: "Fenologia",
      riskIndex: "Indice di rischio",
      riskClass: "Classe di rischio",
    },
    risk: {
      ended: "Modello terminato",
      notSprouted: "Vite non germogliata",
      low: "Rischio basso",
      medium: "Rischio medio",
      high: "Rischio alto",
    },
    advice: {
      low: "In caso di trattamento con zolfo adottare una frequenza di 14-21 gg",
      medium:
        "In caso di trattamento con zolfo adottare una frequenza di 10-17 gg",
      high: "In caso di trattamento con zolfo adottare una frequenza di 7 gg",
    },
    chart: { title: "Indice di rischio oidio nel tempo" },
  },
  pestGrapePlasmoRender: {
    notStarted: {
      title: "Modello non ancora partito",
      estimatedStart: "La fenologia della coltura stima la partenza il",
      startDateUnavailable:
        "La data di partenza non è ancora disponibile (fase fenologica BBCH 15 non raggiunta).",
    },
    modelEnded: {
      title: "Modello terminato",
      sub: "La stagione di monitoraggio si è conclusa (fine settembre).",
    },
    kpi: {
      totalPrimary: "Infezioni primarie totali",
      totalSecondary: "Infezioni secondarie totali",
      status: "Stato",
      primaryInfections: "Infezioni primarie",
      secondaryInfections: "Infezioni secondarie",
    },
    status: { pending: "Non partito", ended: "Terminato" },
    statusLabels: {
      noActiveInfection: "Nessuna infezione attiva",
      infectionCytoSystemic: "Infezione — Citotropici o Sistemici",
      infectionSystemic: "Infezione — Sistemici",
      waitToTreat: "Attendi per trattare",
      infectionContact: "Infezione — Prodotti di Contatto",
      unknown: "Stato sconosciuto",
    },
    table: {
      date: "Data",
      pheno: "Fenologia",
      status: "Stato",
      primary: "Inf. primarie",
      secondary: "Inf. secondarie",
    },
    chart: {
      primaryInfections: "Infezioni primarie",
      secondaryInfections: "Infezioni secondarie",
      countTitle: "Infezioni peronospora nel tempo",
      germinationTitle: "Avanzamento germinazione per infezione",
      germinationYAxis: "Germinazione (%)",
    },
  },
  pestPlasmoPlusRender: {
    table: {
      familyTableLabel: "Famiglie di oospore",
      family: "Famiglia",
      lastStatus: "Ultimo Stato",
      germinationPercent: "Germinazione %",
    },
    infoBox: {
      notReceptive: "La vegetazione non è ancora recettiva (attesa BBCH 15).",
      receptiveSince: "Recettiva dal",
      budsOpenSince: "gemme aperte (BBCH 8) dal",
      pisSeason: "Stagione PIS",
      oosporesActiveSince: "oospore attive dal",
      until: "al",
      noNewFamilyAfter:
        "dopo questa data nessuna nuova famiglia viene generata",
      lastEventOn: "ultimo evento il",
    },
    kpi: {
      activeFamilies: "Famiglie attive",
      maxPhaseReached: "Fase max raggiunta",
      maxGermination: "Germinazione max",
      currentPhenology: "Fenologia attuale",
    },
    dailyData: {
      title: "Dati giornalieri",
    },
    dailyTable: {
      date: "Data",
      maturation: "Maturazione",
      oospores: "oospore",
      maxGer: "Max GER",
      status: "Stato",
      start310: "Partenza 310",
      startPlus: "Partenza Plus",
    },
    badge: {
      sporulata: "Sporulata",
      infetta: "Infetta",
      rule310Tooltip: "Condizioni 310: T>12°C, pioggia 48h ≥10mm, BBCH≥15",
    },
    tablePre: {
      text: "Ad ogni evento di bagnatura del suolo se le oospore non sono in dormienza, il modello crea una nuova famiglia di oospore. Per ogni famiglia su susseguono una serie di eventi (germinazione, rilascio zoospore, infezione, sporulazione, ecc.) che vengono monitorati e mostrati in questa tabella.",
    },
    field: {
      ended: "terminata",
      active: "attiva",
    },
    modal: {
      dayDetailTitle: "Dettaglio {date}",
      noHourlyData: "Dati orari non disponibili.",
      hourlyMeteoHeader:
        "Meteo orario · GEO = sporangi vivi · REL = rilascio zoospore · SUZ = zoospore vive",
      hour: "Ora",
      sporangiTitle: "Sporangi vivi",
      releaseTitle: "Rilascio zoospore",
      zoosporesTitle: "Zoospore vive",
      event: "Evento",
      familyHistoryTitle: "Famiglia {fam} — Cronologia fasi",
    },
    statusLabels: {
      oosporeGermination: "Germinazione oospore",
      sporangiumSurvival: "Sopravvivenza sporangio",
      zoosporeRelease: "Rilascio zoospore",
      zoosporeDispersion: "Dispersione zoospore",
      plantNotReceptive: "Pianta non recettiva",
      leafInfection: "Infezione fogliare",
      sporulation: "Sporulazione",
      sporulationEnd: "Fine sporulazione",
      unknownStatus: "Stato {id}",
    },
    historyLabels: {
      oosporeGermination: "Germinazione oospore",
      sporangium: "Sporangio",
      zoosporesReleased: "Zoospore rilasciate",
      zoosporeDispersion: "Dispersione zoospore",
      infectionNotReceptive: "Infezione (pianta non recettiva)",
      leafInfection: "Infezione fogliare",
      sporulation: "Sporulazione",
      sporulationEnd: "Fine sporulazione",
    },
    mainMessage: {
      primaryInfectionsEnded:
        "H. Le infezioni primarie dell'anno sono terminate.",
      oosporesDormant: "Le oospore sono in dormienza (HT {ht} / soglia 1.3).",
      noFamiliesDormancy:
        "Non ci sono famiglie di oospore. Dormienza al {percent}%.",
      oosporesInDevelopment:
        "A. Oospore in sviluppo (germinazione max {percent}%).",
      oosporesNearGermination:
        "A. Oospore prossime alla germinazione (max {percent}%).",
      sporangiaProduced: "B. Le oospore hanno prodotto gli sporangi.",
      zoosporesReleased: "C. Le zoospore sono state rilasciate.",
      zoosporesDispersed:
        "D. Le zoospore sono state disperse e hanno raggiunto la pianta.",
      potentialInfectionNotReceptive:
        "D. Condizioni potenziali di infezione ma pianta non recettiva.",
      leafInfectionOccurred:
        "E. È avvenuta l'infezione fogliare — periodo di incubazione in corso.",
      sporulationOccurred: "F. È avvenuta la sporulazione.",
      sporulationEnded: "G. La sporulazione è terminata.",
    },
    eventDotLabels: {
      sporangium: "Sporangio",
      zoospores: "Zoospore",
      dispersion: "Dispersione",
      notReceptive: "Non recettiva",
      infection: "Infezione",
      sporulation: "Sporulazione",
      end: "Fine",
    },
    chart: {
      title: "Germinazione oospore e fasi",
      familyLabel: "Fam. {n}",
    },
  },
  modelDashboard: {
    titlePlaceholder: "Titolo dashboard…",
    defaultTitle: "Dashboard modelli",
    refreshing: "In corso…",
    refreshAll: "Aggiorna tutti",
    finishEdit: "Fine modifica",
    editLayout: "Modifica layout",
    emptyState: "Nessun modello. Clicca",
    emptyStateHint: "Modifica layout → + Aggiungi",
    drag: "Trascina",
    customize: "Personalizza",
    remove: "Rimuovi",
    addModel: "Aggiungi modello",
    noDataHint: "Nessun dato. Clicca",
    noDataHintSuffix: "per eseguire il modello.",
    addModalTitle: "Aggiungi modello alla dashboard",
    field: "Campo",
    chooseField: "— scegli campo —",
    model: "Modello",
    chooseModel: "— scegli modello —",
    defenseGroup: "Difesa",
    mode: "Modalità",
    cancel: "Annulla",
    customizeCardTitle: "Personalizza card",
    cardTitleLabel: "Titolo",
    save: "Salva",
    modeCompact: "Compatta",
    modeCard: "Card",
    modeFull: "Completa",
  },
  dssModelsView: {
    pageTitle: "Modelli DSS",
    farmFallback: "Azienda",
    field: "Campo",
    chooseField: "— scegli campo —",
    model: "Modello",
    chooseModel: "— scegli modello —",
    defenseGroup: "Difesa",
    visualization: "Visualizzazione",
    modeFull: "Full",
    modeCard: "Card",
    modeMicrocard: "Microcard",
    modeMobile: "Mobile",
    runModel: "Esegui modello",
    hideJson: "Nascondi JSON",
    rawJson: "JSON grezzo",
    forceRecalculate: "Forza ricalcolo",
    advancedOptions: "Opzioni avanzate",
    runEndDate: "Data fine run",
    runEndDateHint: "(vuoto = oggi / fine stagione)",
    active: "attiva",
    fieldLabel: "Campo:",
    cropLabel: "Coltura:",
    modelLabel: "Modello:",
    cachedResult: "Risultato dalla cache",
    executionError: "Errore esecuzione modello",
    badgeCard: "Card",
    cardPreviewNote:
      "Anteprima card dashboard — click per aprire il dettaglio completo.",
    badgeMobilePreview: "Mobile preview",
    mobilePreviewNote:
      "Simulazione viewport mobile (375px) — il layout adattivo è gestito via CSS.",
    badgeMicrocard: "Microcard",
    microcardPreviewNote:
      "Anteprima microcard — click per aprire il dettaglio completo.",
    microcardHint: "← così apparirebbe in una cella o dashboard",
    placeholderHint: "Seleziona campo, modello e modalità, poi clicca",
    breadcrumbDss: "DSS",
    breadcrumbTestModels: "Test modelli",
  },
  modelDashboardView: {
    pageTitle: "Dashboard modelli",
    farmFallback: "Azienda",
    noSeasonSelected: "Seleziona una stagione per visualizzare la dashboard.",
    debugLink: "debug",
    breadcrumbDss: "DSS",
    breadcrumbDashboard: "Dashboard",
  },
  modelStructure: {
    olivePheno: "Fenologia dell'olivo",
    grapePheno: "Fenologia della vite",
    irrigation: "Irrigazione",
    nutrition: "Concimazione",
    oliveFlyDss: "DSS Mosca dell'olivo",
    grapeLobesia: "Tignoletta della vite",
    grapePowdery: "Oidio",
    grapePlasmo: "Peronospora - 3-10 Goidanich",
    botrytis: "Botrite",
    botrytisGonzalez: "Botrite González (sperimentale)",
    plasmoPlus: "Peronospora Plus - modello epidemiologico",
    plasmoMl: "Peronospora Machine Learning  - rischio sintomi",
    powderyMl: "Oidio Machine Learning - rischio sintomi",
    botrytisMl: "Botrite Machine Learning - rischio sintomi",
    maturation: "Maturazione",
    cornDiabro: "Diabrotica virgifera",
    cornOstrinia: "Ostrinia nubilalis",
    cornHeli: "Helicoverpa armigera",
  },
  // ── Vocabolario tipi evento zoo (animal_custom_form.form_name, valore fisso da DB — vedi I18N_TODO.md) ──
  eventTypeVocab: {
    "Lattazione (IN/OUT)": "Lattazione (IN/OUT)",
    Parto: "Parto",
    Salute: "Salute",
    "Produzione Latte": "Produzione Latte",
    Razione: "Razione",
    "Interventi Sanitari": "Interventi Sanitari",
    Urea: "Urea",
    Ecografia: "Ecografia",
  },
  // ── Vocabolario colture (crop.name, valore fisso da DB — vedi I18N_TODO.md) ──
  cropVocab: {
    Abete: "Abete",
    Acero: "Acero",
    "Actinidia (Kiwi)": "Actinidia (Kiwi)",
    Aglio: "Aglio",
    Albicocco: "Albicocco",
    Alloro: "Alloro",
    Amaranto: "Amaranto",
    Arachide: "Arachide",
    "Arborea generica": "Arborea generica",
    "Arundo Donax": "Arundo Donax",
    Asparago: "Asparago",
    Assenzio: "Assenzio",
    Avena: "Avena",
    Bambu: "Bambu",
    Barbabietola: "Barbabietola",
    Basilico: "Basilico",
    Bosco: "Bosco",
    "Broccoletto o Cime Di Rapa": "Broccoletto o Cime Di Rapa",
    Calendula: "Calendula",
    Calla: "Calla",
    Canapa: "Canapa",
    Carciofo: "Carciofo",
    Cardi: "Cardi",
    Carota: "Carota",
    Castagno: "Castagno",
    Cavolfiore: "Cavolfiore",
    Cavolo: "Cavolo",
    "Cavolo Broccolo": "Cavolo Broccolo",
    "Cavolo Rapa": "Cavolo Rapa",
    Cece: "Cece",
    Cedro: "Cedro",
    Cetriolo: "Cetriolo",
    "Chenopodium Quinoa": "Chenopodium Quinoa",
    Cicerchia: "Cicerchia",
    Cicoria: "Cicoria",
    Ciliegio: "Ciliegio",
    "Ciliegio Acido (Marasca,Visciola,Amarena)":
      "Ciliegio Acido (Marasca,Visciola,Amarena)",
    "Cipolla Anche Di Tipo Lungo (Echalion)":
      "Cipolla Anche Di Tipo Lungo (Echalion)",
    Cipresso: "Cipresso",
    Cocomero: "Cocomero",
    "Colture varie": "Colture varie",
    Colza: "Colza",
    Corbezzolo: "Corbezzolo",
    Coriandolo: "Coriandolo",
    Cotogno: "Cotogno",
    Elicriso: "Elicriso",
    "Erba Medica": "Erba Medica",
    "Erbacea generica": "Erbacea generica",
    Erbaio: "Erbaio",
    Eucalipto: "Eucalipto",
    Facelia: "Facelia",
    Fagiolino: "Fagiolino",
    Fagiolo: "Fagiolo",
    "Fagiolo Dall'Occhio": "Fagiolo Dall'Occhio",
    Farnia: "Farnia",
    Farro: "Farro",
    "Fave, Favino E Favette": "Fave, Favino E Favette",
    "Festuca (Sp. Festuca Pratensis Huds.)":
      "Festuca (Sp. Festuca Pratensis Huds.)",
    Fico: "Fico",
    Finocchio: "Finocchio",
    Fiordaliso: "Fiordaliso",
    Fragola: "Fragola",
    Gelso: "Gelso",
    "Giaggiolo (Iris) Pallida": "Giaggiolo (Iris) Pallida",
    "Giaggiolo o Giglio Bianco Iris Fiorentina":
      "Giaggiolo o Giglio Bianco Iris Fiorentina",
    Ginepro: "Ginepro",
    Ginestrino: "Ginestrino",
    Girasole: "Girasole",
    Giuggiolo: "Giuggiolo",
    "Grano (Frumento) Tenero": "Grano (Frumento) Tenero",
    "Grano (Frumento) duro": "Grano (Frumento) duro",
    "Grano Saraceno": "Grano Saraceno",
    "Grano Turanicum o Frumento Orientale o Grano Khorasan":
      "Grano Turanicum o Frumento Orientale o Grano Khorasan",
    "Indivia o Scarola": "Indivia o Scarola",
    Issopo: "Issopo",
    Lampone: "Lampone",
    "Lattuga Lattughino": "Lattuga Lattughino",
    Lavanda: "Lavanda",
    Leccio: "Leccio",
    Lenticchia: "Lenticchia",
    Limone: "Limone",
    Lino: "Lino",
    "Loietto (Sp. Lolium X Boucheanum Kunt.)":
      "Loietto (Sp. Lolium X Boucheanum Kunt.)",
    "Loietto Loglio": "Loietto Loglio",
    "Loietto Loglio Perenne/Loietto Inglese":
      "Loietto Loglio Perenne/Loietto Inglese",
    "Loto (Kaki) (Compreso Il Caco Mela)":
      "Loto (Kaki) (Compreso Il Caco Mela)",
    Lupinella: "Lupinella",
    Lupino: "Lupino",
    Luppolo: "Luppolo",
    "Lycium Barbarum (Goji)": "Lycium Barbarum (Goji)",
    Mais: "Mais",
    Mandorlo: "Mandorlo",
    Melanzana: "Melanzana",
    Melissa: "Melissa",
    Melo: "Melo",
    Melograno: "Melograno",
    Melone: "Melone",
    Menta: "Menta",
    "Menta Piperita": "Menta Piperita",
    Miglio: "Miglio",
    'Mirtilli Rossi, Mirtilli Neri Ed Altri Frutti Del Genere "Vaccinium"':
      'Mirtilli Rossi, Mirtilli Neri Ed Altri Frutti Del Genere "Vaccinium"',
    Mirto: "Mirto",
    More: "More",
    Nespolo: "Nespolo",
    Nocciolo: "Nocciolo",
    Noce: "Noce",
    "Olivello o Olivello Spinoso": "Olivello o Olivello Spinoso",
    Olivo: "Olivo",
    Orzo: "Orzo",
    Panico: "Panico",
    "Pascolo Arborato - Tara 50%": "Pascolo Arborato - Tara 50%",
    "Pascolo Polifita": "Pascolo Polifita",
    Passiflora: "Passiflora",
    Patata: "Patata",
    "Paulownia Tomentosa": "Paulownia Tomentosa",
    Peperoncino: "Peperoncino",
    Peperone: "Peperone",
    Pero: "Pero",
    Pesco: "Pesco",
    "Pesco Nettarina": "Pesco Nettarina",
    "Piante Aromatiche E Medicinali E Spezie":
      "Piante Aromatiche E Medicinali E Spezie",
    Pino: "Pino",
    "Pino Domestico": "Pino Domestico",
    Pioppo: "Pioppo",
    "Pioppo Bianco": "Pioppo Bianco",
    Pisello: "Pisello",
    Pistacchio: "Pistacchio",
    Pomodoro: "Pomodoro",
    Porro: "Porro",
    "Prati Permanenti Naturali Con Vincoli Ambientali":
      "Prati Permanenti Naturali Con Vincoli Ambientali",
    "Prato In Rotolo (Tappeto Erboso)": "Prato In Rotolo (Tappeto Erboso)",
    "Prato Pascolo": "Prato Pascolo",
    "Prato Polifita": "Prato Polifita",
    Prezzemolo: "Prezzemolo",
    Prugne: "Prugne",
    Prugnolo: "Prugnolo",
    Radicchio: "Radicchio",
    Rafano: "Rafano",
    Ravanello: "Ravanello",
    "Ribes Bianco (Uva Spina)": "Ribes Bianco (Uva Spina)",
    "Ribes Nero": "Ribes Nero",
    "Ribes Rosso": "Ribes Rosso",
    Risone: "Risone",
    Rosa: "Rosa",
    "Rosa Canina": "Rosa Canina",
    Rosmarino: "Rosmarino",
    Rucola: "Rucola",
    Ruscus: "Ruscus",
    Salvia: "Salvia",
    Scalogno: "Scalogno",
    Sedano: "Sedano",
    Senape: "Senape",
    Soia: "Soia",
    Sorbo: "Sorbo",
    Sorgo: "Sorgo",
    Spinacio: "Spinacio",
    "Sughera Quercia Da Sughero": "Sughera Quercia Da Sughero",
    Sulla: "Sulla",
    Susino: "Susino",
    Tabacco: "Tabacco",
    Tartufo: "Tartufo",
    Tiglio: "Tiglio",
    Timo: "Timo",
    Topinambur: "Topinambur",
    Trifoglio: "Trifoglio",
    "Trifoglio (Sp. Trifolium Alexandrinum L.)":
      "Trifoglio (Sp. Trifolium Alexandrinum L.)",
    "Trifoglio (Sp. Trifolium Incarnatum L.)":
      "Trifoglio (Sp. Trifolium Incarnatum L.)",
    "Trifoglio (Sp. Trifolium Pratense L.)":
      "Trifoglio (Sp. Trifolium Pratense L.)",
    "Trifoglio (Sp. Trifolium Repens L.)":
      "Trifoglio (Sp. Trifolium Repens L.)",
    "Trifoglio (Sp. Trifolium Resupinatum L.)":
      "Trifoglio (Sp. Trifolium Resupinatum L.)",
    "Trifoglio (Sp. Trifolium Squarrosum L.)":
      "Trifoglio (Sp. Trifolium Squarrosum L.)",
    Triticale: "Triticale",
    Vecce: "Vecce",
    "Veccia Sativa": "Veccia Sativa",
    Viburno: "Viburno",
    Vite: "Vite",
    Zafferano: "Zafferano",
    Zucca: "Zucca",
    Zucchino: "Zucchino",
  },
  // Vocabolario nomi crop_operation.name / survey_schema.name — vedi I18N_TODO.md.
  // Le voci custom per-organizzazione (create via AdminDbmngView) non sono qui e
  // ricadono sul fallback al valore grezzo dal DB (stesso pattern di cropVocab).
  schemaVocab: {
    "Altra operazione": "Altra operazione",
    "Concimazione Fogliare e Biostimolanti":
      "Concimazione Fogliare e Biostimolanti",
    Concimazione: "Concimazione",
    "Distribuzione effluenti": "Distribuzione effluenti",
    Irrigazione: "Irrigazione",
    "Lavorazione del suolo": "Lavorazione del suolo",
    Potatura: "Potatura",
    Raccolta: "Raccolta",
    "Semina/Trapianto": "Semina/Trapianto",
    Sovescio: "Sovescio",
    Trattamenti: "Trattamenti",
    "Trattamenti mosca dell'olivo": "Trattamenti mosca dell'olivo",
    "Botrite della vite": "Botrite della vite",
    Catture: "Catture",
    "Catture - Tignoletta della vite": "Catture - Tignoletta della vite",
    "Catture old": "Catture old",
    "Fenologia dell'olivo": "Fenologia dell'olivo",
    "Fenologia della vite": "Fenologia della vite",
    "Infestazione - Tignoletta della vite":
      "Infestazione - Tignoletta della vite",
    "Mosca dell'olivo - Infestazione completa":
      "Mosca dell'olivo - Infestazione completa",
    "Mosca dell'olivo - Infestazione semplice":
      "Mosca dell'olivo - Infestazione semplice",
    "Oidio della vite": "Oidio della vite",
    "Peronospora della vite": "Peronospora della vite",
    "Profondità di Falda": "Profondità di Falda",
    propagazione: "Propagazione",
    Sprouting: "Germogliazione",
    Morfologia: "Morfologia",
    Diameter: "Diametro",
    Agroduino: "Agroduino",
    Adversities: "Avversità",
    "prelievo snips": "Prelievo snips",
    "Fisiologia e avversità": "Fisiologia e avversità",
    Spilocea: "Spilocea",
    Fenologia: "Fenologia",
    "Installa il cartellino": "Installa il cartellino",
  },
  syncMonitor: {
    modalTitle: "Stato Sincronizzazione",
    sseConnection: "Connessione SSE",
    connected: "Connesso",
    disconnected: "Disconnesso",
    network: "Rete",
    online: "Online",
    offline: "Offline",
    lastDataSync: "Ultimo sync dati",
    never: "Mai",
    lastVocabSync: "Ultimo sync vocabolari",
    queuedRecords: "Record in coda",
    lastPush: "Ultimo push",
    recentFarmChanges: "Ultime modifiche aziendali",
    hideJson: "Nascondi JSON",
    showJson: "Mostra JSON",
    close: "Chiudi",
    recentErrors: "Errori recenti ({count})",
    clear: "Cancella",
    updateVocab: "Aggiorna Vocabolari",
    syncingLabel: "Sincronizzazione...",
    syncAll: "Sincronizza Tutto",
    clickForStatus: "Clicca per vedere lo stato della sincronizzazione",
    statusChecking: "Controllo...",
    statusUpdatingDefault: "Aggiornamento...",
    statusSynced: "Sincronizzato",
    statusUpdatedDefault: "Aggiornato",
    statusError: "Errore ({count})",
    statusReconnecting: "Riconnessione...",
    now: "adesso",
    minutesAgo: "{n} min fa",
    hoursAgo: "{n}h fa",
    daysAgo: "{n}g fa",
    neverSynced: "Mai sincronizzata",
    resyncError: "Errore durante la risincronizzazione",
    vocabResyncError: "Errore aggiornamento vocabolari",
    syncError: "Errore durante la sincronizzazione",
    syncFailed: "Sincronizzazione fallita",
    checkError: "Errore durante il controllo novità",
    updatingFarms: "Aggiornamento {n} {farms}...",
    updatedFarms: "Aggiornate {n} {farms}",
    vocabUpdated: "Vocabolari aggiornati",
    farmSingular: "azienda",
    farmPlural: "aziende",
  },
  invitationsBanner: {
    title: "Inviti Ricevuti",
    pendingSingular: "Hai 1 invito in sospeso:",
    pendingPlural: "Hai {n} inviti in sospeso:",
    typeTeam: "Team azienda",
    typeOrg: "Organizzazione",
    invitedBy: "Invitato da {name}",
    accept: "Accetta",
    reject: "Rifiuta",
    newProfileCreated:
      "Nuovo profilo creato. Potrai selezionarlo al prossimo login.",
  },
  invitationModal: {
    title: "Invito ricevuto",
    invitedBy: "Invitato da",
    acceptOrgDesc: "Accettando entrerai a far parte di questa organizzazione.",
    reject: "Rifiuta",
    waiting: "Attendere…",
    accept: "Accetta",
    acceptError: "Errore durante l'accettazione",
    alreadyHaveProfile: "Hai già un profilo in un'altra organizzazione.",
    newProfileWillBeCreatedFor: "Accettando verrà creato un nuovo profilo per",
    switchProfileHint:
      "Potrai passare da un profilo all'altro usando il selettore profili al login.",
    cancel: "Annulla",
    creating: "Creazione…",
    createNewProfile: "Crea nuovo profilo",
    newProfileCreatedFor: "Nuovo profilo creato per",
    selectFromProfileMenu: "Selezionalo dal menu profili al prossimo login.",
    joinedOrg: "Sei entrato nell'organizzazione",
    close: "Chiudi",
  },
  moscaCounter: {
    stingNo: "Puntura NO",
    stingYes: "Puntura SI",
    infestationAt: "Infestazione al",
    stingsOutOfObserved: "{si} punture su {total} olive osservate",
    motivationFirst: "Osserva la tua prima oliva..",
    motivationAtLeast50: "Osserva almeno 50 olive!",
    motivationKeepGoing: "Forza dai! Ancora qualche oliva..",
    motivationAlmost100: "A questo punto che fai? Non ci arrivi a 100 olive?!",
    motivationGreatJob: "🥳 Ottimo lavoro!",
  },
  moscaCompletaCounter: {
    totalObserved: "Totale olive osservate",
    eggs: "Uova",
    warningTitle: "⚠️ Attenzione:",
    warningExceedsTotal:
      "La somma degli stadi infestati ({infested}) supera il totale olive ({total})",
    activeLabel: "Attiva (U+L1v+L2v)",
    harmfulLabel: "Dannosa (L3v+L3m+Pv+Pm+Fu)",
    totalInfestations: "Totale infestazioni",
  },
  activitySummary: {
    irrigation: "Irrigazione",
    productKgHa: "{name}: {amount} kg/ha",
    fertilization: "Concimazione",
    organicFertilization: "Concimazione organica",
    greenManure: "Sovescio",
    pruning: "Potatura",
    totalQty: "{qty} {uom} totali",
    harvest: "Raccolta",
    tillage: "Lavorazione",
    productDoseHa: "{name}: {dose} {uom}/ha",
    sowingTransplanting: "Semina/Trapianto",
    treatment: "Trattamento",
    insectsCount: "{n} insetti",
    trapName: "Trappola: {name}",
    trapMonitoring: "Monitoraggio trappola",
    totAbbrev: "Tot",
    olivesCount: " ({n} olive)",
    fullFlySummary: "Mosca completa: {parts}{olives}",
    oliveFlyNoObservations: "Mosca dell'olivo — nessuna oliva osservata",
    oliveFlySummary:
      "Mosca olivo: {pct}% infestazione ({si} punture su {tot} olive)",
    phenology: "Fenologia",
    birth: "Parto: {f}F {m}M{dead}",
    birthDead: " {dead} morti",
    ultrasound: "Ecografia: {result}{days}",
    ultrasoundDaysExpected: ", {gg} gg previsti",
    lactation: "Lattazione: dal {start} al {end}",
    health: "Salute: {type}",
    healthEvent: "Evento sanitario",
  },
  spadeQuestions: {
    ui: {
      newTestTitle: "Nuovo Test della Vanga",
      newTestSubtitle: "Inserisci le informazioni generali del campione",
      sampleCode: "Codice campione",
      sampleCodePlaceholder: "Es. Campo Nord — Punto 1",
      date: "Data",
      latitude: "Latitudine",
      latitudePlaceholder: "Es. 43.6",
      longitude: "Longitudine",
      longitudePlaceholder: "Es. 10.6",
      gpsSearching: "Ricerca in corso…",
      useGpsLocation: "Usa posizione GPS",
      cancel: "Annulla",
      startTest: "Inizia il test →",
      readInstructions: "Leggi le istruzioni qui sopra e procedi.",
      layerN: "Strato {n}",
      back: "← Indietro",
      saveExit: "Salva ed esci",
      next: "Avanti →",
      finish: "Concludi →",
      testCompleted: "Test completato",
      soilQualityAvg: "Qualità media del suolo:",
      hideLayerDetails: "Nascondi dettagli strati",
      showLayerDetails: "Mostra dettagli strati",
      slope: "Pendenza",
      fieldCover: "Copertura campo",
      texture: "Tessitura",
      shearResistance: "Resistenza taglio",
      notes: "Note",
      additionalNotes: "Note aggiuntive",
      notesPlaceholder: "Osservazioni libere sul campione…",
      reviewButton: "← Rivedi",
      saveObservation: "Salva osservazione",
      geoNotSupported: "Geolocalizzazione non supportata dal browser",
      geoError: "Impossibile ottenere la posizione: {message}",
      fillLayerAnswer: "Compila la risposta per lo Strato {n}",
      selectAnAnswer: "Seleziona una risposta",
      invalidLayerCount: "Inserisci un numero di strati valido (1–10)",
      invalidLayerDepths:
        "Le profondità degli strati devono essere numeri interi crescenti",
      notAvailable: "N/D",
      shortLabel: {
        agshp: "Aggregati",
        comp: "Compattezza",
        moist: "Umidità",
        typor: "Residui organici",
        decor: "Decomposizione",
        smell: "Odore",
        rootp: "Radici",
        col: "Colore suolo",
        sq: "Qualità SQ",
      },
    },
    sqLabels: {
      1: "Ottimo",
      2: "Buono",
      3: "Medio",
      4: "Scarso",
      5: "Pessimo",
    },
    questions: {
      fslo: {
        label: "Qual è la pendenza del campo?",
        answers: {
          flat: "Piano",
          low: "Bassa pendenza (<5%)",
          medium: "Media pendenza (6–20%)",
          high: "Alta pendenza (21–60%)",
          very_high: "Molto alta (>60%)",
        },
      },
      fcov: {
        label: "Qual è la copertura prevalente del campo?",
        answers: {
          bare_soil: "Suolo nudo",
          arable: "Coltura arabile",
          horticolture: "Coltura orticola",
          tree_crop: "Coltura arborea",
          forest: "Foresta",
          grassland: "Prato / Pascolo",
        },
      },
      pcov: {
        label: "Cosa contiene l'area di campionamento?",
        answers: {
          crop: "Prevalentemente coltura",
          weeds: "Prevalentemente erbacce",
          soil: "Prevalentemente suolo nudo",
        },
      },
      leg: {
        label: "Stai campionando un suolo con leguminose?",
        answers: {
          yes: "Sì",
          no: "No",
        },
      },
      sois: {
        label: "Cosa osservi sulla superficie del suolo?",
        help: "Seleziona tutto ciò che è visibile sulla superficie del suolo.",
        answers: {
          crust: "Crosta superficiale",
          logging: "Ristagno idrico",
          erosion: "Segni di erosione",
          compaction: "Segni di compattamento",
          algae: "Crescita di alghe",
          cracks: "Screpolature",
        },
      },
      wilpla: {
        label: "Vedi queste piante spontanee nel punto di campionamento?",
        help: "Seleziona le specie presenti in abbondanza.",
        answers: {
          stellaria: "Stellaria media",
          veronica: "Veronica spp.",
          galinsoga: "Galinsoga parviflora",
          capsella: "Capsella bursa-pastoris",
          urtica: "Urtica spp.",
          poa: "Poa annua",
          acalypha: "Acalypha virginica",
          echinochloa: "Echinochloa crus-galli",
          polygonum: "Polygonum aviculare",
          matricaria: "Matricaria chamomilla",
          plantago: "Plantago spp.",
          taraxacum: "Taraxacum officinale",
        },
      },
      info_sample: {
        label: "Come prelevare il campione",
        help: "Inserisci la vanga verticalmente nel suolo fino alla profondità massima. Solleva il campione e sistemalo su una superficie piana. Identifica gli strati visibili e procedi con le osservazioni strato per strato.",
      },
      ressli: {
        label: "Come resiste il suolo al taglio della vanga?",
        help: "Valuta la resistenza durante l'inserimento della vanga.",
        answers: {
          easy: "Facile da tagliare fino alla profondità della vanga",
          hard_uniform: "Uniformemente difficile da tagliare",
          hard_alternation: "Alternanza di parti facili e difficili",
        },
      },
      stext: {
        label: "Qual è la tessitura del suolo nel punto di osservazione?",
        answers: {
          sand: "Sabbioso",
          av_text: "Medio impasto",
          clay: "Argilloso",
        },
      },
      laynum: {
        label: "Inserisci il numero di strati visibili nel profilo",
        help: "Conta il numero di strati distinti visibili (generalmente 1–3, massimo 10).",
        placeholder: "Es. 2",
      },
      laydep: {
        label: "A che profondità (cm) arriva ogni strato?",
        help: "Inserisci la profondità cumulativa dalla superficie per ogni strato. I valori devono essere crescenti.",
        placeholder: "Profondità in cm",
      },
      agshp: {
        label: "Qual è la forma degli aggregati del suolo?",
        answers: {
          granular: "Granulare",
          crumb: "Grumoso",
          blocky_small: "Poliedrico piccolo",
          blocky_large: "Poliedrico grande",
          sub_blocky_small: "Sub-poliedrico piccolo",
          sub_blocky_large: "Sub-poliedrico grande",
          platy: "Lamellare",
          structureless: "Senza struttura",
        },
      },
      agdim: {
        label: "Dimensione più frequente degli aggregati (mm)",
        placeholder: "Dimensione media in mm",
      },
      comp: {
        label: "Quanto è compatto lo strato del suolo?",
        answers: {
          loose: "Soffice",
          lightly_compacted: "Leggermente compatto",
          very_compacted: "Molto compatto",
        },
      },
      moist: {
        label: "Quanto è umido il suolo?",
        help: "Prendi una manciata di suolo e prova a romperla con le mani.",
        answers: {
          dry: "Secco — non si rompe perché troppo duro",
          wet: "Bagnato — non si rompe perché plastico",
          good: "Ottimale — si rompe facilmente in aggregati",
        },
      },
      col: {
        label: "Osservando il colore del suolo, vedi questi segni?",
        answers: {
          ocra: "Macchie ocra / rugginose / nere / bianche",
          grey: "Colore grigio-verde-blu",
        },
      },
      typor: {
        label: "Che tipo di residui organici sono presenti?",
        answers: {
          no_residues: "Nessun residuo",
          manure: "Letame o compost",
          residues: "Residui vegetali",
          straw: "Paglia",
          roots: "Radici vecchie",
        },
      },
      decor: {
        label: "Quanto sono decomposti i residui organici?",
        answers: {
          intact: "Integro (originale riconoscibile)",
          medium_decomposed:
            "Mediamente decomposto (riconoscibile con difficoltà)",
          well_decomposed: "Ben decomposto (non più riconoscibile)",
        },
      },
      smell: {
        label: "Come odora il suolo?",
        answers: {
          no_smell: "Nessun odore",
          good_smell: "Buono (terroso / legnoso)",
          bad_smell: "Cattivo (putrefazione)",
        },
      },
      rootp: {
        label: "Vedi radici nello strato?",
        answers: {
          no_roots: "Nessuna radice",
          few_roots: "Pochissime radici",
          lot_roots: "Molte radici",
        },
      },
      roott: {
        label: "Vedi tubercoli della leguminosa?",
        help: "I tubercoli si trovano sulle radici. Se aperti e rossi all'interno sono attivi (fissano azoto).",
        helpImageCaptions: {
          0: "Leguminosa con tubercoli radicali",
          1: "Tubercolo aperto (rosso = attivo)",
        },
        answers: {
          no_nodules: "Nessun tubercolo",
          yes_few: "Sì, pochi",
          yes_many: "Sì, molti",
          yes_not_red: "Sì, ma non rossi se aperti",
        },
      },
      earthw: {
        label: "Vedi segni della presenza di lombrichi?",
        answers: {
          earthworm: "Lombrico",
          hole: "Galleria / Foro",
          cast: "Escremento (cilind.)",
        },
      },
      biodivoth: {
        label: "Vedi segni di altra fauna del suolo?",
        answers: {
          beetles: "Coleotteri",
          soil_centipedes: "Centopiedi del suolo",
          tropical_centipedes: "Centopiedi tropicali",
          millipedes: "Millepiedi",
          beetle_larvae: "Larve di coleottero",
        },
      },
      sq: {
        label: "Come valuti complessivamente questo strato?",
        help: "1 = ottima qualità strutturale, 5 = qualità molto scadente.",
        answers: {
          1: "1 — Ottimo",
          2: "2 — Buono",
          3: "3 — Medio",
          4: "4 — Scarso",
          5: "5 — Pessimo",
        },
      },
      note: {
        label: "Note aggiuntive",
        placeholder: "Osservazioni aggiuntive sul campione...",
      },
    },
  },
  plantSurveyEditor: {
    changeSchemaMode: "Cambia scheda/modalità",
    validateData: "Valida Dati",
    saving: "Salvataggio...",
    saveChanges: "Salva Modifiche",
    step1SelectSchema: "1. Seleziona Scheda Rilievo",
    loadingSchemas: "Caricamento schede...",
    noSchemasAvailable: "Nessuna scheda disponibile",
    selectSchemaPlaceholder: "Seleziona scheda...",
    step2SelectMode: "2. Seleziona Modalità",
    modeTable: "Tabella",
    modeGrid: "Griglia",
    step3SelectVariable: "3. Seleziona Variabile",
    proceed: "Prosegui",
    insert: "Inserisci",
    edit: "Modifica",
    attention: "Attenzione:",
    orphanedSurveysMessage:
      "Ci sono {n} rilievi collegati a piante che non esistono più.",
    deleteOrphanedSurveys: "Elimina rilievi orfani",
    unsavedChangesWarning:
      "Hai modifiche non salvate. Salva prima di cambiare modalità o navigare via, altrimenti i dati verranno persi.",
    exitFullscreen: "Esci da schermo intero",
    fullscreen: "Schermo intero",
    validationCompleted: "Validazione Completata",
    validationErrorsTitle: "Errori di Validazione",
    errorsLabel: "Errori:",
    newRecords: "Nuovi record",
    modifiedRecords: "Record modificati",
    deletedRecords: "Record eliminati",
    total: "Totale",
    dataValidReadyToSave: "I dati sono validi e pronti per il salvataggio.",
    close: "Chiudi",
    confirmAndSave: "Conferma e Salva",
    columnRow: "Fila",
    columnColumn: "Colonna",
    columnAccession: "Accessione",
    columnVariety: "Varietà",
    columnSurveyDate: "Data Rilievo",
    columnDate: "Data",
    duplicateRecordError:
      "Errore: trovati record duplicati per la stessa pianta alla data {date}",
    confirmDiscardModeChange:
      "Hai modifiche non salvate. Cambiando modalità i dati verranno persi. Continuare?",
    confirmDiscardDateChange:
      "Hai modifiche non salvate. Cambiando data i dati verranno ricaricati e le modifiche persi. Continuare?",
    confirmDiscardGoBack:
      "Hai modifiche non salvate. Se torni indietro i dati verranno persi. Continuare?",
    confirmLeavePage:
      "Hai modifiche non salvate che andranno perse. Vuoi abbandonare la pagina?",
    noVariableSelectedForGrid:
      "Nessuna variabile selezionata per modalità griglia",
    noDataToSave: "Nessun dato da salvare",
    duplicatePlantCode: "Plant code duplicato: {code}",
    saveErrorMessage: "Errore durante il salvataggio: {message}",
    modifiedCell: "Modificato",
    unnamedSchema: "Schema senza nome",
    schemaHasDataLabel: "{name}  ·  dati presenti",
  },
  plantManager: {
    plantsCreated: "Piante create",
    createPlants: "Crea Piante",
    saveConfiguration: "Salva Configurazione",
    resetPlants: "Reset Piante",
    removeAccessions: "Rimuovi Accessioni",
    map: "Mappa",
    table: "Tabella",
    guidedConfiguration: "Configurazione guidata",
    firstPlantFirstRow: "Prima pianta del primo filare",
    clickMapStartingPoint:
      "Clicca sulla mappa per posizionare il punto di partenza",
    lastPlantFirstRow: "Ultima pianta del primo filare",
    clickMapRowDirection:
      "Clicca sulla mappa per definire direzione e lunghezza del filare",
    directionLengthCalculated: "Direzione e lunghezza calcolate",
    plantsPerRow: "Piante per filare",
    spacing: "Spaziatura",
    number: "Numero",
    rowSpacingLabel: "Spaziatura sulla fila (m)",
    plantsPerRowLabel: "Piante per filare",
    next: "Avanti",
    mBetweenPlants: "{n} m tra le piante",
    nPlants: "{n} piante",
    firstPlantLastRow: "Prima pianta dell'ultimo filare",
    clickMapRowSpacingDirection:
      "Clicca sulla mappa per definire la direzione e distanza tra filari",
    rowSpacingCalculated: "Interfila calcolata",
    numberOfRows: "Numero filari",
    interRow: "Interfila",
    rowDistanceLabel: "Distanza tra filari (m)",
    numberOfRowsLabel: "Numero filari",
    finishConfiguration: "Concludi configurazione",
    back: "← Indietro",
    cancel: "Annulla",
    gridConfiguration: "Configurazione Griglia",
    startGuidedWizard: "Avvia wizard guidato",
    numberOfFiles: "Numero File",
    betweenRows: "Tra le file (m)",
    onTheRow: "Sulla fila (m)",
    rotationDegrees: "Rotazione (gradi)",
    layoutType: "Tipo di Sesto",
    rectangular: "Rettangolare",
    quincunx: "Quinconce",
    startingPoint: "Punto di partenza",
    firstPlantFirstRowDesc: "Prima pianta della prima fila.",
    cancelSelection: "Annulla selezione",
    chooseOnMap: "Scegli sulla mappa",
    remove: "Rimuovi",
    plotCentroid: "Centroide dell'appezzamento",
    selectMarkingMode:
      "Seleziona una modalità per marcare le piante, oppure clicca una pianta per vederne i dettagli.",
    info: "Info",
    nonExisting: "Non esistente",
    dead: "Morta",
    totalPositions: "Posizioni totali",
    existingPlants: "Piante esistenti",
    layoutSpacing: "Sesto (Spaziatura)",
    estimatedArea: "Area Stimata",
    density: "Densità",
    plantsPerHa: "piante/ha",
    noPlantsGenerated: "Nessuna pianta generata.",
    accessions: "Accessioni",
    withAccession: "Con accessione",
    uploadAccessionsExcel: "Carica Accessioni (Excel)",
    downloadTemplateHelp:
      "Scarica il template in Excel, compilalo e ricaricalo per associare le accessioni.",
    generating: "Generazione...",
    downloadTemplate: "Scarica Template",
    instructionsTitle: "Istruzioni compilazione",
    howToFillIn: "? Come compilare",
    excelFile: "File Excel",
    checking: "Verifica...",
    checkFile: "Verifica File",
    uploading: "Caricamento...",
    uploadAccessions: "Carica Accessioni",
    downloadFileWithErrors: "Scarica file con errori evidenziati",
    surveys: "Rilievi",
    totalSurveys: "Totale rilievi",
    noSurveysPresent: "Nessun rilievo presente",
    manageSurveys: "Gestisci Rilievi",
    viewData: "Visualizza Dati ({n})",
    updateAccessionsExcel: "Aggiorna Accessioni (Excel)",
    downloadExistingExcelHelp:
      "Scarica il file Excel con le accessioni già caricate, modificalo e ricaricalo.",
    downloadExcel: "Scarica Excel",
    updateAccessions: "Aggiorna Accessioni",
    varieties: "Varietà",
    withoutAccession: "Senza accessione",
    nonExistingPlants: "Piante non esistenti",
    present: "Presente",
    edit: "modifica",
    variety: "Varietà",
    notAvailable: "N/D",
    origin: "Origine",
    date: "Data",
    notes: "Note",
    noAccessionAssociated: "Nessuna accessione associata",
    confirmCreatePlantsTitle: "Conferma creazione piante",
    willCreatePlants: "Verranno create",
    plantsForThisPlot: "piante per questo appezzamento.",
    gridParamsWillBeSaved:
      "I parametri della griglia verranno salvati nel plot.",
    creating: "Creazione...",
    confirm: "Conferma",
    confirmResetPlantsTitle: "Conferma reset piante",
    willDeleteAllExisting: "Verranno eliminate tutte le",
    existingPlantsLower: "piante esistenti.",
    cannotProceed: "Impossibile procedere:",
    thereAreSurveysLinked: "esistono {n} rilievi collegati a queste piante.",
    deleteThemFirst: "Eliminali prima di procedere.",
    goToSurveyManagement: "Vai alla gestione rilievi",
    afterResetHelp:
      "Dopo il reset potrai modificare i parametri e ricreare le piante. Questa operazione non può essere annullata.",
    deleting: "Eliminazione...",
    deletePlants: "Elimina Piante",
    removeAccessionsTitle: "Rimuovi accessioni",
    willRemoveAllAssociations:
      "Verranno rimosse tutte le associazioni tra piante e accessioni per questo appezzamento.",
    accessionsUsedOnlyHere:
      "Le accessioni utilizzate solo da questo appezzamento verranno eliminate. Le piante rimarranno.",
    removing: "Rimozione...",
    confirmRemoval: "Conferma Rimozione",
    excelInstructionsTitle: "Istruzioni compilazione Excel",
    sectionAAccessionsSheet: "A — Foglio Accessioni",
    accessionsSheetIntro:
      "Inserisci una riga per ogni accessione (individuo/clone distinto).",
    fieldCol: "Campo",
    requiredCol: "Obbl.",
    descriptionCol: "Descrizione",
    codeInternalDesc: "Codice breve e semplice (es.",
    codeInternalDesc2: "). Viene usato nel foglio",
    codeInternalDesc3: "per popolare la matrice delle piante.",
    codeAccessionDesc:
      "Codice identificativo ufficiale dell'accessione. Almeno 6 caratteri, deve essere univoco.",
    codeVarietyDesc: "Nome della varietà associata a questa accessione.",
    sourceDesc: "Provenienza dell'accessione (testo libero, es.",
    dateAccessionDesc: "Data di acquisizione dell'accessione in formato",
    varietyFlagNew: "inserisci la varietà nel database se non esiste ancora.",
    varietyFlagOk: "sei certo dell'assegnazione di varietà.",
    varietyFlagUncertain: "assegnazione di varietà incerta.",
    noteFieldDesc: "Note libere sull'accessione. Campo facoltativo.",
    messageFieldDesc:
      "Non compilare. Viene popolato automaticamente dal sistema con eventuali messaggi di errore.",
    sectionBPlantsSheet: "B — Foglio Plants",
    plantsSheetIntro:
      "La matrice rappresenta la griglia fisica del vigneto/frutteto. Ogni cella corrisponde a una pianta.",
    plantsSheetBullet1Pre: "Per ogni pianta inserisci il",
    plantsSheetBullet1Post:
      "dell'accessione corrispondente (quello definito nel foglio Accessioni).",
    plantsSheetBullet2Pre: "Se la pianta non è presente scrivi",
    plantsSheetBullet2Mid: "; se è morta scrivi",
    plantsSheetBullet2Post: ".",
    close: "Chiudi",
    legacyFormatDetectedTitle: "Formato dati legacy rilevato",
    legacyFormatDesc:
      "Questo appezzamento utilizza il vecchio formato di configurazione griglia. Vuoi convertirlo al nuovo formato?",
    parameterCol: "Parametro",
    legacyValueCol: "Valore legacy",
    newFieldCol: "Nuovo campo",
    filesRows: "File (righe)",
    plantsPerRowCols: "Piante per fila (colonne)",
    interRowDistance: "Distanza inter-fila (m)",
    onRowDistance: "Distanza sulla fila (m)",
    angleBearing: "Angoli (bearing)",
    filesLabel: "File",
    columnsLabel: "Colonne",
    ignore: "Ignora",
    convertToNewFormat: "Converti al nuovo formato",
    home: "Home",
    farms: "Aziende",
    plants: "Piante",
    plantManagementTitle: "Gestione Piante",
    rowColHeader: "Fila",
    colHeader: "Col",
    codeHeader: "Codice",
    statusHeader: "Stato",
    accessionHeader: "Accessione",
    varietyHeader: "Varietà",
    notesHeader: "Note",
    errorGeneratingTemplate: "Errore generazione template",
    errorGeneratingTemplateRetry:
      "Piante non ancora sincronizzate col server. Attendi qualche secondo e riprova. ({msg})",
    errorPrefix: "Errore: {msg}",
    errorSaving: "Errore nel salvataggio: {msg}",
    gridParamsSaved: "Parametri griglia salvati.",
    errorCreating: "Errore nella creazione: {msg}",
    partialCreateError:
      "Create solo {count} piante su {total} richieste. {msg}",
    plantsCreatedSuccess: "Create {count} piante.",
    cannotDeletePlantsSurveys:
      'Impossibile eliminare le piante: esistono {n} rilievi collegati. Elimina prima i rilievi dalla sezione "Rilievi Piante".',
    errorDeleting: "Errore nella cancellazione: {msg}",
    plantsDeletedSuccess:
      "Piante eliminate. Ora puoi modificare i parametri e ricreare le piante.",
    plotLayerName: "Appezzamento",
    guideLinesLayerName: "Guida linee",
    guidePointsLayerName: "Guida punti",
    gridPreviewLayerName: "Anteprima griglia",
    rowPreviewLayerName: "Anteprima filare",
    plantsLayerName: "Piante",
    schemaFallback: "Schema {id}",
  },

  // ── Zoo / Allevamento (HerdHome) ──────────────────────────────────────────────
  herdHome: {
    deleteHerd: "Elimina allevamento",
    confirmDeletePermanent: "Eliminare definitivamente?",
    herdList: "Allevamenti",
    bleReader: "Lettore BLE",
    dashboard: "Dashboard",
    rations: "Razioni",
    fertility: "Fertilità",
    warningSpeciesTested:
      "Attenzione: Il sistema è stato testato principalmente su allevamenti di ovini. Alcune funzionalità potrebbero non essere completamente supportate per altre specie.",
    headsFiltered: "{filtered} / {total} capi",
    headsActive: "{count} capi attivi",
    exportBdn: "Esporta BDN",
    importBdn: "Importa da BDN",
    allSexes: "Tutti i sessi",
    allBreeds: "Tutte le razze",
    allAges: "Tutte le età",
    allGroupsFilter: "Tutti i gruppi",
    withoutGroupFilter: "Senza gruppo",
    age0_6: "< 6 mesi",
    age6_24: "6–24 mesi",
    age2_6: "2–6 anni",
    age6plus: "> 6 anni",
    reset: "Reset",
    noAnimalsFiltered: "Nessun animale corrisponde ai filtri.",
    filters: "Filtri",
    exitedAnimals: "Animali usciti ({count})",
    exportAllTitle: "Esporta tutti (attivi + usciti)",
    exportAll: "Esporta tutti",
    noExitedAnimals: "Nessun animale uscito.",
    exitColumn: "Uscita",
    confirmRestore: "Ripristinare {code}?",
    farmFallback: "Azienda",
  },

  // ── Zoo / Allevamento (HerdUpsert) ────────────────────────────────────────────
  herdUpsert: {
    titleNew: "Nuovo Allevamento",
    titleEdit: "Modifica Allevamento",
    saving: "Salvataggio...",
    herdData: "Dati gregge",
    species: "Specie",
    namePlaceholder: "Es. Pecore da latte",
    herdCode: "Codice allevamento (BDN)",
    herdCodePlaceholder: "Es. IT-0123456",
    unassignedAnimalsTitle: "Animali senza gregge trovati",
    migratePrompt:
      'Esistono {count} animali di specie "{specie}" non ancora associati a un gregge. Vuoi associarli a questo gregge?',
    notNow: "Non ora",
    migrateConfirm: "Associa {count} animali",
    nameRequired: "Nome obbligatorio",
    speciesRequired: "Specie obbligatoria",
    farmFallback: "Azienda",
    newHerdBreadcrumb: "Nuovo allevamento",
  },

  // ── Zoo / Allevamento (EventUpsertForm) ───────────────────────────────────────
  eventUpsertForm: {
    eventType: "Tipo evento",
    noSchemaAvailable:
      "Nessun schema disponibile per questo tipo di evento per la specie",
    saving: "Salvataggio...",
    dateLabel: "Data",
    selectEventType: "Seleziona il tipo di evento.",
    exhaustedSuffix: " (esaurito)",
    lastEvent: "Ultimo evento",
    viewHistory: "Vedi tutto lo storico",
    eventHistory: "Storico eventi",
    noPastEvents: "Nessun evento precedente.",
    close: "Chiudi",
  },

  // ── Zoo / Allevamento (ZooHome) ───────────────────────────────────────────────
  zooHome: {
    titleWithFarm: "Allevamento — {name}",
    bleReader: "Lettore BLE",
    newHerd: "+ Nuovo gregge",
    emptyTitle: "Nessun gregge configurato",
    emptyDesc: "Crea il primo gregge per iniziare a gestire i tuoi animali.",
    createFirstHerd: "Crea primo gregge",
    headCount: "{count} capi",
    groupCount: "{count} gruppi",
    farmFallback: "Azienda",
  },

  // ── Zoo / Allevamento (EventUpsert) ───────────────────────────────────────────
  eventUpsert: {
    titleEdit: "Modifica Evento",
    saving: "Salvataggio...",
    groupLabel: "Gruppo",
    noGroupOption: "— nessun gruppo —",
    farmFallback: "Azienda",
    zooHomeBreadcrumb: "Allevamento Home",
    animalFallback: "Animale",
    editEventBreadcrumb: "Modifica evento",
    newEventBreadcrumb: "Nuovo evento",
    goToAnimal: "Vai alla scheda animale",
    bleAlreadyRead: "Attenzione! Animale già letto oggi",
  },

  // ── Zoo / Allevamento (FertilityDashboard) ───────────────────────────────────
  fertilityDashboard: {
    pageTitlePrefix: "Fertilità",
    herdDefault: "Gregge",
    dashboardTitle: "Dashboard Fertilità",
    periodKpi: "Periodo KPI:",
    period6: "Ultimi 6 mesi",
    period12: "Ultimo anno",
    period24: "Ultimi 2 anni",
    periodAll: "Tutta la vita del gregge",
    activeFemales: "Femmine attive",
    fertility: "Fertilità",
    fertilitySub: "(femmine con eco+ / tot. femmine)",
    prolificity: "Prolificità",
    prolificitySub: "(nati/parto nel periodo)",
    deliveriesInPeriod: "Parti nel periodo",
    bornInPeriod: "Nati nel periodo",
    tabFemales: "Capi Femmine",
    tabPregnancies: "Gravidanze",
    tabEco: "Ecografie",
    tabDeliveries: "Parti",
    femaleHeadsCount: "{n} capi femmina",
    downloadCsv: "Scarica CSV",
    pregnanciesRegistered: "{n} gravidanze registrate — {period}",
    onlyOpenFuture: "Solo in corso / future",
    noPregnancies: "Nessuna gravidanza rilevata dalle ecografie.",
    daysAbbrev: "gg",
    nBorn: "{n} nati",
    examsCount: "{n} esami — {period}",
    noEcoInPeriod: "Nessuna ecografia nel periodo selezionato.",
    deliveriesCount: "{n} parti — {period}",
    noDeliveriesInPeriod: "Nessun parto nel periodo selezionato.",
    periodLabelAll: "tutta la vita del gregge",
    periodLabel6: "ultimi 6 mesi",
    periodLabel12: "ultimo anno",
    periodLabel24: "ultimi 2 anni",
    periodLabelN: "ultimi {n} mesi",
    colBirth: "Nascita",
    colEcoPos: "Eco+",
    colEcoPosDates: "Date eco+",
    colLastEco: "Ultima eco",
    colBornTotal: "Nati tot.",
    colBornM: "Nati ♂",
    colBornF: "Nati ♀",
    colAnimal: "Animale",
    colEcoList: "Ecografie (data · gg · atteso)",
    colExpectedDelivery: "Parto atteso",
    colActualDelivery: "Parto effettivo",
    colStatus: "Stato",
    colDate: "Data",
    colGestDays: "Gg gest.",
    colGestationDays: "Gg gestazione",
    colBornCount: "N. nati",
    colBornCountM: "N. nati ♂",
    colBornCountF: "N. nati ♀",
    breadcrumbFarms: "Aziende",
    breadcrumbFarmDefault: "Azienda",
    statusDelivered: "Partorito",
    statusOverdue: "Ritardo {n} gg",
    statusIn: "Fra {n} gg",
    statusExpected: "Atteso",
    formsNotFound:
      "Form non trovati (eco: {eco}, delivery: {delivery}). Verificare il campo custom_form in animal_custom_form.",
    loadErrorMsg: "Errore caricamento dati: {msg}",
  },

  // ── Zoo / Allevamento (RationsDashboard) ─────────────────────────────────────
  rationsDashboard: {
    pageTitlePrefix: "Razioni",
    herdDefault: "Allevamento",
    dashboardTitle: "Dashboard Razioni",
    step1Title: "1. Alimenti",
    step2Title: "2. Razioni",
    step3Title: "3. Assegnazioni",
    feedsConfigured: "{n} alimento/i configurati",
    addAtLeastOneFeed: "Aggiungi almeno un alimento",
    rationsDefined: "{n} razione/i definite",
    createRationWithFeeds: "Crea una razione con gli alimenti",
    assignmentsActive: "{n} assegnazione/i attive",
    assignRationToGroup: "Assegna una razione a un gruppo",
    feedsInWarehouse: "Alimenti in magazzino",
    newFeed: "Nuovo alimento",
    editFeed: "Modifica alimento",
    noFeedConfigured:
      "Nessun alimento configurato. Aggiungi mangimi, fieno, integratori…",
    uom: "UdM",
    warehouseResidual: "Residuo magazzino",
    rationsDefinedTitle: "Razioni definite",
    newRation: "Nuova razione",
    editRation: "Modifica razione",
    addFeedFirst: "Prima aggiungi almeno un alimento (passo 1).",
    noRationDefined:
      "Nessuna razione definita. Crea una razione combinando gli alimenti.",
    ration: "Razione",
    ingredientsPerHeadPerDay: "Ingredienti (qtà/capo/die)",
    head: "capo",
    newAssignmentTitle: "Nuova assegnazione razione",
    defineRationFirst: "Prima definisci almeno una razione (passo 2).",
    noGroupInHerd: "Nessun gruppo nel gregge.",
    selectGroup: "Seleziona gruppo",
    registerAssignment: "Registra assegnazione razione",
    currentSituation: "Situazione attuale",
    activeAssignments: "Assegnazioni attive",
    groupsUnderRation: "Gruppi sotto razione",
    totalDailyConsumption: "Consumo totale/die",
    firstShortageIn: "Prima carenza tra",
    rationAssignments: "Assegnazioni razioni",
    totalCount: "{n} totali",
    noAssignmentRegistered: "Nessuna assegnazione registrata.",
    from: "Dal",
    to: "Al",
    headsEstimate: "Capi (stima)",
    qtyPerDay: "Qtà/die",
    status: "Stato",
    statusActive: "Attiva",
    statusPast: "Conclusa",
    statusFuture: "Futura",
    consumptionProjectionTitle:
      "Proiezione consumi ingredienti (assegnazioni attive)",
    ingredient: "Ingrediente",
    currentResidual: "Residuo attuale",
    daysToEnd: "Gg al termine",
    residualPlus7d: "Residuo +7gg",
    residualPlus30d: "Residuo +30gg",
    residualPlus90d: "Residuo +90gg",
    projectionNote:
      "Proiezione basata sulla consistenza attuale dei gruppi. Il residuo cala ogni giorno in base al consumo stimato delle assegnazioni attive.",
  },

  // ── Zoo / Allevamento (MilkQualityCard) ──────────────────────────────────────
  milkQualityCard: {
    title: "Qualità Latte",
    expand: "Espandi",
    minimize: "Minimizza",
    noData: "Nessuna analisi latte disponibile.",
    monthlyTrend: "{varLabel} — andamento mensile",
    selectVariableHint: "Seleziona una variabile per vedere il grafico",
    varBacterialLoad: "Carica Batterica",
    varSomaticCells: "Cellule Somatiche",
    varFat: "Grassi %",
    varProtein: "Proteine %",
    varUrea: "Urea mg/dl",
    varAvgProd: "Prod. media kg/d",
    varAdultSheep: "Pecore adulte",
    dataNotAvailable: "Dato non disponibile",
    valuesOutOfRange: "Valori fuori soglia",
    valuesOptimal: "Valori ottimali",
    valuesIntermediate: "Valori intermedi",
    tileHealth: "Salute",
    qualityHigh: "Alta qualità",
    qualityMedium: "Media qualità",
    qualityLow: "Bassa qualità",
    tileMilkQuality: "Qualità latte",
    feedLowProtein: "Alimentazione poco proteica",
    feedHighProtein: "Alimentazione troppo proteica",
    feedBalanced: "Alimentazione bilanciata",
    tileNutrition: "Nutrizione",
    tileProductivity: "Produttività",
    kgPerSheep: "{n} kg/d per pecora",
    monthAbbrevs: [
      "Gen",
      "Feb",
      "Mar",
      "Apr",
      "Mag",
      "Giu",
      "Lug",
      "Ago",
      "Set",
      "Ott",
      "Nov",
      "Dic",
    ],
    currentYear: "Anno corrente",
    lastYear: "Anno scorso",
    zoneAverage: "Media zona",
  },

  // ── Zoo / Allevamento (BluetoothScanner) ─────────────────────────────────────
  bluetoothScanner: {
    deviceConnected: "Dispositivo connesso",
    disconnect: "Disconnetti",
    lastCodeRead: "Ultimo codice letto",
    messagesReceived: "Messaggi ricevuti",
    simulated: "simulato",
    listeningChannel: "Canale ascolto",
    none: "nessuno",
    service: "Servizio",
    listening: "In ascolto",
    testMode: "Modalità Test",
    simulateDesc: "Simula la lettura di un bolo senza lettore fisico",
    simulateBolusReading: "Simula Lettura Bolo",
    stressTest: "Stress test (50 letture ravvicinate)",
    stressTestRunning: "Stress test in corso...",
    spoofRandomCode:
      "Test: sostituisci codice letto con uno reale casuale (utile con un solo bolo)",
    spoofActiveWarning: "Attenzione, sei in modalità di test: i codici letti vengono sostituiti con codici casuali",
    scanningInProgress: "Scansione in corso...",
    startBluetoothScan: "Avvia scansione Bluetooth",
    searchingDevices: "Ricerca dispositivi in corso...",
    devicesFound: "Dispositivi rilevati ({n})",
    hideAnonymous: "Nascondi anonimi",
    seeAllAnonymous: "Vedi tutti (+ {n} anonimi)",
    noDeviceFound:
      'Nessun dispositivo trovato. Premi "Avvia scansione" per cercare.',
    webOnlyMsg:
      'La scansione Bluetooth è disponibile solo sull\'app mobile. Usa "Simula Lettura Bolo" per testare il flusso.',
    errorInit: "Errore inizializzazione Bluetooth. Verifica che sia attivo.",
    errorNoDeviceRetry: "Nessun dispositivo trovato. Riprova.",
    errorScan:
      "Errore durante la scansione. Verifica che il Bluetooth sia attivo.",
    connecting: "Connessione in corso...",
    deviceConnectedExclaim: "Dispositivo connesso!",
    errorConnect: "Errore durante la connessione al dispositivo.",
    channelUpdated: "Canale aggiornato",
    errorChannelChange: "Errore durante il cambio canale.",
    deviceDisconnected: "Dispositivo disconnesso",
    simulatedCode: "Codice simulato: {code}",
    errorSimulation: "Errore durante la simulazione.",
  },
  bluetoothPage: {
    title: "Lettore Bluetooth",
    infoText:
      "Utilizza questa funzionalità per leggere i boli degli animali tramite lettori Bluetooth (RS420, Petscan etc...). Il codice letto viene automaticamente associato all'animale corrispondente.",
    quickAction: "Azione rapida",
    quickActionDesc:
      "Alla lettura del bolo vai direttamente a registrare questo evento",
    firstAvailableForm: "— Prima scheda disponibile —",
    recentReadings: "Letture recenti",
    synced: "Sincronizzato",
    toSync: "Da sincronizzare",
  },
  herdStats: {
    manageGroups: "Gestisci gruppi",
    total: "TOTALE",
    totalHeads: "Capi Totali",
    groups: "Gruppi",
    maleAbbrev: "M",
    femaleAbbrev: "F",
    youngAbbrev: "Giov",
    newGroup: "Nuovo gruppo",
    groupDynamics: "Dinamica gruppi",
    females: "Femmine",
    males: "Maschi",
    young: "Giovani",
    adultFemales: "Femmine adulte",
    adultMales: "Maschi adulti",
    noAge: "Senza età",
    headsUnit: "capi",
  },
  useBluetooth: {
    noHerdConfigured:
      "Nessun gregge configurato. Configura un gregge prima di aggiungere animali via Bluetooth.",
    chipReader: "Lettore Chip",
    cellIride: "Cell Iride",
  },
  useZooUtils: {
    yearsCount: "{n} anno | {n} anni",
    monthsCount: "{n} mese | {n} mesi",
    lessThanOneMonth: "meno di 1 mese",
    codeRequired: "Codice obbligatorio",
    codeTooShort: "Codice troppo corto (minimo 3 caratteri)",
    typeIn: {
      N: "Nato in stalla",
      M: "Acquistato da allevamento italiano",
      R: "Prima iscrizione",
      C: "Acquistato da paesi UE con cedola",
      E: "Acquistato da paesi UE",
      F: "Acquistato da fiera o mercato",
      G: "Acquistato da centro genetico",
      I: "Acquistato da stabulario",
      K: "Acquistato da centro di raccolta",
      L: "Acquistato da stalla di sosta",
      P: "Rientro da pascolo",
      Q: "Trasferito senza acquisto",
      S: "Rientro da paese estero",
      T: "Acquistato da paesi terzi",
      V: "Rientro fiera mancata vendita",
      W: "Nato in stalla (parto gemellare)",
    },
    typeOut: {
      D: "Morto/Abbattuto/Macellato in azienda",
      M: "Uscito verso macello",
      A: "Venduto per autoconsumo",
      C: "Cancellazione amministrativa",
      E: "Venduto a un paese estero",
      F: "Oggetto di furto/smarrimento",
      G: "Uscito verso centro genetico",
      H: "Oggetto di furto",
      I: "Uscito verso stabulario",
      J: "Uscita da pascolo a pascolo",
      K: "Uscito verso centro di raccolta",
      L: "Identificati singolarmente",
      N: "Non specificato",
      P: "Uscito verso pascolo",
      Q: "Macellato per autoconsumo",
      R: "Uscito verso circo",
      S: "Uscito verso stalla di sosta",
      T: "Trasferito senza vendita",
      U: "Uscito verso una fiera",
      V: "Venduto ad allev. italiano",
      W: "Oggetto di smarrimento",
    },
  },

  // ── Zoo / Allevamento (Animal & Group views) ─────────────────────────────────
  animalUpsert: {
    titleEdit: "Modifica animale",
    saving: "Salvataggio...",
    sectionIdentification: "Identificazione",
    sectionEntry: "Ingresso",
    sectionBiological: "Dati biologici",
    sectionGenetics: "Genetica",
    sectionNotes: "Note",
    removeName: "Rimuovi nome",
    assignName: "Assegna nome",
    codePlaceholder: "es. IT001234567890",
    namePlaceholder: "Nome animale (opzionale)",
    codeBdnPlaceholder: "Codice BDN",
    farmOriginPlaceholder: "Azienda di provenienza",
    notePlaceholder: "Note aggiuntive...",
    generate: "Genera",
    farmOrigin: "Azienda di provenienza",
    scrapieLabel: "Genotipo Scrapie",
    scrapieNone: "— Nessuno —",
    dangerDeleteLink: "Elimina definitivamente questo animale",
    sexRequired: "Il sesso è obbligatorio",
    confirmHardDelete:
      "Sei sicuro di voler eliminare definitivamente questo animale? L'operazione non è reversibile.",
    breedUnknown: "— Sconosciuta —",
    groupNone: "— Nessun gruppo —",
  },
  animalRemove: {
    title: "Registra uscita",
    warningExit:
      "Stai per registrare l'uscita di questo animale dall'allevamento.",
    inGroupPrefix: "Questo animale fa parte del gruppo",
    removeFromGroup: "Rimuovi anche dal gruppo",
    reasonLabel: "Motivo uscita",
    confirmExit: "Conferma uscita",
  },
  addAnimalsView: {
    title: "Aggiungi animali",
    uploadCardTitle: "Carica elenco animali",
    helpText:
      "Incolla o carica un file con l'elenco degli animali da importare.",
    tabPaste: "Incolla testo",
    tabFile: "Carica file",
    pastePlaceholder: "Incolla qui i dati degli animali...",
    dropHint: "Trascina qui un file oppure clicca per selezionarlo",
    parsing: "Analisi in corso...",
    parseBtn: "Analizza",
    statNew: "Nuovi",
    statUpdates: "Aggiornamenti",
    statMissing: "Mancanti",
    fileAnimalsTitle: "Animali nel file ({count})",
    colSpecie: "Specie",
    colStatus: "Stato",
    missingTitle: "Animali mancanti ({count})",
    missingWarning:
      "Questi animali sono presenti in allevamento ma non nel file caricato.",
    bulkActionLabel: "Azione per tutti",
    keepOption: "Mantieni",
    exitOption: "Segna uscita",
    applyBulk: "Applica",
    colAction: "Azione",
    colReason: "Motivo",
    keepShort: "Mantieni",
    importBtn: "Importa {count} animali",
    doneTitle: "Importazione completata",
    importingTitle: "Importazione in corso...",
    doneSummary: "{count} animali importati con successo.",
    errorsSummary: "{count} errori durante l'importazione.",
    backToHerd: "Torna all'allevamento",
    herdFallback: "Gregge",
    breadcrumbTitle: "Aggiungi animali",
    rowUpdate: "Aggiornamento",
    parseError: "Errore durante l'analisi dei dati.",
  },
  groupUpsert: {
    randomColor: "Casuale",
    nameRequired: "Il nome del gruppo è obbligatorio.",
  },
  groupAddAnimals: {
    searchPlaceholder: "Cerca per codice o nome...",
    countLabel: "{selected} selezionati · {available} disponibili",
    addButton: "Aggiungi {count} animali",
  },
  groupDynamicsView: {
    title: "Dinamica gruppi",
    noData: "Nessun dato disponibile per il periodo selezionato.",
    colDate: "Data",
    period3m: "3 mesi",
    period6m: "6 mesi",
    period12m: "12 mesi",
    periodAll: "Tutto",
    tabChart: "Grafico",
    tabTable: "Tabella",
    yAxisTitle: "N° animali",
  },
  groupList: {
    dynamics: "Dinamica",
    detail: "Dettaglio",
    description: "Descrizione",
    headCount: "capi",
    confirmDelete: 'Eliminare il gruppo "{name}"?',
  },
  groupEventUpsert: {
    titleEdit: "Modifica evento gruppo",
    titleNew: "Nuovo evento gruppo",
    headerEdit: "Modifica evento",
    headerNew: "Nuovo evento",
  },
  animalDetail: {
    notFound: "Animale non trovato.",
    exitedBanner: "Animale uscito",
    panelHistory: "Storico",
    entryLabel: "Ingresso",
    registryDataHeader: "Dati anagrafici",
    currentGroupHeader: "Gruppo corrente",
    move: "Sposta",
    exit: "Esci",
    assignToGroup: "Assegna a gruppo",
    since: "dal",
    noEventsOrMovements: "Nessun evento o movimento registrato.",
    moveModalTitle: "Sposta in un altro gruppo",
    exitModalTitle: "Esci dal gruppo",
    removeFromGroupPrefix: "Rimuovere",
    removeFromGroupMiddle: "dal gruppo",
    loadingGroups: "Caricamento gruppi...",
    noGroupsAvailable: "Nessun gruppo disponibile.",
    confirmExit: "Conferma uscita",
    deleteMembershipTitle: "Cancella dato appartenenza",
    deleteMembershipWarning:
      "Questa operazione elimina definitivamente il dato di appartenenza al gruppo.",
    deleteMembershipConfirmPrefix:
      "Eliminare il dato di appartenenza al gruppo",
    deleteDataButton: "Cancella dato",
    eventDetailTitle: "Dettaglio evento",
    close: "Chiudi",
    groupEventSubtitle: "Evento di gruppo",
    groupEntryTitle: 'Ingresso nel gruppo "{group}"',
    groupExitTitle: 'Uscita dal gruppo "{group}"',
    confirmRestore: "Ripristinare {code}?",
    confirmDeleteEvent: "Eliminare questo evento?",
  },
  groupDetail: {
    eventsTab: "Eventi",
    exitSelected: "Esci selezionati ({count})",
    exitedSingleWarning:
      "L'animale {code} è uscito dall'allevamento ({typeOut}) — rimuoverlo dal gruppo.",
    exitedMultiWarning:
      "{count} animali sono usciti dall'allevamento — rimuoverli dal gruppo.",
    exitGroupAt: "Esci dal gruppo al",
    hidePast: "Nascondi",
    pastMembers: "Membri precedenti",
    noPastMembers: "Nessun membro precedente.",
    notFound: "Gruppo non trovato.",
    exitModalTitle: "Uscita dal gruppo",
    inGroupSince: "nel gruppo dal",
    selectedAnimals: "{count} animali selezionati",
    exitDateLabel: "Data uscita",
    destinationLabel: "Destinazione",
    saving: "Salvataggio...",
    confirmExitBtn: "Conferma uscita",
    colInGroupSince: "Nel gruppo dal",
    colHerdExit: "Uscita allevamento",
    noGroupOption: "— Nessun gruppo —",
    confirmForceExit:
      "Rimuovere {name} dal gruppo alla data di uscita dall'allevamento ({date})?",
    dateRequired: "La data è obbligatoria.",
    dateBeforeEntry:
      "La data di uscita non può essere prima della data di ingresso.",
  },
  zooStore: {
    cannotDeleteAnimalHasEvents:
      "Impossibile eliminare: l'animale ha eventi registrati. Eliminarli prima.",
    cannotDeleteAnimalHasMemberships:
      "Impossibile eliminare: l'animale ha appartenenze a gruppi. Rimuoverlo dai gruppi prima.",
    cannotDeleteGroupHasAnimals:
      "Impossibile eliminare un gruppo con animali. Rimuovere prima tutti gli animali.",
    animalsMoved: "{count} animali spostati",
    errorDuringMove: "Errore durante lo spostamento",
  },
  poderiLayout: {
    dbErrorTitle: "Errore Database",
    dbErrorSubtitle: "Si è verificato un problema con il database locale",
    dbErrorHeading: "Impossibile accedere al database",
    dbErrorRetry: "Riprova Inizializzazione",
  },
  poderiStore: {
    plotNotFoundOrNoGeometry: "Plot non trovato o senza geometria",
    onlyOwnerCanDelete: "Solo il proprietario può eliminare l'azienda",
  },
  dbStore: {
    cannotInitDb: "Impossibile inizializzare il DB: {message}",
    fetchDataUnauthorized:
      "Non è stato possibile prendere i dati. Codice errore 401: non autorizzato.",
    fetchDataFailed: "Non è stato possibile prendere i dati.",
    errorCode: "Codice errore: {status}.",
  },
  geoElementDetail: {
    loading: "Caricamento...",
    notFound: "Elemento geografico non trovato.",
    survey: "Rilievo",
    type: "Tipo",
    description: "Descrizione",
    surveysCount: "Rilievi ({count})",
    noSchemaConfigured:
      "Nessuna scheda di rilievo configurata per questo tipo di elemento.",
    noSurveysHint:
      'Nessun rilievo registrato. Usa "Aggiungi" per inserire il primo.',
    editSurveyTitle: "Modifica Rilievo",
    newSurveyTitle: "Nuovo Rilievo",
    saving: "Salvataggio...",
    surveyDateLabel: "Data rilievo",
    surveySchemaLabel: "Scheda di rilievo",
    selectSchemaPlaceholder: "Seleziona scheda",
    editGeoElementTitle: "Modifica elemento geografico",
    back: "Indietro",
    next: "Avanti",
    saveChanges: "Salva Modifiche",
    deleteGeoElementTitle: "Elimina elemento geografico",
    deleteGeoElementConfirm: "Eliminare l'elemento geografico",
    deletingGeoElement: "Eliminazione...",
    deleteSurveyTitle: "Elimina rilievo",
    deleteSurveyConfirm: "Eliminare il rilievo del",
    notAvailable: "N/D",
    typeFallback: "Tipo {id}",
    schemaFallback: "Schema {id}",
    defaultTitle: "Elemento geografico",
  },
  useModelFarmMapLayers: {
    farmCenter: "Centro Azienda",
    loading: "Caricamento...",
    calculationError: "Errore nel calcolo",
    field: "Appezzamento",
    loadingLower: "caricamento...",
    errorLower: "errore",
    noCultivableField: "Nessun appezzamento coltivabile",
    fields: "Appezzamenti",
    alert: "Allerta",
    customGeometry: "geometria personalizzata",
    lowRisk: "Basso rischio",
    attention: "Attenzione",
    critical: "Critico",
    notAvailable: "N/D",
  },
  useMapLayers: {
    cropsCategory: "Colture",
    noCrop: "Nessuna coltura",
    typeFallback: "Tipo {id}",
    geoElementsCategory: "Elementi Geografici",
    farmCenter: "Centro Azienda",
    fields: "Appezzamenti",
    area: "Superficie",
    type: "Tipo",
    crop: "Coltura",
    fieldsCount: "Campi",
    customGeometry: "geometria personalizzata",
    goToField: "Vai al campo",
    notAvailable: "N/D",
    geoElements: "Elementi Geografici",
    description: "Descrizione",
    goToDetail: "Vai al dettaglio",
  },
  plotMap: {
    pointsCount: "{count} punti",
    editActive: "Modifica Attiva",
    edit: "Modifica",
    undo: "Annulla",
    delete: "Elimina",
    clickToDrawPolygon:
      "Clicca sulla mappa per iniziare a disegnare il poligono",
    clickToDrawLine: "Clicca sulla mappa per iniziare a disegnare la linea",
    clickToPlacePoint: "Clicca sulla mappa per posizionare il punto",
    enableDrawingHint:
      "Inserisci le coordinate del centro azienda per abilitare il disegno",
    multiPolygonSingleWarning:
      "La geometria originale è un MultiPolygon con un solo poligono — visualizzato normalmente.",
    multiPolygonMultiWarning:
      "La geometria originale contiene più poligoni separati. Nell'editor viene mostrato solo quello più grande.",
    multiPolygonDataLossWarning: "Salvando, gli altri poligoni andranno persi.",
    polygonStartTitle: "Click sulla mappa per disegnare il poligono",
    polygonStartHint: "Aggiungi almeno 3 punti.",
    editModeLabel: "Modalità modifica:",
    polygonEditHint:
      'Trascina i vertici per spostarli, click per eliminare (min 3), trascina i punti "+" per inserire nuovi vertici.',
    polygonDoneTitle: "Poligono completato!",
    polygonDoneHint:
      'Usa "Modifica" per cambiarlo o "Elimina" per ricominciare.',
    lineStartTitle: "Click sulla mappa per disegnare la linea",
    lineStartHint: "Aggiungi almeno 2 punti.",
    lineEditHint:
      'Trascina i vertici per spostarli, click per eliminare (min 2), trascina i punti "+" per inserire nuovi vertici.',
    lineDoneTitle: "Linea completata!",
    lineDoneHint: 'Usa "Modifica" per cambiarla o "Elimina" per ricominciare.',
    pointStartTitle: "Click sulla mappa per posizionare il punto",
    pointDoneTitle: "Punto posizionato.",
    pointDoneHint:
      "Trascina il marker per spostarlo o clicca altrove per riposizionarlo.",
    centerMarkerTooltip: "Centro Azienda",
    fullscreen: "Fullscreen",
    exitFullscreen: "Esci dal fullscreen",
    confirmDeleteGeometry: "Eliminare la geometria?",
    otherPlotFallback: "Altro appezzamento",
  },
  usePlantMapLayers: {
    notAvailable: "N/D",
    nonExistingPositions: "Posizioni non esistenti",
    deadPlants: "Piante morte",
    plants: "Piante",
    selection: "Selezione",
    labels: "Etichette",
  },
  useVoiceInput: {
    micError: "Errore microfono: {error}",
    noAudioRecorded: "Nessun audio registrato per Whisper",
    transcriptionError: "Errore trascrizione Whisper",
    micUnavailable: "Microfono non disponibile o permesso negato",
  },
  plantSurveyEditorView: {
    loading: "Caricamento...",
    noPlants: "Nessuna pianta disponibile per questo appezzamento",
    pageTitle: "Rilievi Piante",
    home: "Home",
    farms: "Aziende",
    surveysBreadcrumb: "Rilievi",
  },
  plantSurveyViewerView: {
    pageTitle: "Elaborazione Rilievi",
    backToPlants: "Torna a Piante",
    loadingData: "Caricamento dati...",
    noSurveysAvailable: "Nessun rilievo disponibile per questo appezzamento.",
    schema: "Scheda",
    selectSchema: "Seleziona scheda...",
    variable: "Variabile",
    selectVariable: "Seleziona variabile...",
    noNumericVariable: "Nessuna variabile numerica in questa scheda",
    campaign: "Campagna",
    allCampaigns: "Tutte le campagne",
    observationsCount: "{count} osservazioni",
    plantsSurveyedCount: "{count} piante rilevate",
    campaignSingular: "campagna",
    campaignPlural: "campagne",
    editData: "Modifica dati",
    tabMap: "Mappa",
    tabStats: "Statistiche",
    tabRawData: "Dati grezzi",
    sum: "Somma",
    values: "Valori",
    mapMode: "Modalità mappa",
    rowColHeader: "↓ Fila / Col →",
    cellTooltipNumeric: "Fila {row}, Col {col} — media: {mean} (n={count})",
    cellTooltipValue: "Fila {row}, Col {col} — {value}",
    noData: "Nessun dato",
    noPlant: "Nessuna pianta",
    spatialMapCaption: "Mappa spaziale — {schema} · {variable}",
    noMapData: "Nessun dato disponibile per la mappa",
    totalN: "N totale",
    mean: "Media",
    stdDev: "Dev. Std",
    median: "Mediana",
    outliers: "Outliers",
    date: "Data",
    total: "Totale",
    editThisDate: "Modifica questa data",
    outlierValues: "Valori outlier:",
    perVariety: "Per varietà",
    variety: "Varietà",
    noNumericData: "Nessun dato numerico disponibile",
    rowsCount: "{count} righe",
    downloadCSV: "Scarica CSV",
    home: "Home",
    farms: "Aziende",
    dateSingular: "data",
    datePlural: "date",
    schemaFallback: "Scheda {id}",
    schemaOptionLabel: "{name} — {count} rilievi",
    row: "Fila",
    column: "Colonna",
    plantTag: "Cartellino pianta",
    accession: "Accessione",
  },
};
